const mentions = {
  E0002: {
    id: "E0002",
    label: "mad heretic Leutard",
    detail_case_summary:
      'In the "Historiarum Libri Quinque", Rodulfus Glaber describes the case of Leutard, a villager from Vertus who became a heretic after being possessed by a swarm of bees. Lautard gained many followers but the spread of his heresy was stopped by the Bishop of Châlons, Gebuin. In the end, Leutard committed suicide.',
    label_and_source_concatenated:
      "mad heretic Leutard (Rodulfus Glabrus, Historiarum Libri Quinque)",
    case_id: "E1001",
    case_label: "mad heretic Leutard",
    text_id: "T82",
    text_label: "Historiarum Libri Quinque",
    year_start_post_quem: "~1000",
    year_start_ante_quem: "~1000",
    year_end_post_quem: "~1000",
    year_end_ante_quem: "~1000",
    year_approximate: "y",
    location_id: "L0008 #L0009 #L0115",
    location_label: "vicus Virtutis #Galia #diocesis Catalaunensis",
    location_primary_id: "L0008",
    location_primary_label: "Vertus",
    geometry: "point",
    name_of_heresy_id: "C0001",
    name_of_heresy_label: "heresis",
    name_of_heretics_id: null,
    name_of_heretics_label: "#VALUE!",
    connotations_heresy_id: "C1611 #C1049 #C1290 #C1325 #C1726 #C3216 #C1050",
    connotations_heresy_label:
      "Satane legatus #vesanie pervicatia #insanus/a/um #venenum nequitie #turpis/e #damnabilis/e #insania",
    heretic_id: "P0002 #G0020 #G0021",
    heretic_label:
      "Leutardus #rustici [sectatores Leutardi] #vulgus [sectatores Leutardi]",
    heretics_amount_id: "[C1069]",
    heretics_amount_label: "plures/a",
    heretics_social_characterization_id: "[C1071] #C1354",
    heretics_social_characterization_label: "plebs #vulgus",
    instigator_to_heresy_id: "G0019",
    instigator_to_heresy_label: "examen apium",
    repressor_id: "P0003",
    repressor_label: "Gebuinus senex episcopus Catalauni",
    person_or_groups_other_id: "P0007",
    person_or_groups_other_label: "uxor Leutardi",
    dealing_with_them_id: "C1265",
    dealing_with_them_label: "hearing",
    outcome_id: "C1051 #C1052",
    outcome_label: "reconversion to Catholicism #suicide",
    "Unnamed: 40": null,
    execution_location_type_id: null,
    beliefs_id: null,
    beliefs_label: "#VALUE!",
    practice_id: "[C1053] #[C1054] #[C1310] #[C1618] #[C1056] #[C2326]",
    practice_label:
      "celibacy #disrespect for cross #disrespect for effigies of Christ #rejection of tithing #partial rejection of the Old Testament #proselytization",
    note: 'A similar case of possession by a swarm of insects was described by Gregory of Tours in the "Decem Libri Historiarum" (Book X, 25). Gregory writes about a man who was possessed while cutting wood in the forest. After being attacked by a swarm of flies, he went mad and demanded to be called Christ. For more information on the content of this source, see the notes on the case of Tanchelm ("Epistola ecclesie Traiectensis ad Fridericum archiepiscopum Coloniensem").',
  },
  E0003: {
    id: "E0003",
    label: "learned heretic Vilgard",
    detail_case_summary:
      'In the "Historiarum Libri Quinque", Rodulfus Glaber describes the case of Vilgard, a man from Ravenna. Vilgard, passionate about grammar studies, was visited one day by demons in the form of Latin poets. He soon became a heretic but was discovered and condemned by the Bishop of Ravenna, Peter. The heretic and his alleged followers were killed. Rodulfus connects the case of Vilgard of Ravenna with the appearance of some unspecified heretics in Spain and Sardinia.',
    label_and_source_concatenated:
      "learned heretic Vilgard (Rodulfus Glabrus, Historiarum Libri Quinque)",
    case_id: "E1002",
    case_label: "learned heretic Vilgard",
    text_id: "T82",
    text_label: "Historiarum Libri Quinque",
    year_start_post_quem: "~1000",
    year_start_ante_quem: "~1000",
    year_end_post_quem: "~1000",
    year_end_ante_quem: "~1000",
    year_approximate: "y",
    location_id: "L0010 #L0011",
    location_label: "Ravenna #Italia",
    location_primary_id: "L0010",
    location_primary_label: "Ravenna",
    geometry: "point",
    name_of_heresy_id: "C0001",
    name_of_heresy_label: "heresis",
    name_of_heretics_id: null,
    name_of_heretics_label: "#VALUE!",
    connotations_heresy_id: "C0448 #C2295 #C2159 #C3217 #C1172",
    connotations_heresy_label:
      "malum #inflatus superbia #stultus/a/um #demonum fallaciis depravatus #dogma pestiferum",
    heretic_id: "P0004 #G0104",
    heretic_label: "Vilgardus #[alii heretici in Italia reperti]",
    heretics_amount_id: "C1069",
    heretics_amount_label: "plures/a",
    heretics_social_characterization_id: null,
    heretics_social_characterization_label: "#VALUE!",
    instigator_to_heresy_id: "G0006",
    instigator_to_heresy_label:
      "demones [species Virgilii, Oratii et Iuvenalis]",
    repressor_id: "P0005",
    repressor_label: "Petrus pontifex Ravenne",
    person_or_groups_other_id: null,
    person_or_groups_other_label: "#VALUE!",
    dealing_with_them_id: null,
    dealing_with_them_label: "#VALUE!",
    outcome_id: "C1106 #C1147 #C1148",
    outcome_label: "excommunication #death by fire #death by sword",
    "Unnamed: 40": null,
    execution_location_type_id: null,
    beliefs_id: "[C0052]",
    beliefs_label: "errores",
    practice_id: "[C1074]",
    practice_label: "grammar studies",
    note: "The source mentions that the heretics and their followers were killed by sword and/or fire.\n#Glaber links the appearance of heresy with the millenarian apocalyptical prophecy of Satan's release after 1000 years.",
  },
  E0018: {
    id: "E0018",
    label: "heretics in Sardinia",
    detail_case_summary:
      'In the "Historiarum Libri Quinque", Rodulfus Glaber mentions some unspecified heretics found in Sardinia around the year 1000. Rodulfus connects their case with the case of Vilgard of Ravenna and heretics in Spain.',
    label_and_source_concatenated:
      "heretics in Sardinia (Rodulfus Glabrus, Historiarum Libri Quinque)",
    case_id: "E1003",
    case_label: "heretics in Sardinia",
    text_id: "T82",
    text_label: "Historiarum Libri Quinque",
    year_start_post_quem: "~1000",
    year_start_ante_quem: "~1000",
    year_end_post_quem: "~1000",
    year_end_ante_quem: "~1000",
    year_approximate: "y",
    location_id: "L0029",
    location_label: "Sardinia",
    location_primary_id: "[L0103]",
    location_primary_label: "Cagliari",
    geometry: "point with halo",
    name_of_heresy_id: null,
    name_of_heresy_label: "#VALUE!",
    name_of_heretics_id: null,
    name_of_heretics_label: "#VALUE!",
    connotations_heresy_id: null,
    connotations_heresy_label: "#VALUE!",
    heretic_id: "G0107",
    heretic_label: "[heretici in Sardinia]",
    heretics_amount_id: "C1174",
    heretics_amount_label: "aliqui/e/a",
    heretics_social_characterization_id: "C1067",
    heretics_social_characterization_label: "not stated by the source",
    instigator_to_heresy_id: "C1067",
    instigator_to_heresy_label: "not stated by the source",
    repressor_id: "C1067",
    repressor_label: "not stated by the source",
    person_or_groups_other_id: null,
    person_or_groups_other_label: "#VALUE!",
    dealing_with_them_id: null,
    dealing_with_them_label: "#VALUE!",
    outcome_id: "C1058",
    outcome_label: "extermination of heretics",
    "Unnamed: 40": null,
    execution_location_type_id: null,
    beliefs_id: "C1067",
    beliefs_label: "not stated by the source",
    practice_id: "[C2326]",
    practice_label: "proselytization",
    note: "Glaber links the appearance of heresy with the millenarian apocalyptical prophecy of Satan's release after 1000 years.",
  },
  E0081: {
    id: "E0081",
    label: "heretics in Spain",
    detail_case_summary:
      'In the "Historiarum Libri Quinque", Rodulfus Glaber mentions some unspecified heretics found in Spain around the year 1000. Rodulfus connects their case with the case of Vilgard of Ravenna and heretics in Sardinia.',
    label_and_source_concatenated:
      "heretics in Spain (Rodulfus Glabrus, Historiarum Libri Quinque)",
    case_id: "E1004",
    case_label: "heretics in Spain",
    text_id: "T82",
    text_label: "Historiarum Libri Quinque",
    year_start_post_quem: "~1000",
    year_start_ante_quem: "~1000",
    year_end_post_quem: "~1000",
    year_end_ante_quem: "~1000",
    year_approximate: "y",
    location_id: "L0030",
    location_label: "Hispania",
    location_primary_id: "[L0104]",
    location_primary_label: "Pamplona",
    geometry: "point with halo",
    name_of_heresy_id: null,
    name_of_heresy_label: "#VALUE!",
    name_of_heretics_id: null,
    name_of_heretics_label: "#VALUE!",
    connotations_heresy_id: null,
    connotations_heresy_label: "#VALUE!",
    heretic_id: "G0108",
    heretic_label: "[heretici in Hispania]",
    heretics_amount_id: "C1174",
    heretics_amount_label: "aliqui/e/a",
    heretics_social_characterization_id: "C1067",
    heretics_social_characterization_label: "not stated by the source",
    instigator_to_heresy_id: "G0110",
    instigator_to_heresy_label: "[heretici ex Sardinia]",
    repressor_id: "C1067",
    repressor_label: "not stated by the source",
    person_or_groups_other_id: null,
    person_or_groups_other_label: "#VALUE!",
    dealing_with_them_id: null,
    dealing_with_them_label: "#VALUE!",
    outcome_id: "C1058",
    outcome_label: "extermination of heretics",
    "Unnamed: 40": null,
    execution_location_type_id: null,
    beliefs_id: "C1067",
    beliefs_label: "not stated by the source",
    practice_id: "C1067",
    practice_label: "not stated by the source",
    note: "Glaber links the appearance of heresy with the millenarian apocalyptical prophecy of Satan's release after 1000 years.",
  },
  E0036: {
    id: "E0036",
    label: "antibaptists in southern France",
    detail_case_summary:
      'In a passage of the "Liber Miraculorum Sancte Fides" describing a villager denying the sanctity of a Saint Fides church, Bernard of Angers compares him to heretics who reject the sacrament of baptism.',
    label_and_source_concatenated:
      "antibaptists in southern France (Bernardus Andecavensis, Liber Miraculorum Sancte Fidis)",
    case_id: "E1017",
    case_label: "antibaptists in southern France",
    text_id: "T105",
    text_label: "Liber Miraculorum Sancte Fidis",
    year_start_post_quem: "1013",
    year_start_ante_quem: "1020",
    year_end_post_quem: "1013",
    year_end_ante_quem: "1020",
    year_approximate: "y",
    location_id: "[L0048] #[L0025]",
    location_label: "Conchae #Occidens Europe",
    location_primary_id: "[L0048]",
    location_primary_label: "Conques",
    geometry: "point with halo",
    name_of_heresy_id: "C0001 #C0122",
    name_of_heresy_label: "heresis #error",
    name_of_heretics_id: null,
    name_of_heretics_label: "#VALUE!",
    connotations_heresy_id: "C1366",
    connotations_heresy_label: "profanus error",
    heretic_id: "P0047 #G0049",
    heretic_label:
      "improbus rusticus [qui contra cultum Sancte Fidis locutus est] #heretici [qui sacramanetum baptismi negant]",
    heretics_amount_id: null,
    heretics_amount_label: "#VALUE!",
    heretics_social_characterization_id: "C1169",
    heretics_social_characterization_label: "rustici",
    instigator_to_heresy_id: null,
    instigator_to_heresy_label: "#VALUE!",
    repressor_id: null,
    repressor_label: "#VALUE!",
    person_or_groups_other_id: null,
    person_or_groups_other_label: "#VALUE!",
    dealing_with_them_id: "C1367",
    dealing_with_them_label: "divine punishment",
    outcome_id: "C1051",
    outcome_label: "reconversion to Catholicism",
    "Unnamed: 40": null,
    execution_location_type_id: null,
    beliefs_id: "[C1061]",
    beliefs_label: "rejection of baptism as sacrament",
    practice_id: "[C1359]",
    practice_label: "rejection of cult",
    note: '"Divine punishment" and "reconversion to Catholicism" only refer to the peasant who rejected the cult of Saint Fides. The fate of heretics who rejected the sacrament of baptism is unknown.',
  },
  E0033: {
    id: "E0033",
    label: "arians in Poitou",
    detail_case_summary:
      'A document by William, Duke of Aquitaine, reports on "Arians" who appeared in Poitou around 1016.',
    label_and_source_concatenated:
      "arians in Poitou (Guillelmus dux Aquitanie, carta Guillelmi ducis Aquitanie)",
    case_id: "E1014",
    case_label: "arians in Poitou",
    text_id: "T103",
    text_label: "carta Guillelmi ducis Aquitanie",
    year_start_post_quem: "1016",
    year_start_ante_quem: "1016",
    year_end_post_quem: "1016",
    year_end_ante_quem: "1016",
    year_approximate: "n",
    location_id: "[L0044]",
    location_label: "Pictavis",
    location_primary_id: "L0044H",
    location_primary_label: "Poitiers",
    geometry: "point with halo",
    name_of_heresy_id: "C1047",
    name_of_heresy_label: "arriana heresis",
    name_of_heretics_id: null,
    name_of_heretics_label: "#VALUE!",
    connotations_heresy_id: "C3546 #C3547 #C1312",
    connotations_heresy_label:
      "multa mala opera #inaudita opera #rabies tyrannorum",
    heretic_id: "G0048 #G0135",
    heretic_label:
      "populus [arriani Pictavenses] #ministri ecclesie [arriani Pictavenses]",
    heretics_amount_id: "[C1069]",
    heretics_amount_label: "plures/a",
    heretics_social_characterization_id: "[C1075] #[C0455]",
    heretics_social_characterization_label: "laici #clerici",
    instigator_to_heresy_id: "C1067",
    instigator_to_heresy_label: "not stated by the source",
    repressor_id: "P0046",
    repressor_label: "Willelmus dux Aquitanensium",
    person_or_groups_other_id: null,
    person_or_groups_other_label: "#VALUE!",
    dealing_with_them_id: "C1067",
    dealing_with_them_label: "not stated by the source",
    outcome_id: "C1067",
    outcome_label: "not stated by the source",
    "Unnamed: 40": null,
    execution_location_type_id: null,
    beliefs_id: "C1067",
    beliefs_label: "not stated by the source",
    practice_id: "C1067",
    practice_label: "not stated by the source",
    note: 'The author of the charter makes an association between "arriana heresis" and "rabies", a connotation used by St. Jerome in one of his letters (Saint Jérôme, "Lettres", éd. et trad. Grégoire, Collombet, Lyon, 1837, t. I, n° XVI, p. 110) and also by Isidore of Seville in "Etymologiae" (VI.XVI.6).\n#Another example of Duke William\'s attempt to combat heretics is mentioned in Adhemar\'s Chronicon, where he describes a synod at Charroux from 1028 (name of the case: "Manicheans at Charroux").',
  },
  E0004: {
    id: "E0004",
    label: "manicheans in Aquitaine",
    detail_case_summary:
      'In the "Chronicon Aquitanicum et Francicum", around the year 1018, Adhemar of Chabannes describes some heretics named "Manicheans" discovered in Aquitania. They were characterized by an apparent ascetic lifestyle and a rejection of the sacrament of baptism and the cult of the cross.',
    label_and_source_concatenated:
      "manicheans in Aquitaine (Ademarus Cabannensis, Chronicon Aquitanicum et Francicum)",
    case_id: "E1005",
    case_label: "manicheans in Aquitaine",
    text_id: "T83",
    text_label: "Chronicon Aquitanicum et Francicum",
    year_start_post_quem: "1018",
    year_start_ante_quem: "1018",
    year_end_post_quem: "1018",
    year_end_ante_quem: "1018",
    year_approximate: "n",
    location_id: "L0007",
    location_label: "Aquitania",
    location_primary_id: "[L0080H]",
    location_primary_label: "Bordeaux",
    geometry: "point with halo",
    name_of_heresy_id: null,
    name_of_heresy_label: "#VALUE!",
    name_of_heretics_id: "C1059",
    name_of_heretics_label: "manichei",
    connotations_heresy_id: "C1060",
    connotations_heresy_label: "nuncii Antichristi",
    heretic_id: "G0016",
    heretic_label: "manichei [in Aquitania]",
    heretics_amount_id: "C0671",
    heretics_amount_label: "multi/e/a",
    heretics_social_characterization_id: "C1071",
    heretics_social_characterization_label: "plebs",
    instigator_to_heresy_id: "C1067",
    instigator_to_heresy_label: "not stated by the source",
    repressor_id: "C1067",
    repressor_label: "not stated by the source",
    person_or_groups_other_id: null,
    person_or_groups_other_label: "#VALUE!",
    dealing_with_them_id: "C1067",
    dealing_with_them_label: "not stated by the source",
    outcome_id: "C1067",
    outcome_label: "not stated by the source",
    "Unnamed: 40": null,
    execution_location_type_id: null,
    beliefs_id: "[C1061] #[C0052]",
    beliefs_label: "rejection of baptism as sacrament #errores",
    practice_id: "[C1054] #[C1062] #[C1073] #[C1176] #C1177 #[C2326]",
    practice_label:
      "disrespect for cross #fasting #monastic alimentary restrictions #feigned celibacy #luxuria #proselytization",
    note: null,
  },
  E0017: {
    id: "E0017",
    label: "manicheans in Toulouse",
    detail_case_summary:
      'In the "Chronicon Aquitanicum et Francicum", around the year 1022, Adhemar of Chabannes describes in brief some heretics named "Manicheans" discovered and exterminated near Toulouse. The description of Manicheans is embedded in Adhemar\'s description of the heretics in Orléans found and executed also in the year 1022.',
    label_and_source_concatenated:
      "manicheans in Toulouse (Ademarus Cabannensis, Chronicon Aquitanicum et Francicum)",
    case_id: "E1006",
    case_label: "manicheans in Toulouse",
    text_id: "T83",
    text_label: "Chronicon Aquitanicum et Francicum",
    year_start_post_quem: "~1022",
    year_start_ante_quem: "~1022",
    year_end_post_quem: "~1022",
    year_end_ante_quem: "~1022",
    year_approximate: "y",
    location_id: "L0023 #L0025",
    location_label: "Tolosa #Occidens Europe",
    location_primary_id: "L0023H",
    location_primary_label: "Toulouse",
    geometry: "point with halo",
    name_of_heresy_id: null,
    name_of_heresy_label: "#VALUE!",
    name_of_heretics_id: "C1059",
    name_of_heretics_label: "manichei",
    connotations_heresy_id: "C1060",
    connotations_heresy_label: "nuncii Antichristi",
    heretic_id: "G0018 #G0109",
    heretic_label:
      "manichei [apud Tolosam] #manichei [in diversis Occidentis partibus]",
    heretics_amount_id: "[C0671]",
    heretics_amount_label: "multi/e/a",
    heretics_social_characterization_id: "C1067",
    heretics_social_characterization_label: "not stated by the source",
    instigator_to_heresy_id: "C1067",
    instigator_to_heresy_label: "not stated by the source",
    repressor_id: null,
    repressor_label: "#VALUE!",
    person_or_groups_other_id: null,
    person_or_groups_other_label: "#VALUE!",
    dealing_with_them_id: "C1067",
    dealing_with_them_label: "not stated by the source",
    outcome_id: "C1058",
    outcome_label: "extermination of heretics",
    "Unnamed: 40": null,
    execution_location_type_id: null,
    beliefs_id: null,
    beliefs_label: "#VALUE!",
    practice_id: "C1150 #[C2326]",
    practice_label: "in occulto #proselytization",
    note: null,
  },
  E0006: {
    id: "E0006",
    label: "learned heresy in Orléans",
    detail_case_summary:
      'In the "Chronicon Aquitanicum et Francicum", under the year 1022, Adhemar of Chabannes describes heretical canons discovered and executed in Orléans by the order of King Robert the Pious. Adhemar describes heretics as devil worshippers but gives no precise information on their doctrine. In the same chapter dealing with the heretics of Orléans, Adhemar describes the heresy discovered at the same time in Toulouse.',
    label_and_source_concatenated:
      "learned heresy in Orléans (Ademarus Cabannensis, Chronicon Aquitanicum et Francicum)",
    case_id: "E1007",
    case_label: "learned heresy at Orléans",
    text_id: "T83",
    text_label: "Chronicon Aquitanicum et Francicum",
    year_start_post_quem: "1022",
    year_start_ante_quem: "1022",
    year_end_post_quem: "1022",
    year_end_ante_quem: "1022",
    year_approximate: "n",
    location_id: "L0013 #L0017",
    location_label: "Aurelianum #ecclesia cathedralis Sancte Crucis Aurelianis",
    location_primary_id: "L0013",
    location_primary_label: "Orléans",
    geometry: "point",
    name_of_heresy_id: null,
    name_of_heresy_label: "#VALUE!",
    name_of_heretics_id: "C1059",
    name_of_heretics_label: "manichei",
    connotations_heresy_id: null,
    connotations_heresy_label: "#VALUE!",
    heretic_id: "G0017 #P0024 #P0009",
    heretic_label: "canonici Sancte Crucis Aurelianis #Theodatus #Lisoius",
    heretics_amount_id: "~V~10+1",
    heretics_amount_label: "~V~10+1",
    heretics_social_characterization_id: "C1117",
    heretics_social_characterization_label: "canonici cathedrales",
    instigator_to_heresy_id: "P0025",
    instigator_to_heresy_label: "quidam rusticus Petragoricensis",
    repressor_id: "P0006 #P0026",
    repressor_label:
      "Rothbertus rex Francie #Odolricus episcopus Aurelianensis",
    person_or_groups_other_id: "P0027",
    person_or_groups_other_label:
      "diabolus [quem manichei Aurelianenses adorabant]",
    dealing_with_them_id: "C1067",
    dealing_with_them_label: "not stated by the source",
    outcome_id: "C1097 #C1106 #C1063 #C1228",
    outcome_label: "degradation #excommunication #burning #exhumation",
    "Unnamed: 40": null,
    execution_location_type_id: null,
    beliefs_id: "[C1361]",
    beliefs_label: "rejection of Christ",
    practice_id: "[C1993] #C1149 #C1150 #[C1151] #[C2330]",
    practice_label:
      "feigned piety #adoratio diaboli #in occulto #feigned orthodoxy #undergoing martyrdom",
    note: "Heretics were not afraid of death and treated the stake as an ordeal easy to overcome.\n#The number of heretics is 10+1 because Adhemar speaks about 10 heretics, but also mentions Theodatus, a dead heretic whose body is exhumed and thrown out on the road.\n#Heretics have a vision of the devil in the form of an Ethiopian.",
  },
  E0007: {
    id: "E0007",
    label: "learned heresy in Orléans",
    detail_case_summary:
      'In the "Vita Gauzlini", Andrew of Fleury describes learned heretics discovered in Orléans in 1022. A similar description can be found in the other text of Andrew of Fleury, "Miracula Sancti Benedicti".',
    label_and_source_concatenated:
      "learned heresy in Orléans (Adrevaldus monachus Floriacensis, Vita Gauzlini, abbatis Floriacensis monasterii)",
    case_id: "E1007",
    case_label: "learned heresy at Orléans",
    text_id: "T85",
    text_label: "Vita Gauzlini, abbatis Floriacensis monasterii",
    year_start_post_quem: "1022",
    year_start_ante_quem: "1022",
    year_end_post_quem: "1022",
    year_end_ante_quem: "1022",
    year_approximate: "n",
    location_id: "L0013",
    location_label: "Aurelianum",
    location_primary_id: "L0013",
    location_primary_label: "Orléans",
    geometry: "point",
    name_of_heresy_id: "C0001",
    name_of_heresy_label: "heresis",
    name_of_heretics_id: null,
    name_of_heretics_label: "#VALUE!",
    connotations_heresy_id:
      "C3501 #C1326 #C2241 #C2274 #C2275 #C1860 #C1269 #C1232",
    connotations_heresy_label:
      "nefandissima heresis #heresis sancte Ecclesie catholice contraria omnimodis #sub ovina pelle lupus #lupus perditionis #seminarium diaboli #perditio #false insanie #adversarii divinorum",
    heretic_id: "G0014 #P0008 #P0009",
    heretic_label: "clerici Aurelianenses [heretici] #Stephanus #Lisoius",
    heretics_amount_id: "[C1069]",
    heretics_amount_label: "plures/a",
    heretics_social_characterization_id: "C0455 #C1271 #C1272 #C1273",
    heretics_social_characterization_label:
      "clerici #presbyteri #diacones #subdiacones",
    instigator_to_heresy_id: "C1067",
    instigator_to_heresy_label: "not stated by the source",
    repressor_id: "P0006",
    repressor_label: "Rothbertus rex Francie",
    person_or_groups_other_id: "P0010 #G0008",
    person_or_groups_other_label:
      "Gauzlinus abbas Floriacensis #sapientiores Floriacenses",
    dealing_with_them_id: "[C1048]",
    dealing_with_them_label: "public debate",
    outcome_id: "C1063",
    outcome_label: "burning",
    "Unnamed: 40": null,
    execution_location_type_id: null,
    beliefs_id: "[C1154] #[C1080] #[C1061] #[C3220] #[C2503]",
    beliefs_label:
      "antitrinitarism #docetism #rejection of baptism as sacrament #bishops do not possess the Holy Spirit to ordain #heterodox mariological attitude",
    practice_id: "[C2299] #[C1081] #[C1152] #[C1082]",
    practice_label:
      "capital sin cannot be forgiven #rejection of imposition of hands #rejection of material churches #rejection of marriage as sacrament",
    note: "The description of heretical errors is followed by the profession of faith of Gauzlin. Gauzlin's credo deals with: the Trinity, Christ's incarnation and its nature, God's act of creation, the devil and free will, the resurrection of the flesh, the Last Judgement, marriage, meat consumption, the readmission of sinners into the community, baptism, the exclusivity of salvation in the Roman Church, and the decisions of six ecumenical councils.",
  },
  E0012: {
    id: "E0012",
    label: "learned heresy in Orléans",
    detail_case_summary:
      'In the "Miracula Sancti Benedicti", Andrew of Fleury describes learned heretics discovered in Orléans in 1022. A similar description can be found in the other text of Andrew of Fleury, "Vita Gauzlini".',
    label_and_source_concatenated:
      "learned heresy in Orléans (Adrevaldus monachus Floriacensis, Miracula Sancti Benedicti)",
    case_id: "E1007",
    case_label: "learned heresy at Orléans",
    text_id: "T88",
    text_label: "Miracula Sancti Benedicti",
    year_start_post_quem: "1022",
    year_start_ante_quem: "1022",
    year_end_post_quem: "1022",
    year_end_ante_quem: "1022",
    year_approximate: "n",
    location_id: "L0013",
    location_label: "Aurelianum",
    location_primary_id: "L0013",
    location_primary_label: "Orléans",
    geometry: "point",
    name_of_heresy_id: "C0001",
    name_of_heresy_label: "heresis",
    name_of_heretics_id: null,
    name_of_heretics_label: "#VALUE!",
    connotations_heresy_id:
      "C1275 #C1326 #C2241 #C2274 #C2275 #C1860 #C1269 #C1232",
    connotations_heresy_label:
      "nefanda heresis #heresis sancte Ecclesie catholice contraria omnimodis #sub ovina pelle lupus #lupus perditionis #seminarium diaboli #perditio #false insanie #adversarii divinorum",
    heretic_id: "G0014 #P0008 #P0009 #P0023",
    heretic_label:
      "clerici Aurelianenses [heretici] #Stephanus #Lisoius #Fulcherius",
    heretics_amount_id: "[C1069]",
    heretics_amount_label: "plures/a",
    heretics_social_characterization_id: "C0455 #C1271 #C1272 #C1273",
    heretics_social_characterization_label:
      "clerici #presbyteri #diacones #subdiacones",
    instigator_to_heresy_id: "C1067",
    instigator_to_heresy_label: "not stated by the source",
    repressor_id: "P0006",
    repressor_label: "Rothbertus rex Francie",
    person_or_groups_other_id: "P0010 #G0008",
    person_or_groups_other_label:
      "Gauzlinus abbas Floriacensis #sapientiores Floriacenses",
    dealing_with_them_id: "[C1048]",
    dealing_with_them_label: "public debate",
    outcome_id: "C1063",
    outcome_label: "burning",
    "Unnamed: 40": null,
    execution_location_type_id: null,
    beliefs_id: "[C1154] #[C1080] #[C1061] #[C3220] #[C2503]",
    beliefs_label:
      "antitrinitarism #docetism #rejection of baptism as sacrament #bishops do not possess the Holy Spirit to ordain #heterodox mariological attitude",
    practice_id: "[C2299] #[C1081] #[C1152] #[C1082]",
    practice_label:
      "capital sin cannot be forgiven #rejection of imposition of hands #rejection of material churches #rejection of marriage as sacrament",
    note: "The description of the heresy is followed by a story of one monk who had a bad dream about heretics.",
  },
  E0016: {
    id: "E0016",
    label: "learned heresy in Orléans",
    detail_case_summary:
      'A short description of the case of learned heretics discovered in Orléans in 1022, described in "Historia Francie".',
    label_and_source_concatenated:
      "learned heresy in Orléans (Historia Francie)",
    case_id: "E1007",
    case_label: "learned heresy at Orléans",
    text_id: "T92",
    text_label: "Historia Francie",
    year_start_post_quem: "1022",
    year_start_ante_quem: "1022",
    year_end_post_quem: "1022",
    year_end_ante_quem: "1022",
    year_approximate: "n",
    location_id: "L0013",
    location_label: "Aurelianum",
    location_primary_id: "L0013",
    location_primary_label: "Orléans",
    geometry: "point",
    name_of_heresy_id: "C0001",
    name_of_heresy_label: "heresis",
    name_of_heretics_id: null,
    name_of_heretics_label: "#VALUE!",
    connotations_heresy_id: "C1275",
    connotations_heresy_label: "nefanda heresis",
    heretic_id: "P0008 #P0009 #[G0014]",
    heretic_label: "Stephanus #Lisoius #clerici Aurelianenses [heretici]",
    heretics_amount_id: "[C1069]",
    heretics_amount_label: "plures/a",
    heretics_social_characterization_id: "C1271 #C1274 #[C0455]",
    heretics_social_characterization_label: "presbyteri #Levite #clerici",
    instigator_to_heresy_id: "C1067",
    instigator_to_heresy_label: "not stated by the source",
    repressor_id: "C1067",
    repressor_label: "not stated by the source",
    person_or_groups_other_id: null,
    person_or_groups_other_label: "#VALUE!",
    dealing_with_them_id: "C1067",
    dealing_with_them_label: "not stated by the source",
    outcome_id: "C1063",
    outcome_label: "burning",
    "Unnamed: 40": null,
    execution_location_type_id: null,
    beliefs_id: "[C1061] #[C3220] #[C0052]",
    beliefs_label:
      "rejection of baptism as sacrament #bishops do not possess the Holy Spirit to ordain #errores",
    practice_id: "[C2299] #[C1081] #[C1082]",
    practice_label:
      "capital sin cannot be forgiven #rejection of imposition of hands #rejection of marriage as sacrament",
    note: 'The source doesn\'t mention the date of the event but places it around the year of death of the pope Sylvester II (1003).\n#The description of the event is preceded by a description of the birth of a monstrous child in Orléans in 1003.\n#The description of the event is followed by information about a tsunami ("secus maritima") in Aquitaine and blood rain.',
  },
  E0008: {
    id: "E0008",
    label: "learned heresy in Orléans",
    detail_case_summary:
      'In one of the chapters of the "Historiarum Libri Quinque", Rodulfus Glaber gives a long description of the case of learned heretics discovered in Orléans in 1022. The heresy was discovered by a priest from Rouen. The heretics were killed on the order of King Robert the Pious. Glaber described heretics as hedonists, who had a heretical view on the Trinity and did not believe that God had created the world.',
    label_and_source_concatenated:
      "learned heresy in Orléans (Rodulfus Glabrus, Historiarum Libri Quinque)",
    case_id: "E1007",
    case_label: "learned heresy at Orléans",
    text_id: "T82",
    text_label: "Historiarum Libri Quinque",
    year_start_post_quem: "1022",
    year_start_ante_quem: "1022",
    year_end_post_quem: "1022",
    year_end_ante_quem: "1022",
    year_approximate: "n",
    location_id: "L0013 #L0009 #L0102 #L0016 #L0017 #L0018",
    location_label:
      "Aurelianum #Galia #vicinia Aureliani #Rothomagus #ecclesia cathedralis Sancte Crucis Aurelianis #ecclesia Sancti Petri cognomento Puellaris",
    location_primary_id: "L0013",
    location_primary_label: "Orléans",
    geometry: "point",
    name_of_heresy_id: "C0001",
    name_of_heresy_label: "heresis",
    name_of_heretics_id: null,
    name_of_heretics_label: "#VALUE!",
    connotations_heresy_id:
      "C1157 #C1327 #C2276 #C3503 #C2277 #C1325 #C2278 #C1088 #C1329 #C1090 #C3505 #C3507 #C3509 #C3225 #C1092 #C1091 #C2002",
    connotations_heresy_label:
      "cruda heresis #insolens heresis #laqueus cecitatis #insanissima heresis #heresis diabolo plena #venenum nequitie #seminarium nequam #vesanie #clandestina pestis #dogma perversum #stultissima heresis #miserrima heresis #insanientes #canum more latrantes #epicurei #perfidia #ars diabolica",
    heretic_id: "P0011 #P0009 #G0014",
    heretic_label: "Heribertus #Lisoius #clerici Aurelianenses [heretici]",
    heretics_amount_id: "~V~13 #C1069",
    heretics_amount_label: "~V~13 #plures/a",
    heretics_social_characterization_id: "C0455 #C1160 #C1161",
    heretics_social_characterization_label: "clerici #simplices #idiote",
    instigator_to_heresy_id: "P0012",
    instigator_to_heresy_label: "mulier quadam ex Italia",
    repressor_id: "P0013 #P0014 #P0006 #G0009 #G0010 #G0022 #G0023",
    repressor_label:
      "presbiter Rotomagorum #Richardus comes Rotomagorum #Rothbertus rex Francie #episcopi [Aureliani congregati] #abbates [Aureliani congregati] #religiosi [Aureliani congregati] #laici [Aureliani congregati]",
    person_or_groups_other_id: null,
    person_or_groups_other_label: "#VALUE!",
    dealing_with_them_id: "C1265",
    dealing_with_them_label: "hearing",
    outcome_id: "C1063",
    outcome_label: "burning",
    "Unnamed: 40": null,
    execution_location_type_id: "C1162",
    beliefs_id: "[C1154] #[C1158] #[C1159] #[C0052]",
    beliefs_label:
      "antitrinitarism #God did not create this world #good deeds are superfluous for salvation #errores",
    practice_id: "[C2326] #[C1111] #[C2329]",
    practice_label: "proselytization #hedonism #preparedness for martyrdom",
    note: 'Glabrus dates the heresy as 1017.\n#The term "hedonism" refers to the practices of heretics which involved indulging in shameful pleasures: "in hoc tamen epicureis erant hereticis similes, quoniam voluptatem flagitiis credebant non recompensari ultionis vindictam”.\n#Heretics confessed to their errors when they were burning.',
  },
  E0010: {
    id: "E0010",
    label: "learned heresy in Orléans",
    detail_case_summary:
      "Learned heretics discovered in Orléans in 1022, described by Bishop Balduin in a letter to his diocesans. In the letter, Balduin describes some errors of the heretics to warn against, and to stop the possible spread of the Orléans heresy to his diocese.",
    label_and_source_concatenated:
      "learned heresy in Orléans (Baldvinus episcopus Tarvenensis, Epistola Baldvini Episcopi)",
    case_id: "E1007",
    case_label: "learned heresy at Orléans",
    text_id: "T93",
    text_label: "Epistola Baldvini Episcopi",
    year_start_post_quem: "1022",
    year_start_ante_quem: "1022",
    year_end_post_quem: "1022",
    year_end_ante_quem: "1022",
    year_approximate: "n",
    location_id: "L0013 #L0007 #L0026 #L0017",
    location_label:
      "Aurelianum #Aquitania #Arvernia #ecclesia cathedralis Sancte Crucis Aurelianis",
    location_primary_id: "L0013",
    location_primary_label: "Orléans",
    geometry: "point",
    name_of_heresy_id: "C1163",
    name_of_heresy_label: "manichea heresis",
    name_of_heretics_id: "[C1059]",
    name_of_heretics_label: "manichei",
    connotations_heresy_id:
      "C1234 #C1157 #C1327 #C1164 #C1330 #C1331 #C1591 #C2279 #C2002 #C0543",
    connotations_heresy_label:
      "hostis humani generis insanissimus #cruda heresis #insolens heresis #pessima dogmata #clandestina lues #virulenta lues #virus #obstinatio animi #ars diabolica #blasphemia",
    heretic_id: "G0014 #P0011 #P0009",
    heretic_label: "clerici Aurelianenses [heretici] #Heribertus #Lisoius",
    heretics_amount_id: "~V~11 #C1069",
    heretics_amount_label: "~V~11 #plures/a",
    heretics_social_characterization_id: "C1117 #[C1160]",
    heretics_social_characterization_label: "canonici cathedrales #simplices",
    instigator_to_heresy_id: "C1067",
    instigator_to_heresy_label: "not stated by the source",
    repressor_id: "P0006 #G0009 #G0010 #G0103 #P0016 #P0115",
    repressor_label:
      "Rothbertus rex Francie #episcopi [Aureliani congregati] #abbates [Aureliani congregati] #decani [Aureliani congregati] #Fulbertus episcopus Carnotensis #Franco Bononicus",
    person_or_groups_other_id: null,
    person_or_groups_other_label: "#VALUE!",
    dealing_with_them_id: "C1048",
    dealing_with_them_label: "public debate",
    outcome_id: "C1063",
    outcome_label: "burning",
    "Unnamed: 40": null,
    execution_location_type_id: "C1162",
    beliefs_id: "[C1061]",
    beliefs_label: "rejection of baptism as sacrament",
    practice_id: "[C1054] #[C1359] #[C1167]",
    practice_label:
      "disrespect for cross #rejection of cult #rejection of fasting",
    note: "Balduin dates the heresy as 1017.\n#Heretics confessed to their errors when they were burning.\n#In the later part of the letter Balduin writes about blood rain in Aquitania.",
  },
  E0009: {
    id: "E0009",
    label: "learned heresy in Orléans",
    detail_case_summary:
      "The longest and most detailed description of the case of the learned heretics discovered in Orléans in 1022, described in the cartulary of Saint-Père of Chartres. The description places Arefast, a Norman knight, in the foreground and portrays him as a hero who exposed heresy through elaborate intrigue. The story is preceded by an act of donation of Arefast to the monastery. ",
    label_and_source_concatenated:
      "learned heresy in Orléans (Paulus monachus Carnotensis, Cartularium monasterii sancti Petri Carnotensis)",
    case_id: "E1007",
    case_label: "learned heresy at Orléans",
    text_id: "T86",
    text_label: "Cartularium monasterii sancti Petri Carnotensis",
    year_start_post_quem: "1022",
    year_start_ante_quem: "1022",
    year_end_post_quem: "1022",
    year_end_ante_quem: "1022",
    year_approximate: "n",
    location_id: "L0013 #L0009 #L0017",
    location_label:
      "Aurelianum #Galia #ecclesia cathedralis Sancte Crucis Aurelianis",
    location_primary_id: "L0013",
    location_primary_label: "Orléans",
    geometry: "point",
    name_of_heresy_id: "C0001 #C0122",
    name_of_heresy_label: "heresis #error",
    name_of_heretics_id: null,
    name_of_heretics_label: "#VALUE!",
    connotations_heresy_id:
      "C0002 #C1332 #C1333 #C3231 #C1334 #C1094 #C1093 #C1335 #C3232 #C1341 #C1336 #C3510 #C3511 #C3512 #C3233 #C1338 #C3513 #C3514 #C1339 #C1240 #C1340 #C2006 #C1342 #C1344",
    connotations_heresy_label:
      "heretica pravitas #nefandus error #venenum erroris #heresis baratrum #mortiferus haustus nequitie #dementia #error diabolicus #pestis latitans #multimode artes diabolice fraudis #domus erroneorum #nequitie sentina #exsecrandus/a/um #perditi/e #miserrimi/e #fetidum pectus #nequissima congregatio #vis diabolice fraudis #nefarium opus #infidelium crudelitas #totius veritatis inimici #heresis feditas #serpens #magistri erroris #os viperinum",
    heretic_id: "P0015 #P0008 #P0009 #[G0014] #[G0024]",
    heretic_label:
      "Heribertus #Stephanus #Lisoius #clerici Aurelianenses [heretici] #monache Aurelianenses [heretice]",
    heretics_amount_id: "[C1069]",
    heretics_amount_label: "plures/a",
    heretics_social_characterization_id: "C0455 #C1241",
    heretics_social_characterization_label: "clerici #monache",
    instigator_to_heresy_id: "C1067",
    instigator_to_heresy_label: "not stated by the source",
    repressor_id:
      "P0018 #P0014 #P0006 #P0017 #P0019 #G0011 #G0012 #G0008 #P0020",
    repressor_label:
      "Arefastus miles Richardi #Richardus comes Rotomagorum #Rothbertus rex Francie #Ebrardus sacriscinarius Carnotensis #Constantia regina Francie #offciales regii [Aureliani congregati] #collegium episcoporum [Aureliani congregatum] #sapientiores Floriacenses #Guarinus presul Belvacensis",
    person_or_groups_other_id: "P0016 #P0028",
    person_or_groups_other_label:
      "Fulbertus episcopus Carnotensis #demon [qui hereticis Aurelianensibus apparebat]",
    dealing_with_them_id: "C1048",
    dealing_with_them_label: "public debate",
    outcome_id: "C1097 #C1098 #C1063 #C1051",
    outcome_label:
      "degradation #corporeal mutilation #burning #reconversion to Catholicism",
    "Unnamed: 40": null,
    execution_location_type_id: "C1162",
    beliefs_id: "[C1080] #[C1061] #[C1064] #[C1102] #[C1252]",
    beliefs_label:
      "docetism #rejection of baptism as sacrament #rejection of Eucharist as sacrament #gnosis #God is the Creator",
    practice_id: "[C1100] #[C1101] #[C1242] #[C3362]",
    practice_label:
      "rejection of cult of saints #rejection of cult of martyrs #imposition of hands #conventicula hereticorum",
    note: 'The source is sometimes cited by historians as "Gesta Synodi Aurelianensis".\n#The date of the event is not mentioned in the source.\n#The term "God is the Creator" used in the beliefs refers to the passages in the source in which the heretics acknowledge that the world was indeed created by God: "Quod natura denegat, semper a creatore discrepat" and "et nichil aliud sapimus, nisi quod a Deo, omnium conditore".\n#The author gives a detailed description of a heretic orgy and of the consecutive murder of a child born from sexual intercourse which allegedly happened at this orgy. The ashes of the murdered child were then used by heretics as a sort of anti-Eucharist. A similar description can be found in the case of manicheans near Soissons, described by Guibert of Nogent.\n#In certain passages the author stresses the importance of the Eucharist and the cult of the cross.\n#The heretics use a metaphor of tree grafting to describe the process of the transmission of heretical errors to a disciple.',
  },
  E0005: {
    id: "E0005",
    label: "learned heresy in Orléans",
    detail_case_summary:
      "The earliest reference describing the events that took place in Orléans in 1022 is the letter written by John of Ripoll to the abbot Oliba. John describes the incident in Orléans and the errors of heretics to warn Oliba and to tell him how to recognize the heresy.",
    label_and_source_concatenated:
      "learned heresy in Orléans (Johannes monachus Floriacensis, Epistola Johannis monachi ad Olibam)",
    case_id: "E1007",
    case_label: "learned heresy at Orléans",
    text_id: "T84",
    text_label: "Epistola Johannis monachi ad Olibam",
    year_start_post_quem: "1022",
    year_start_ante_quem: "1022",
    year_end_post_quem: "1022",
    year_end_ante_quem: "1022",
    year_approximate: "n",
    location_id: "L0013",
    location_label: "Aurelianum",
    location_primary_id: "L0013",
    location_primary_label: "Orléans",
    geometry: "point",
    name_of_heresy_id: "C0001",
    name_of_heresy_label: "heresis",
    name_of_heretics_id: null,
    name_of_heretics_label: "#VALUE!",
    connotations_heresy_id: "C1243 #C1345",
    connotations_heresy_label: "odibilis/e Deo #perosi celo et terre",
    heretic_id: "G0014 #G0025",
    heretic_label:
      "clerici Aurelianenses [heretici] #laici Aurelianenses [heretici]",
    heretics_amount_id: "~V~14",
    heretics_amount_label: "~V~14",
    heretics_social_characterization_id: "C2280 #C2281",
    heretics_social_characterization_label:
      "meliores clerici civitatis #meliores laici civitatis",
    instigator_to_heresy_id: "C1067",
    instigator_to_heresy_label: "not stated by the source",
    repressor_id: "P0006",
    repressor_label: "Rothbertus rex Francie",
    person_or_groups_other_id: null,
    person_or_groups_other_label: "#VALUE!",
    dealing_with_them_id: "C1067",
    dealing_with_them_label: "not stated by the source",
    outcome_id: "C1063",
    outcome_label: "burning",
    "Unnamed: 40": null,
    execution_location_type_id: null,
    beliefs_id: "[C1061] #[C1064]",
    beliefs_label:
      "rejection of baptism as sacrament #rejection of Eucharist as sacrament",
    practice_id: "[C1065] #[C1082] #[C1066]",
    practice_label:
      "rejection of confession as sacrament #rejection of marriage as sacrament #avoidance of meat",
    note: null,
  },
  E0011: {
    id: "E0011",
    label: "learned heresy in Orléans",
    detail_case_summary:
      'A short description of the case of learned heretics discovered in Orléans in 1022 inserted in the "Vita Theodorici episcopi Aurelianensis". A similar description can be found in "Chronicon Sancti Petri Vivi Senonesis" and "Chronicon Turonense".',
    label_and_source_concatenated:
      "learned heresy in Orléans (Vita Theodorici episcopi Aurelianensis)",
    case_id: "E1007",
    case_label: "learned heresy at Orléans",
    text_id: "T87",
    text_label: "Vita Theodorici episcopi Aurelianensis",
    year_start_post_quem: "1022",
    year_start_ante_quem: "1022",
    year_end_post_quem: "1022",
    year_end_ante_quem: "1022",
    year_approximate: "n",
    location_id: "L0013",
    location_label: "Aurelianum",
    location_primary_id: "L0013",
    location_primary_label: "Orléans",
    geometry: "point",
    name_of_heresy_id: "C0001",
    name_of_heresy_label: "heresis",
    name_of_heretics_id: null,
    name_of_heretics_label: "#VALUE!",
    connotations_heresy_id: "C1104 #C1105",
    connotations_heresy_label: "nova heresis #heresis inaudita",
    heretic_id: "G0014",
    heretic_label: "clerici Aurelianenses [heretici]",
    heretics_amount_id: "[C1174]",
    heretics_amount_label: "aliqui/e/a",
    heretics_social_characterization_id: "C2280",
    heretics_social_characterization_label: "meliores clerici civitatis",
    instigator_to_heresy_id: "C1067",
    instigator_to_heresy_label: "not stated by the source",
    repressor_id: "P0006 #P0021 #G0013",
    repressor_label:
      "Rothbertus rex Francie #Leothericus archiepiscopus Senonensis #synodum [Aureliani congregatum]",
    person_or_groups_other_id: "P0022",
    person_or_groups_other_label: "Theodoricus episcopus Aurelianensis",
    dealing_with_them_id: "[C1048]",
    dealing_with_them_label: "public debate",
    outcome_id: "C1063",
    outcome_label: "burning",
    "Unnamed: 40": null,
    execution_location_type_id: null,
    beliefs_id: "C1067",
    beliefs_label: "not stated by the source",
    practice_id: "C1067",
    practice_label: "not stated by the source",
    note: null,
  },
  E0015: {
    id: "E0015",
    label: "learned heresy in Orléans",
    detail_case_summary:
      'A short description of the case of learned heretics discovered in Orléans in 1022, described in "Chronicon Sancti Petri Vivi Senonensis". A similar description can be found in "Vita Theodorici episcopi Aurelianensis" and "Chronicon Turonense".',
    label_and_source_concatenated:
      "learned heresy in Orléans (Clarius monachus Senonensis, Chronicon Sancti Petri Vivi Senonensis)",
    case_id: "E1007",
    case_label: "learned heresy at Orléans",
    text_id: "T89",
    text_label: "Chronicon Sancti Petri Vivi Senonensis",
    year_start_post_quem: "1022",
    year_start_ante_quem: "1022",
    year_end_post_quem: "1022",
    year_end_ante_quem: "1022",
    year_approximate: "n",
    location_id: "L0013",
    location_label: "Aurelianum",
    location_primary_id: "L0013",
    location_primary_label: "Orléans",
    geometry: "point",
    name_of_heresy_id: "C0001",
    name_of_heresy_label: "heresis",
    name_of_heretics_id: null,
    name_of_heretics_label: "#VALUE!",
    connotations_heresy_id: "C1245 #C1104 #C1105",
    connotations_heresy_label: "magna heresis #nova heresis #heresis inaudita",
    heretic_id: "G0014",
    heretic_label: "clerici Aurelianenses [heretici]",
    heretics_amount_id: "[C1174]",
    heretics_amount_label: "aliqui/e/a",
    heretics_social_characterization_id: "C2280",
    heretics_social_characterization_label: "meliores clerici civitatis",
    instigator_to_heresy_id: "C1067",
    instigator_to_heresy_label: "not stated by the source",
    repressor_id: "P0006 #P0021 #G0013",
    repressor_label:
      "Rothbertus rex Francie #Leothericus archiepiscopus Senonensis #synodum [Aureliani congregatum]",
    person_or_groups_other_id: null,
    person_or_groups_other_label: "#VALUE!",
    dealing_with_them_id: "[C1048]",
    dealing_with_them_label: "public debate",
    outcome_id: "C1063",
    outcome_label: "burning",
    "Unnamed: 40": null,
    execution_location_type_id: null,
    beliefs_id: "C1067",
    beliefs_label: "not stated by the source",
    practice_id: "C1067",
    practice_label: "not stated by the source",
    note: "There are two major redactions of the source, one written in the 12th century by a certain Clarius, and the second from the 13th century written by Geoffroy de Courlon. The redaction of Clarius was used for this map.",
  },
  E0013: {
    id: "E0013",
    label: "learned heresy in Orléans",
    detail_case_summary:
      'A short description of the case of learned heretics discovered in Orléans in 1022, described in "Chronicon Turonense". A similar description can be found in "Chronicon Sancti Petri Vivi Senonesis" and "Vita Theodorici episcopi Aurelianensis".',
    label_and_source_concatenated:
      "learned heresy in Orléans (Petrus Bechinus, Chronicon Turonense)",
    case_id: "E1007",
    case_label: "learned heresy at Orléans",
    text_id: "T90",
    text_label: "Chronicon Turonense",
    year_start_post_quem: "1022",
    year_start_ante_quem: "1022",
    year_end_post_quem: "1022",
    year_end_ante_quem: "1022",
    year_approximate: "n",
    location_id: "L0013",
    location_label: "Aurelianum",
    location_primary_id: "L0013",
    location_primary_label: "Orléans",
    geometry: "point",
    name_of_heresy_id: "C0001",
    name_of_heresy_label: "heresis",
    name_of_heretics_id: null,
    name_of_heretics_label: "#VALUE!",
    connotations_heresy_id: "C1104 #C1105",
    connotations_heresy_label: "nova heresis #heresis inaudita",
    heretic_id: "G0014",
    heretic_label: "clerici Aurelianenses [heretici]",
    heretics_amount_id: "[C1174]",
    heretics_amount_label: "aliqui/e/a",
    heretics_social_characterization_id: "C2280",
    heretics_social_characterization_label: "meliores clerici civitatis",
    instigator_to_heresy_id: "C1067",
    instigator_to_heresy_label: "not stated by the source",
    repressor_id: "G0015",
    repressor_label: "concilium [Aureliani congregatum]",
    person_or_groups_other_id: null,
    person_or_groups_other_label: "#VALUE!",
    dealing_with_them_id: "[C1048]",
    dealing_with_them_label: "public debate",
    outcome_id: "C1063",
    outcome_label: "burning",
    "Unnamed: 40": null,
    execution_location_type_id: null,
    beliefs_id: "C1067",
    beliefs_label: "not stated by the source",
    practice_id: "C1067",
    practice_label: "not stated by the source",
    note: null,
  },
  E0014: {
    id: "E0014",
    label: "learned heresy in Orléans",
    detail_case_summary:
      "A short mention in the dating clause of a charter of Robert II informing about some heretics discovered in Orléans in 1022.",
    label_and_source_concatenated:
      "learned heresy in Orléans (Robertus rex Francie, Carta Roberti regis Francie)",
    case_id: "E1007",
    case_label: "learned heresy at Orléans",
    text_id: "T91",
    text_label: "Carta Roberti regis Francie",
    year_start_post_quem: "1022",
    year_start_ante_quem: "1022",
    year_end_post_quem: "1022",
    year_end_ante_quem: "1022",
    year_approximate: "n",
    location_id: "L0013",
    location_label: "Aurelianum",
    location_primary_id: "L0013",
    location_primary_label: "Orléans",
    geometry: "point",
    name_of_heresy_id: "[C0001]",
    name_of_heresy_label: "heresis",
    name_of_heretics_id: null,
    name_of_heretics_label: "#VALUE!",
    connotations_heresy_id: null,
    connotations_heresy_label: "#VALUE!",
    heretic_id: "G0026",
    heretic_label: "heretici Aurelianenses",
    heretics_amount_id: "[C1174]",
    heretics_amount_label: "aliqui/e/a",
    heretics_social_characterization_id: "C1067",
    heretics_social_characterization_label: "not stated by the source",
    instigator_to_heresy_id: "C1067",
    instigator_to_heresy_label: "not stated by the source",
    repressor_id: "C1067",
    repressor_label: "not stated by the source",
    person_or_groups_other_id: null,
    person_or_groups_other_label: "#VALUE!",
    dealing_with_them_id: "C1067",
    dealing_with_them_label: "not stated by the source",
    outcome_id: "C1106",
    outcome_label: "excommunication",
    "Unnamed: 40": null,
    execution_location_type_id: null,
    beliefs_id: "C1067",
    beliefs_label: "not stated by the source",
    practice_id: "C1067",
    practice_label: "not stated by the source",
    note: 'King Robert\'s diploma for the monastery of Micy-Saint-Mesmin from the year 1022 has come down to us in two versions, one true and one false. The true act of donation contains the date "quando et heretici dampnati sunt Aurelianis"; the extended version in the forged confirmation of ownership was most likely the fault of the forger: ”quando Stephanus heresiarches et complices eius dampnati et arsi sunt Aurelianis”.',
  },
  E0101: {
    id: "E0101",
    label: "learned heresy in Orléans",
    detail_case_summary:
      'A short description of the case of learned heretics discovered in Orléans in 1022, described in "Chronicon breve Autissiodorense".',
    label_and_source_concatenated:
      "learned heresy in Orléans (Chronicon breve Autissiodorense)",
    case_id: "E1007",
    case_label: "learned heresy at Orléans",
    text_id: "T155",
    text_label: "Chronicon breve Autissiodorense",
    year_start_post_quem: "1022",
    year_start_ante_quem: "1022",
    year_end_post_quem: "1022",
    year_end_ante_quem: "1022",
    year_approximate: "n",
    location_id: "L0013",
    location_label: "Aurelianum",
    location_primary_id: "L0013",
    location_primary_label: "Orléans",
    geometry: "point",
    name_of_heresy_id: "[C0001]",
    name_of_heresy_label: "heresis",
    name_of_heretics_id: "C1059",
    name_of_heretics_label: "manichei",
    connotations_heresy_id: "C3719",
    connotations_heresy_label: "diabolica suggestio",
    heretic_id: "G0014",
    heretic_label: "clerici Aurelianenses [heretici]",
    heretics_amount_id: "[C1174]",
    heretics_amount_label: "aliqui/e/a",
    heretics_social_characterization_id: "C0455",
    heretics_social_characterization_label: "clerici",
    instigator_to_heresy_id: "C1067",
    instigator_to_heresy_label: "not stated by the source",
    repressor_id: "C1067",
    repressor_label: "not stated by the source",
    person_or_groups_other_id: null,
    person_or_groups_other_label: "#VALUE!",
    dealing_with_them_id: "C1067",
    dealing_with_them_label: "not stated by the source",
    outcome_id: "C1063",
    outcome_label: "burning",
    "Unnamed: 40": null,
    execution_location_type_id: null,
    beliefs_id: "C1067",
    beliefs_label: "not stated by the source",
    practice_id: "C1067",
    practice_label: "not stated by the source",
    note: null,
  },
  E0021: {
    id: "E0021",
    label: "evangelical heretics of Arras",
    detail_case_summary:
      "A letter written by Gerard, Bishop of Cambrai and Arras, to the bishop R. Gerard warns R. of the heretics he has discovered in Arras, who are also in the diocese of R. He describes their doctrine and warns him not to believe in their feigned orthodoxy.",
    label_and_source_concatenated:
      "evangelical heretics of Arras (Gerardus episcopus Camaracensis et Attrebatensis, epistola Gerardi episcopi Camaracensis et Attrebatensis ad R.)",
    case_id: "E1009",
    case_label: "evangelical heretics of Arras",
    text_id: "T143",
    text_label: "epistola Gerardi episcopi Camaracensis et Attrebatensis ad R.",
    year_start_post_quem: "1025",
    year_start_ante_quem: "1025",
    year_end_post_quem: "1025",
    year_end_ante_quem: "1025",
    year_approximate: "n",
    location_id: "L0034\n#L0014\n#L0036",
    location_label: "Atrebatum #Catalaunum #Leodium",
    location_primary_id: "L0034",
    location_primary_label: "Arras",
    geometry: "point",
    name_of_heresy_id: "C1262",
    name_of_heresy_label: "secta",
    name_of_heretics_id: null,
    name_of_heretics_label: "#VALUE!",
    connotations_heresy_id: "C3516 #C1350 #C1349 #C1351 #C3236",
    connotations_heresy_label:
      "nefarii/e #erroris spiritu magicati #pravi dogmatis dementia #erroris maleficium #simulata religio",
    heretic_id: "G0111",
    heretic_label: "[heretici Attrebatenses]",
    heretics_amount_id: "[C1174]",
    heretics_amount_label: "aliqui/e/a",
    heretics_social_characterization_id: "C1067",
    heretics_social_characterization_label: "not stated by the source",
    instigator_to_heresy_id: "C1067",
    instigator_to_heresy_label: "not stated by the source",
    repressor_id: "P0037",
    repressor_label: "Gerardus episcopus Camaracensis et Attrebatensis",
    person_or_groups_other_id: "P0038",
    person_or_groups_other_label: "R. episcopus",
    dealing_with_them_id: "C1265",
    dealing_with_them_label: "hearing",
    outcome_id: "C1067",
    outcome_label: "not stated by the source",
    "Unnamed: 40": null,
    execution_location_type_id: null,
    beliefs_id: "[C1061]\n#[C1064]\n#[C0052]",
    beliefs_label:
      "rejection of baptism as sacrament #rejection of Eucharist as sacrament #errores",
    practice_id: "[C1151] #[C2326] #[C2283] #[C1065] #[C1082]",
    practice_label:
      "feigned orthodoxy #proselytization #importance of apostolic and evangelical texts #rejection of confession as sacrament #rejection of marriage as sacrament",
    note: 'The second location of the heresy is uncertain as we do not know to whom the Archbishop of Arras had addressed his letter. There are two possibilities for an enigmatic "bishop R.": Roger I of Châlons (1018-1042) or Reginard of Liège (1025-1036).',
  },
  E0022: {
    id: "E0022",
    label: "evangelical heretics of Arras",
    detail_case_summary:
      "Acts of the synod of January 1025 at Arras. The source reports how the Bishop of Cambrai and Arras, Gerard, discovered heretics during his annual stay in Arras. Gerard ordered the imprisonment of the heretics, who were then subjected to interrogation in a cell and then in public. The acts provide information regarding the doctrine of the heretics, which put great importance on evangelical precepts. The source also contains a record of Gerard's sermon on the truths of the faith, which he reportedly delivered at the synod.",
    label_and_source_concatenated:
      "evangelical heretics of Arras (Acta Synodi Atrebatensis)",
    case_id: "E1009",
    case_label: "evangelical heretics of Arras",
    text_id: "T94",
    text_label: "Acta Synodi Atrebatensis",
    year_start_post_quem: "1025",
    year_start_ante_quem: "1025",
    year_end_post_quem: "1025",
    year_end_ante_quem: "1025",
    year_approximate: "n",
    location_id: "L0034\n#L0116",
    location_label: "Atrebatum #ecclesia beate Marie Attrebatensis",
    location_primary_id: "L0034",
    location_primary_label: "Arras",
    geometry: "point",
    name_of_heresy_id: "C0001 #C1262",
    name_of_heresy_label: "heresis #secta",
    name_of_heretics_id: null,
    name_of_heretics_label: "#VALUE!",
    connotations_heresy_id: "C3238 #C1352 #C1264",
    connotations_heresy_label:
      "pravi dogmatis error #perfidia incredulitatis #heretica infidelitas",
    heretic_id: "G0035",
    heretic_label: "auditores Gundulfi",
    heretics_amount_id: "[C1174]",
    heretics_amount_label: "aliqui/e/a",
    heretics_social_characterization_id: "[C1170]",
    heretics_social_characterization_label: "illitterati/e",
    instigator_to_heresy_id: "G0112\n#P0036",
    instigator_to_heresy_label: "quidam viri ex Italia #Gundulfus ex Italia",
    repressor_id: "P0037 #G0114 #G0037",
    repressor_label:
      "Gerardus episcopus Camaracensis et Attrebatensis #questores [qui fugam hereticorum prevenerunt] #synodum [abbates, religiosi, archidiaconi, ceterisque Atrebati congregati]",
    person_or_groups_other_id: "G0113 #G0036 #G0038",
    person_or_groups_other_label:
      "clerici et monachi Attrebatenses #archidiaconi Gerardi episcopi #multitudo cleri et populi [Atrebati congregatum]",
    dealing_with_them_id: "C1266 #C1265 #C3241 #C1048",
    dealing_with_them_label: "apprehension #hearing #fast #public debate",
    outcome_id: "C3237 #C1106 #C1051 #C1323",
    outcome_label:
      "attempted flight #excommunication #reconversion to Catholicism #abjuration of heretical errors",
    "Unnamed: 40": null,
    execution_location_type_id: null,
    beliefs_id: "[C2327] #[C1113] #[C1061] #[C1064]",
    beliefs_label:
      "salvation through justice #rejection of sacraments #rejection of baptism as sacrament #rejection of Eucharist as sacrament",
    practice_id:
      "[C2326] #[C2283] #[C1065] #[C1152] #[C1082] #[C3239] #C3240 #[C2883] #[C1253] #[C2284] #[C2884] #[C2885]",
    practice_label:
      "proselytization #importance of apostolic and evangelical texts #rejection of confession as sacrament #rejection of material churches #rejection of marriage as sacrament #rejection of cult of confessors #preter apostolos et martyres neminem debere venerari #relinquishing the world #chastity #importance of manual labor #non-offensive behaviour #charity",
    note: 'The Church of the Blessed Mary is the location where the synod took place.\n#After hearing of the heretics, the bishop ordered the local monks and clergy to fast for the conversion of the heretics.\n#All of the heretics present at the synod converted to Catholicism and excommunication was thrown at other potential heretics professing the condemned doctrine.\n#Heretics gave a detailed explanation of their rejection of the sacrament of baptism: if someone follows the way of "justitia", baptism is unnecessary; if one does not have "justitia", baptism will not help in any way; no minister is worthy enough to administer the sacrament; the remission of sins by baptism does not protect against committing new ones in the future; the baptism of children is invalid because it is not received by them consciously.\n#Subjects treated by Gerard in his sermon: "de baptismo, de corpore et sanguine Domini, de sancta ecclesia quae est domus Dei, de sacro altari et de thymiamate, de signis, de sacris ordinibus, de sepultura, de penitentia, quod penitentia post mortem prosit, de connubiis, de confessoribus, de psallendi officio, de veneratione Dominice crucis, de imagine Salvatoris in cruce, de ordinibus ecclesiassici regiminis, de eorum falsa justitia".\n#Subjects treated in the heretical abjuration: baptism, penitence, church buildings, the Eucharist, marriage.\n#Subjects treated in the final credo: baptism, confession, church buildings, the Eucharist, incarnation, the resurrection and ascension of Christ, marriage.\n#At the end of his sermon, the bishop referred to a passage from The First Letter of Paul to Timothy, in which the apostle writes about the heretics of the end of times: "[Spiritus autem manifeste dicit,] quia in novissimis temporibus discedent quidam a fide, attendentes spiritibus erroris, et doctrinis demoniorum, in hypocrisi loquentium [mendacium], et cauteriatam habentium conscientiam suam, prohibentium nubere, abstinere a cibis, quos Deus creavit ad percipiendum cum gratiarum actione fidelibus, [et iis qui cognoverunt veritatem]" (1 Tim. 4:1-3).',
  },
  E0032: {
    id: "E0032",
    label: "ascetic heretics in Périgord",
    detail_case_summary:
      'A letter written by the monk Heribert warning of heretics who have appeared in Périgord and who are characterized by following principles of "vita apostolica" and asceticism.',
    label_and_source_concatenated:
      "ascetic heretics in Périgord (Heribertus monachus, epistola monachi Heriberti)",
    case_id: "E1013",
    case_label: "ascetic heretics in Périgord",
    text_id: "T102",
    text_label: "epistola monachi Heriberti",
    year_start_post_quem: "1025",
    year_start_ante_quem: "1050",
    year_end_post_quem: "1025",
    year_end_ante_quem: "1050",
    year_approximate: "y",
    location_id: "L0043",
    location_label: "regio Petragorensis",
    location_primary_id: "L0028",
    location_primary_label: "Périgueux",
    geometry: "point with halo",
    name_of_heresy_id: "C0001 #C1262",
    name_of_heresy_label: "heresis #secta",
    name_of_heretics_id: null,
    name_of_heretics_label: "#VALUE!",
    connotations_heresy_id: "C1104 #C3718 #C1295 #C1296 #C1297 #C1298",
    connotations_heresy_label:
      "nova heresis #pseudoapostoli #ministri totius iniquitatis #secta perversa #secta occulta #secta decipiens",
    heretic_id: "G0043",
    heretic_label: "pseudoapostoli Petragorenses",
    heretics_amount_id: "C1303",
    heretics_amount_label: "quamplures/ia",
    heretics_social_characterization_id: "C1075 #C0455 #C1271 #C1078 #C1241",
    heretics_social_characterization_label:
      "laici #clerici #presbyteri #monachi #monache",
    instigator_to_heresy_id: "C1067",
    instigator_to_heresy_label: "not stated by the source",
    repressor_id: null,
    repressor_label: "#VALUE!",
    person_or_groups_other_id: null,
    person_or_groups_other_label: "#VALUE!",
    dealing_with_them_id: "C1067",
    dealing_with_them_label: "not stated by the source",
    outcome_id: "C1067",
    outcome_label: "not stated by the source",
    "Unnamed: 40": null,
    execution_location_type_id: null,
    beliefs_id: "[C2323] #[C1064]",
    beliefs_label:
      "heterodox attitude to Trinity #rejection of Eucharist as sacrament",
    practice_id:
      "[C0800] #[C1152] #[C1066] #[C1304] #[C1305] #[C1306] #[C1256] #[C1152] #[C1307] #[C1308] #[C1309] #[C1151] #[C1054] #[C1310]",
    practice_label:
      "vita apostolica #rejection of material churches #avoidance of meat #reduction of alcohol consumption #multiple genuflections #rejection of money #common property #rejection of material churches #poverty-motivated rejection of almsgiving #rejection of Mass #rejection of ecclesiastical canticles #feigned orthodoxy #disrespect for cross #disrespect for effigies of Christ",
    note: "In a later redaction of the text from the third part of the 12th century at the end of the letter, there is a warning regarding possible missions of heretics in Germany.\n#In the latest redaction of the text from the end of the 12th century there is information about the heresiarch of heretics named Pontius.",
  },
  E0019: {
    id: "E0019",
    label: "ascetic heretics of Monteforte",
    detail_case_summary:
      'A detailed account of the heretics of Monteforte, an unidentified fortress near Turin, who were discovered around 1028 and described by Landulf Senior in the "Historia Mediolanensis". Much of the reference consists of a dialogue between Archbishop Aribert and a representative of the heretics, Gerard. The heretics were sentenced to death by burning.',
    label_and_source_concatenated:
      "ascetic heretics of Monteforte (Landulphus Maioris, Historia Mediolanensis)",
    case_id: "E1008",
    case_label: "ascetic heretics of Monteforte",
    text_id: "T81",
    text_label: "Historia Mediolanensis",
    year_start_post_quem: "~1028",
    year_start_ante_quem: "~1028",
    year_end_post_quem: "~1028",
    year_end_ante_quem: "~1028",
    year_approximate: "y",
    location_id: "L0004 #L0006 #L0005 #L0003",
    location_label:
      "castellum [supra locum qui Monsfortis vocatur] #Monsfortis #Taurinum #Mediolanum",
    location_primary_id: "L0005",
    location_primary_label: "Torino",
    geometry: "point with halo",
    name_of_heresy_id: "C0001",
    name_of_heresy_label: "heresis",
    name_of_heretics_id: null,
    name_of_heretics_label: "#VALUE!",
    connotations_heresy_id: "C1105 #C1346 #C1347 #C3515 #C2282 #C1091",
    connotations_heresy_label:
      "heresis inaudita #astutia #ingenium pravum #nefandissimi/e #falsa rudimenta #perfidia",
    heretic_id: "P0029 #G0031 #P0030",
    heretic_label:
      "Girardus #[incole castri Montis Fortis] #comitissa Montis Fortis",
    heretics_amount_id: "[C1069]",
    heretics_amount_label: "plures/a",
    heretics_social_characterization_id: "C2881",
    heretics_social_characterization_label: "includes noble(s)",
    instigator_to_heresy_id: "G0029",
    instigator_to_heresy_label: "heretici ex incognita orbis parte",
    repressor_id: "P0001 #G0005 #G0028",
    repressor_label:
      "Heribertus archiepiscopus Mediolani #milites [a Heriberto Montefortem missi] #maiores laici Mediolani",
    person_or_groups_other_id: "G0030 #G0027",
    person_or_groups_other_label:
      "homines presentes inquisitione hereticorum Montis Fortis #rustici [conventi Medionani]",
    dealing_with_them_id: "C1265 #C1266",
    dealing_with_them_label: "hearing #apprehension",
    outcome_id: "C1051 #C2297 #C1063",
    outcome_label:
      "reconversion to Catholicism #death by mob lynching #burning",
    "Unnamed: 40": null,
    execution_location_type_id: null,
    beliefs_id: "[C1252] #[C0052] #[C2323] #[C1258]",
    beliefs_label:
      "God is the Creator #errores #heterodox attitude to Trinity #human birth through parthenogenesis",
    practice_id:
      "[C1253] #[C1254] #[C1066] #[C1062] #[C1255] #[C2324] #[C1256] #[C2329] #[C2256] #[C1251] #[C2322] #[C2326] #[C2330]",
    practice_label:
      "chastity #endorsement of white marriage #avoidance of meat #fasting #constant prayers #alternative Church ministers #common property #preparedness for martyrdom #acceptance of the Old and the New Testament #rejection of the Roman Church #heretical pope #proselytization #undergoing martyrdom",
    note: 'Turin and Milan are not the actual locations of heresy. The hearing of the heretics took place in Turin, while in Milan, they had their trial and were killed by some laics, though the archbishop was against capital punishment.\n#Landulph relates that heretics must have come from outside, an unknown part of Italy.\n#The social character of all the heretics is unknown; however, there was at least one noble - the countess of the fortress.\n#The term "God is the Creator" used in the beliefs refers to the passage in the source in which the heretics acknowledge that the world was indeed created by God: "Quod dixi Patrem, Deus est eternus, qui omnia ut ab initio, et in quo omnia consistunt".',
  },
  E0020: {
    id: "E0020",
    label: "ascetic heretics of Monteforte",
    detail_case_summary:
      'An account of the heretics of Monteforte, an unidentified fortress near Turin, who were discovered around 1028 and described by Rodulfus Glaber in the "Historiarum Libri Quinque". Rodulfus also describes a diabolical attempt by a female heretic to convert a dying knight in a nearby fortress.',
    label_and_source_concatenated:
      "ascetic heretics of Monteforte (Rodulfus Glabrus, Historiarum Libri Quinque)",
    case_id: "E1008",
    case_label: "ascetic heretics of Monteforte",
    text_id: "T82",
    text_label: "Historiarum Libri Quinque",
    year_start_post_quem: "~1028",
    year_start_ante_quem: "~1028",
    year_end_post_quem: "~1028",
    year_end_ante_quem: "~1028",
    year_approximate: "y",
    location_id: "L0006 #L0001 #L0002",
    location_label: "Monsfortis #Longobardia #castrum [in Lombardia]",
    location_primary_id: "L0005",
    location_primary_label: "Torino",
    geometry: "point with halo",
    name_of_heresy_id: "C0001 #C1262",
    name_of_heresy_label: "heresis #secta",
    name_of_heretics_id: null,
    name_of_heretics_label: "#VALUE!",
    connotations_heresy_id: "C0002 #C1348",
    connotations_heresy_label: "heretica pravitas #secta nequitie",
    heretic_id: "G0031\n#P0034",
    heretic_label:
      "[incole castri Montis Fortis] #mulier revera ex castro hereticorum",
    heretics_amount_id: "[C1069]",
    heretics_amount_label: "plures/a",
    heretics_social_characterization_id: "C2881",
    heretics_social_characterization_label: "includes noble(s)",
    instigator_to_heresy_id: null,
    instigator_to_heresy_label: "#VALUE!",
    repressor_id: "P0031 #P0032 #G0032 #G0033",
    repressor_label:
      "Mainfredus marchio Taurinorum et Segusianorum #Alricus episcopus Astensis #marchiones Longobardenses #presules Longobardenses",
    person_or_groups_other_id: "#P0033 #G0034 #P0035",
    person_or_groups_other_label:
      "Hugo miles #[demones qui Hugoni apparuerunt] #[Satan]",
    dealing_with_them_id: "C1990 #C1266",
    dealing_with_them_label: "military action #apprehension",
    outcome_id: "C1063",
    outcome_label: "burning",
    "Unnamed: 40": null,
    execution_location_type_id: null,
    beliefs_id: "C1067",
    beliefs_label: "not stated by the source",
    practice_id: "[C2879] #[C2326] #[C2330]",
    practice_label: "idolatry #proselytization #undergoing martyrdom",
    note: 'Instead of the terms "prime fraudis auctor" and "princeps [demonum]" in the "other persons" section, [Satan] was used. In the same section, instead of  "exercitus in nigerrimis vestibus et faciebus teterrimis", the term [demones qui Hugoni apparuerunt] was used. These hypothetical persons appeared in the vision of Hugo, a knight on his deathbed, whom the heretics wanted to convert to their heresy.',
  },
  E0034: {
    id: "E0034",
    label: "manicheans at Charroux",
    detail_case_summary:
      'In the "Chronicon Aquitanicum et Francicum", Adhemar of Chabannes writes about a synod convened by William, Duke of Aquitaine, and held at Charroux in 1028 to combat the spread of the Manichaean heresy.',
    label_and_source_concatenated:
      "manicheans at Charroux (Ademarus Cabannensis, Chronicon Aquitanicum et Francicum)",
    case_id: "E1015",
    case_label: "manicheans at Charroux",
    text_id: "T83",
    text_label: "Chronicon Aquitanicum et Francicum",
    year_start_post_quem: "1028",
    year_start_ante_quem: "1028",
    year_end_post_quem: "1028",
    year_end_ante_quem: "1028",
    year_approximate: "n",
    location_id: "L0045",
    location_label: "Carrofum",
    location_primary_id: "L0045",
    location_primary_label: "Charroux (Vienne)",
    geometry: "point",
    name_of_heresy_id: "C0001",
    name_of_heresy_label: "heresis",
    name_of_heretics_id: "C1059",
    name_of_heretics_label: "manichei",
    connotations_heresy_id: null,
    connotations_heresy_label: "#VALUE!",
    heretic_id: "G0045\n#G0044",
    heretic_label:
      "manichei [apud Carrofum] #vulgus [secratores manichei Carrofenses]",
    heretics_amount_id: "[C1069]",
    heretics_amount_label: "plures/a",
    heretics_social_characterization_id: "C1354",
    heretics_social_characterization_label: "vulgus",
    instigator_to_heresy_id: "C1067",
    instigator_to_heresy_label: "not stated by the source",
    repressor_id: "P0046 #G0046",
    repressor_label:
      "Willelmus dux Aquitanensium #concilium episcoporum et abbatum [congregatum Carrofi]",
    person_or_groups_other_id: "G0047",
    person_or_groups_other_label: "omnes Aquitanie principes",
    dealing_with_them_id: "C1067",
    dealing_with_them_label: "not stated by the source",
    outcome_id: "C1067",
    outcome_label: "not stated by the source",
    "Unnamed: 40": null,
    execution_location_type_id: null,
    beliefs_id: "C1067",
    beliefs_label: "not stated by the source",
    practice_id: "C1067",
    practice_label: "not stated by the source",
    note: 'Another example of Duke William\'s attempt to combat heretics is mentioned in his document from 1016 (name of the case: "Arians in Poitou").',
  },
  E0035: {
    id: "E0035",
    label: "heretics in Italy and Greece",
    detail_case_summary:
      'Gerard of Csanad, in his "Deliberatio supra hymnum trium puerorum," gives information concerning heretics found in Italy and Greece in his time as Bishop of Csanad (c. 1040). He lists their heretical errors, which are mainly against cult and of an eschatological nature.',
    label_and_source_concatenated:
      "heretics in Italy and Greece (Gerardus episcopus Csanadiensis, Deliberatio supra hymnum trium puerorum)",
    case_id: "E1016",
    case_label: "heretics in Italy and Greece",
    text_id: "T104",
    text_label: "Deliberatio supra hymnum trium puerorum",
    year_start_post_quem: "1030",
    year_start_ante_quem: "1047",
    year_end_post_quem: "1030",
    year_end_ante_quem: "1047",
    year_approximate: "y",
    location_id: "L0047 #L0046 #L0010",
    location_label: "Gretia #Verona #Ravenna",
    location_primary_id: "L0046 #L0010",
    location_primary_label: "Verona #Ravenna",
    geometry: "polyline",
    name_of_heresy_id: "C0001",
    name_of_heresy_label: "heresis",
    name_of_heretics_id: null,
    name_of_heretics_label: "#VALUE!",
    connotations_heresy_id: "C1355 #C1105 #C1356",
    connotations_heresy_label:
      "filii diaboli #heresis inaudita #potestas tenebrarum",
    heretic_id: "G0116",
    heretic_label: "[heretici in Italia et Gretia]",
    heretics_amount_id: "[C0671]",
    heretics_amount_label: "multi/e/a",
    heretics_social_characterization_id: "C1067",
    heretics_social_characterization_label: "not stated by the source",
    instigator_to_heresy_id: "C1067",
    instigator_to_heresy_label: "not stated by the source",
    repressor_id: null,
    repressor_label: "#VALUE!",
    person_or_groups_other_id: null,
    person_or_groups_other_label: "#VALUE!",
    dealing_with_them_id: "C1067",
    dealing_with_them_label: "not stated by the source",
    outcome_id: "C1067",
    outcome_label: "not stated by the source",
    "Unnamed: 40": null,
    execution_location_type_id: null,
    beliefs_id: "[C1361] #[C1358] #[C1357]",
    beliefs_label:
      "rejection of Christ #rejection of almsgiving for the salvation of the dead #disbelief in the resurrection of the dead",
    practice_id: "[C1359] #[C1152] #[C1360]",
    practice_label:
      "rejection of cult #rejection of material churches #rejection of clergy",
    note: "Gerard of Csanad has very good knowledge of heresies, i.e. he is highly aware of the doctrines of Manicheans (i.e. dualism) and does not give ancient names to the heretical movements of his time.",
  },
  E0029: {
    id: "E0029",
    label: "manicheans at Châlons",
    detail_case_summary:
      'Anselm of Liège in the "Gesta episcoporum Tungrensium, Traiectensium, et Leodiensium" gives a paraphrase of the unknown letter of Roger, Bishop of Châlons to Wazo, Bishop of Liège, in which he asks him to help find a way of fighting heretics in his diocese.',
    label_and_source_concatenated:
      "manicheans at Châlons (Anselmus Leodiensis, Herigerus Lobiensis, Gesta episcoporum Tungrensium, Traiectensium, et Leodiensium)",
    case_id: "E1011",
    case_label: "manicheans at Châlons",
    text_id: "T100",
    text_label: "Gesta episcoporum Tungrensium, Traiectensium, et Leodiensium",
    year_start_post_quem: "1043",
    year_start_ante_quem: "1048",
    year_end_post_quem: "1043",
    year_end_ante_quem: "1048",
    year_approximate: "y",
    location_id: "L0115",
    location_label: "diocesis Catalaunensis",
    location_primary_id: "L0014",
    location_primary_label: "Châlons-en-Champagne",
    geometry: "point",
    name_of_heresy_id: "C1286 #C0122",
    name_of_heresy_label: "dogma manicheorum #error",
    name_of_heretics_id: null,
    name_of_heretics_label: "#VALUE!",
    connotations_heresy_id: "C1090 #C3542 #C1726 #C1612 #C0543 #C1860",
    connotations_heresy_label:
      "dogma perversum #obscenus/a/um #turpis/e #sacrilegus/a/um #blasphemia #perditio",
    heretic_id: "[G0041]",
    heretic_label: "[heretici Catalaunenses]",
    heretics_amount_id: "[C1069]",
    heretics_amount_label: "plures/a",
    heretics_social_characterization_id: "C1169 #C1161 #C1287",
    heretics_social_characterization_label: "rustici #idiote #infacundi",
    instigator_to_heresy_id: "C1067",
    instigator_to_heresy_label: "not stated by the source",
    repressor_id: "P0043 #P0044",
    repressor_label:
      "Rotgerus episcopus Catalaunensis #Wazo episcopus Leodiensis",
    person_or_groups_other_id: null,
    person_or_groups_other_label: "#VALUE!",
    dealing_with_them_id: "C1067",
    dealing_with_them_label: "not stated by the source",
    outcome_id: "C1067",
    outcome_label: "not stated by the source",
    "Unnamed: 40": null,
    execution_location_type_id: null,
    beliefs_id: "[C3250]",
    beliefs_label: "heterodox attitude to the Holy Spirit",
    practice_id:
      "[C3362] #[C3246] #[C1242] #[C3244] #[C2326] #[C1082] #[C1066] #[C1284]",
    practice_label:
      "conventicula hereticorum #odious practices #imposition of hands #cult of heresiarch #proselytization #rejection of marriage as sacrament #avoidance of meat #rejection of killing animals",
    note: 'The source "Gesta episcoporum Tungrensium, Traiectensium, et Leodiensium" has been divided here into two parts as it consists of two components: a paraphrase of Roger of Châlons\' letter to Wazo of Liège and Wazo\'s reply to Roger.\n#The practice of "odious practices" refers to a passage of the source in which it mentions secret conventicles of heretics where they allegedly committed unspecified filthy acts.\n#The practice of "cult of heresiarch" refers to the alleged cult of heresiarch Mani that heretics were supposed to practice.',
  },
  E0030: {
    id: "E0030",
    label: "manicheans at Châlons",
    detail_case_summary:
      "A letter of Wazo of Liège to Roger II of Châlons cited in Anselm of Liège's \"Gesta episcoporum Tungrensium, Traiectensium, et Leodiensium\". Wazo gives Roger directions on how to approach and fight heretics present in Roger's diocese.",
    label_and_source_concatenated:
      "manicheans at Châlons (Wazo episcopus Leodiensis, epistola Wazoni episcopi Leodiensis (in: Gesta episcoporum Tungrensium, Traiectensium, et Leodiensium))",
    case_id: "E1011",
    case_label: "manicheans at Châlons",
    text_id: "T144",
    text_label:
      "epistola Wazoni episcopi Leodiensis (in: Gesta episcoporum Tungrensium, Traiectensium, et Leodiensium)",
    year_start_post_quem: "1043",
    year_start_ante_quem: "1048",
    year_end_post_quem: "1043",
    year_end_ante_quem: "1048",
    year_approximate: "y",
    location_id: "[L0115]",
    location_label: "diocesis Catalaunensis",
    location_primary_id: "L0014",
    location_primary_label: "Châlons-en-Champagne",
    geometry: "point",
    name_of_heresy_id: "C1047 #C0122 #C1262",
    name_of_heresy_label: "arriana heresis #error #secta",
    name_of_heretics_id: "C1293",
    name_of_heretics_label: "schismatici",
    connotations_heresy_id:
      "C3543 #C1292 #C3445 #C1586 #C3716 #C3545 #C1976 #C3544 #C1860 #C3249 #C1294",
    connotations_heresy_label:
      "insanissime blasphemie #sacrilegium #errantes #zizania #diabolica fraus #prevaricatores #impietas #peccatores #perditio #diaboli laquei #immunda secta",
    heretic_id: "[G0041]",
    heretic_label: "[heretici Catalaunenses]",
    heretics_amount_id: null,
    heretics_amount_label: "#VALUE!",
    heretics_social_characterization_id: "C1067",
    heretics_social_characterization_label: "not stated by the source",
    instigator_to_heresy_id: "C1067",
    instigator_to_heresy_label: "not stated by the source",
    repressor_id: "[P0044]",
    repressor_label: "Wazo episcopus Leodiensis",
    person_or_groups_other_id: null,
    person_or_groups_other_label: "#VALUE!",
    dealing_with_them_id: null,
    dealing_with_them_label: "#VALUE!",
    outcome_id: "C1106",
    outcome_label: "excommunication",
    "Unnamed: 40": null,
    execution_location_type_id: null,
    beliefs_id: "[C3250]",
    beliefs_label: "heterodox attitude to the Holy Spirit",
    practice_id: "[C1291] #[C1993]",
    practice_label: "rejection of killing #feigned piety",
    note: "The source \"Gesta episcoporum Tungrensium, Traiectensium, et Leodiensium\" has been divided here into two parts as it consists of two components: a paraphrase of Roger of Châlons' letter to Wazo of Liège and Wazo's reply to Roger.\n#Wazo of Liège recounts the example of saint Martin of Tours and the parable of the Tares and urges Bishop Roger to do the same with heretics as in the parable. Wazo expresses hope for a possible future conversion of heretics. Wazo encourages the excommunication of heretics as well as those who help them but stipulates that capital punishment is reserved only for secular authorities.\n#Anselm reports that at that time many innocent people were killed in France for the mere suspicion of heresy that stemmed from the pale skin of some people.",
  },
  E0031: {
    id: "E0031",
    label: "heretics in Gaul",
    detail_case_summary:
      "During the synod at Reims in 1049, Pope Leon IX excommunicates an unidentified group of heretics in Gaul and everyone who wishes to support them in any way.",
    label_and_source_concatenated:
      "heretics in Gaul (Anselmus Remensis, Historia dedicationis ecclesiae Sancti Remigii apud Remos)",
    case_id: "E1012",
    case_label: "heretics in Gaul",
    text_id: "T101",
    text_label: "Historia dedicationis ecclesiae Sancti Remigii apud Remos",
    year_start_post_quem: "1049",
    year_start_ante_quem: "1049",
    year_end_post_quem: "1049",
    year_end_ante_quem: "1049",
    year_approximate: "n",
    location_id: "L0009",
    location_label: "Galia",
    location_primary_id: "L0065H",
    location_primary_label: "Reims",
    geometry: "point with halo",
    name_of_heresy_id: "[C0001]",
    name_of_heresy_label: "heresis",
    name_of_heretics_id: null,
    name_of_heretics_label: "#VALUE!",
    connotations_heresy_id: "[C1104]",
    connotations_heresy_label: "nova heresis",
    heretic_id: "G0042",
    heretic_label: "[heretici in Galia]",
    heretics_amount_id: "C1067",
    heretics_amount_label: "not stated by the source",
    heretics_social_characterization_id: "C1067",
    heretics_social_characterization_label: "not stated by the source",
    instigator_to_heresy_id: "C1067",
    instigator_to_heresy_label: "not stated by the source",
    repressor_id: "P0045",
    repressor_label: "Leo episcopus Rome",
    person_or_groups_other_id: "G0115",
    person_or_groups_other_label: "synodum [Remis congregatum]",
    dealing_with_them_id: null,
    dealing_with_them_label: "#VALUE!",
    outcome_id: "C1106",
    outcome_label: "excommunication",
    "Unnamed: 40": null,
    execution_location_type_id: null,
    beliefs_id: "C1067",
    beliefs_label: "not stated by the source",
    practice_id: "C1067",
    practice_label: "not stated by the source",
    note: null,
  },
  E0082: {
    id: "E0082",
    label: "Berengarian heresy (synod at Rome, 1050)",
    detail_case_summary:
      "A synod called by Pope Leo IX, without the participation of Berengar of Tours. During it, Berengar's letter to Lanfranc of Bec was read. Lanfranc disowned Berengar's views. Berengar was excommunicated “in absentia” and summoned to appear at the next synod of Vercelli.",
    label_and_source_concatenated: "Berengarian heresy (synod at Rome, 1050)",
    case_id: "E1030",
    case_label: "Berengarian heresy",
    text_id: null,
    text_label: null,
    year_start_post_quem: "1049",
    year_start_ante_quem: "1049",
    year_end_post_quem: "1080",
    year_end_ante_quem: "1080",
    year_approximate: "n",
    location_id: "L0042",
    location_label: "Roma",
    location_primary_id: "L0110",
    location_primary_label: "Tours",
    geometry: "point",
    name_of_heresy_id: null,
    name_of_heresy_label: "#VALUE!",
    name_of_heretics_id: null,
    name_of_heretics_label: "#VALUE!",
    connotations_heresy_id: null,
    connotations_heresy_label: "#VALUE!",
    heretic_id: null,
    heretic_label: "#VALUE!",
    heretics_amount_id: null,
    heretics_amount_label: "#VALUE!",
    heretics_social_characterization_id: null,
    heretics_social_characterization_label: "#VALUE!",
    instigator_to_heresy_id: null,
    instigator_to_heresy_label: "#VALUE!",
    repressor_id: null,
    repressor_label: "#VALUE!",
    person_or_groups_other_id: null,
    person_or_groups_other_label: "#VALUE!",
    dealing_with_them_id: null,
    dealing_with_them_label: "#VALUE!",
    outcome_id: null,
    outcome_label: "#VALUE!",
    "Unnamed: 40": null,
    execution_location_type_id: null,
    beliefs_id: null,
    beliefs_label: "#VALUE!",
    practice_id: null,
    practice_label: "#VALUE!",
    note: null,
  },
  E0083: {
    id: "E0083",
    label: "Berengarian heresy (public debate at Chartres, 1050)",
    detail_case_summary:
      "The public debate of Berengar with Chartres clerics. We know the names of three of them: William, Arnulf, and Ascelin. During the debate, it turned out that Berengar had not yet read the entire treatise of John Eriugena to which he was referring (in fact, it was a treatise on the Eucharist written by Ratramnus, not Eriugena). We can interpret the result of the debate as Berengar's failure.",
    label_and_source_concatenated:
      "Berengarian heresy (public debate at Chartres, 1050)",
    case_id: "E1030",
    case_label: "Berengarian heresy",
    text_id: null,
    text_label: null,
    year_start_post_quem: "1049",
    year_start_ante_quem: "1049",
    year_end_post_quem: "1080",
    year_end_ante_quem: "1080",
    year_approximate: "n",
    location_id: "L0019",
    location_label: "Carnotum",
    location_primary_id: "L0110",
    location_primary_label: "Tours",
    geometry: "point",
    name_of_heresy_id: null,
    name_of_heresy_label: "#VALUE!",
    name_of_heretics_id: null,
    name_of_heretics_label: "#VALUE!",
    connotations_heresy_id: null,
    connotations_heresy_label: "#VALUE!",
    heretic_id: null,
    heretic_label: "#VALUE!",
    heretics_amount_id: null,
    heretics_amount_label: "#VALUE!",
    heretics_social_characterization_id: null,
    heretics_social_characterization_label: "#VALUE!",
    instigator_to_heresy_id: null,
    instigator_to_heresy_label: "#VALUE!",
    repressor_id: null,
    repressor_label: "#VALUE!",
    person_or_groups_other_id: null,
    person_or_groups_other_label: "#VALUE!",
    dealing_with_them_id: null,
    dealing_with_them_label: "#VALUE!",
    outcome_id: null,
    outcome_label: "#VALUE!",
    "Unnamed: 40": null,
    execution_location_type_id: null,
    beliefs_id: null,
    beliefs_label: "#VALUE!",
    practice_id: null,
    practice_label: "#VALUE!",
    note: null,
  },
  E0084: {
    id: "E0084",
    label: "Berengarian heresy (synod at Vercelli, 1050)",
    detail_case_summary:
      "A synod convened by Pope Leo IX, without the participation of Berengar, who at that time was a prisoner of the King of France, Henry I. During the synod, the congregation read the treatise of Eriugena (Ratramnus). The treaty and Berengar were condemned. Two clerics present at the synod stood up for Berengar's views.",
    label_and_source_concatenated:
      "Berengarian heresy (synod at Vercelli, 1050)",
    case_id: "E1030",
    case_label: "Berengarian heresy",
    text_id: null,
    text_label: null,
    year_start_post_quem: "1049",
    year_start_ante_quem: "1049",
    year_end_post_quem: "1080",
    year_end_ante_quem: "1080",
    year_approximate: "n",
    location_id: "L0111",
    location_label: "Vercelle",
    location_primary_id: "L0110",
    location_primary_label: "Tours",
    geometry: "point",
    name_of_heresy_id: null,
    name_of_heresy_label: "#VALUE!",
    name_of_heretics_id: null,
    name_of_heretics_label: "#VALUE!",
    connotations_heresy_id: null,
    connotations_heresy_label: "#VALUE!",
    heretic_id: null,
    heretic_label: "#VALUE!",
    heretics_amount_id: null,
    heretics_amount_label: "#VALUE!",
    heretics_social_characterization_id: null,
    heretics_social_characterization_label: "#VALUE!",
    instigator_to_heresy_id: null,
    instigator_to_heresy_label: "#VALUE!",
    repressor_id: null,
    repressor_label: "#VALUE!",
    person_or_groups_other_id: null,
    person_or_groups_other_label: "#VALUE!",
    dealing_with_them_id: null,
    dealing_with_them_label: "#VALUE!",
    outcome_id: null,
    outcome_label: "#VALUE!",
    "Unnamed: 40": null,
    execution_location_type_id: null,
    beliefs_id: null,
    beliefs_label: "#VALUE!",
    practice_id: null,
    practice_label: "#VALUE!",
    note: null,
  },
  E0085: {
    id: "E0085",
    label: "Berengarian heresy (synod at Brionne, 1050)",
    detail_case_summary:
      "After paying Henry I a large sum, Berengar was released and went to Normandy. He took part in a synod at Brionne convened by Prince William the Bastard. Lanfranc's presence at the synod is uncertain. Berengar was accompanied by one clerk unknown by name. Berengar was condemned by the synod.",
    label_and_source_concatenated:
      "Berengarian heresy (synod at Brionne, 1050)",
    case_id: "E1030",
    case_label: "Berengarian heresy",
    text_id: null,
    text_label: null,
    year_start_post_quem: "1049",
    year_start_ante_quem: "1049",
    year_end_post_quem: "1080",
    year_end_ante_quem: "1080",
    year_approximate: "n",
    location_id: "L0112",
    location_label: "Brionnum",
    location_primary_id: "L0110",
    location_primary_label: "Tours",
    geometry: "point",
    name_of_heresy_id: null,
    name_of_heresy_label: "#VALUE!",
    name_of_heretics_id: null,
    name_of_heretics_label: "#VALUE!",
    connotations_heresy_id: null,
    connotations_heresy_label: "#VALUE!",
    heretic_id: null,
    heretic_label: "#VALUE!",
    heretics_amount_id: null,
    heretics_amount_label: "#VALUE!",
    heretics_social_characterization_id: null,
    heretics_social_characterization_label: "#VALUE!",
    instigator_to_heresy_id: null,
    instigator_to_heresy_label: "#VALUE!",
    repressor_id: null,
    repressor_label: "#VALUE!",
    person_or_groups_other_id: null,
    person_or_groups_other_label: "#VALUE!",
    dealing_with_them_id: null,
    dealing_with_them_label: "#VALUE!",
    outcome_id: null,
    outcome_label: "#VALUE!",
    "Unnamed: 40": null,
    execution_location_type_id: null,
    beliefs_id: null,
    beliefs_label: "#VALUE!",
    practice_id: null,
    practice_label: "#VALUE!",
    note: null,
  },
  E0086: {
    id: "E0086",
    label: "Berengarian heresy (synod at Paris, 1051)",
    detail_case_summary:
      "A synod called by the King of France, Henry I, without the participation of Berengar of Tours. During the synod, a letter from Berengar to Paulinus, primicerius of Metz, was read out (the letter is lost, but Paulin's earlier letter to Berengar is known). Prior to its convocation, the king received a letter from Theoduin, Bishop of Liège, who reproached Berengar for three errors: unbelief in the real presence of Christ in the Eucharist, opposition to the baptism of children, and a misconception of the sacrament of marriage. Theoduin also tried to persuade Henry not to convene a synod, as Berengar had already been judged by the Pope. The Synod of Paris condemned Berengar and his student, Eusebius Bruno.",
    label_and_source_concatenated: "Berengarian heresy (synod at Paris, 1051)",
    case_id: "E1030",
    case_label: "Berengarian heresy",
    text_id: null,
    text_label: null,
    year_start_post_quem: "1049",
    year_start_ante_quem: "1049",
    year_end_post_quem: "1080",
    year_end_ante_quem: "1080",
    year_approximate: "n",
    location_id: "L0098",
    location_label: "Parisis",
    location_primary_id: "L0110",
    location_primary_label: "Tours",
    geometry: "point",
    name_of_heresy_id: null,
    name_of_heresy_label: "#VALUE!",
    name_of_heretics_id: null,
    name_of_heretics_label: "#VALUE!",
    connotations_heresy_id: null,
    connotations_heresy_label: "#VALUE!",
    heretic_id: null,
    heretic_label: "#VALUE!",
    heretics_amount_id: null,
    heretics_amount_label: "#VALUE!",
    heretics_social_characterization_id: null,
    heretics_social_characterization_label: "#VALUE!",
    instigator_to_heresy_id: null,
    instigator_to_heresy_label: "#VALUE!",
    repressor_id: null,
    repressor_label: "#VALUE!",
    person_or_groups_other_id: null,
    person_or_groups_other_label: "#VALUE!",
    dealing_with_them_id: null,
    dealing_with_them_label: "#VALUE!",
    outcome_id: null,
    outcome_label: "#VALUE!",
    "Unnamed: 40": null,
    execution_location_type_id: null,
    beliefs_id: null,
    beliefs_label: "#VALUE!",
    practice_id: null,
    practice_label: "#VALUE!",
    note: null,
  },
  E0087: {
    id: "E0087",
    label: "Berengarian heresy (synod at unknown location, ~1051-1054)",
    detail_case_summary:
      "Durand of Troarn writes about a certain synod at an unknown place, which took place somewhere between 1051 and 1054. Berengar of Tours and Eusebius Bruno were present there and professed their Catholic faith.",
    label_and_source_concatenated:
      "Berengarian heresy (synod at unknown location, ~1051-1054)",
    case_id: "E1030",
    case_label: "Berengarian heresy",
    text_id: null,
    text_label: null,
    year_start_post_quem: "1049",
    year_start_ante_quem: "1049",
    year_end_post_quem: "1080",
    year_end_ante_quem: "1080",
    year_approximate: "n",
    location_id: null,
    location_label: "#VALUE!",
    location_primary_id: "L0110",
    location_primary_label: "Tours",
    geometry: "point",
    name_of_heresy_id: null,
    name_of_heresy_label: "#VALUE!",
    name_of_heretics_id: null,
    name_of_heretics_label: "#VALUE!",
    connotations_heresy_id: null,
    connotations_heresy_label: "#VALUE!",
    heretic_id: null,
    heretic_label: "#VALUE!",
    heretics_amount_id: null,
    heretics_amount_label: "#VALUE!",
    heretics_social_characterization_id: null,
    heretics_social_characterization_label: "#VALUE!",
    instigator_to_heresy_id: null,
    instigator_to_heresy_label: "#VALUE!",
    repressor_id: null,
    repressor_label: "#VALUE!",
    person_or_groups_other_id: null,
    person_or_groups_other_label: "#VALUE!",
    dealing_with_them_id: null,
    dealing_with_them_label: "#VALUE!",
    outcome_id: null,
    outcome_label: "#VALUE!",
    "Unnamed: 40": null,
    execution_location_type_id: null,
    beliefs_id: null,
    beliefs_label: "#VALUE!",
    practice_id: null,
    practice_label: "#VALUE!",
    note: null,
  },
  E0088: {
    id: "E0088",
    label: "Berengarian heresy (synod at Tours, 1054)",
    detail_case_summary:
      "A synod presided over by papal legate Hildebrand. Not only the clergy of Anjou were present at the meeting, but also the Bishops of Orléans and Auxerre, and the Archbishop of Tours. At the synod, Berengar dismissed the charge of ever claiming that consecrated bread was no different from ordinary bread. Berengar makes an orthodox profession of faith (text unknown). The synod is interrupted by the sudden news of the death of Pope Leo IX, because of which Hildebrand must return to Rome.",
    label_and_source_concatenated: "Berengarian heresy (synod at Tours, 1054)",
    case_id: "E1030",
    case_label: "Berengarian heresy",
    text_id: null,
    text_label: null,
    year_start_post_quem: "1049",
    year_start_ante_quem: "1049",
    year_end_post_quem: "1080",
    year_end_ante_quem: "1080",
    year_approximate: "n",
    location_id: "L0110",
    location_label: "Turonum",
    location_primary_id: "L0110",
    location_primary_label: "Tours",
    geometry: "point",
    name_of_heresy_id: null,
    name_of_heresy_label: "#VALUE!",
    name_of_heretics_id: null,
    name_of_heretics_label: "#VALUE!",
    connotations_heresy_id: null,
    connotations_heresy_label: "#VALUE!",
    heretic_id: null,
    heretic_label: "#VALUE!",
    heretics_amount_id: null,
    heretics_amount_label: "#VALUE!",
    heretics_social_characterization_id: null,
    heretics_social_characterization_label: "#VALUE!",
    instigator_to_heresy_id: null,
    instigator_to_heresy_label: "#VALUE!",
    repressor_id: null,
    repressor_label: "#VALUE!",
    person_or_groups_other_id: null,
    person_or_groups_other_label: "#VALUE!",
    dealing_with_them_id: null,
    dealing_with_them_label: "#VALUE!",
    outcome_id: null,
    outcome_label: "#VALUE!",
    "Unnamed: 40": null,
    execution_location_type_id: null,
    beliefs_id: null,
    beliefs_label: "#VALUE!",
    practice_id: null,
    practice_label: "#VALUE!",
    note: null,
  },
  E0089: {
    id: "E0089",
    label: "Berengarian heresy (synod at Rome, 1059)",
    detail_case_summary:
      "A synod convened by Pope Nicholas II. According to Berengar's testimony, 113 bishops were present at the synod. Berengar accepted the creed of faith prepared by Humbert of Silva Candida, and had to throw the unorthodox books into the fire. After returning to Tours, Berengar wrote “Scriptum contra synodum” against the decision of the synod (the text is lost, but known in fragments because of the quotations of Lanfranc of Bec in his treatise “De corpore et sanguine Domini”).",
    label_and_source_concatenated: "Berengarian heresy (synod at Rome, 1059)",
    case_id: "E1030",
    case_label: "Berengarian heresy",
    text_id: null,
    text_label: null,
    year_start_post_quem: "1049",
    year_start_ante_quem: "1049",
    year_end_post_quem: "1080",
    year_end_ante_quem: "1080",
    year_approximate: "n",
    location_id: "L0042",
    location_label: "Roma",
    location_primary_id: "L0110",
    location_primary_label: "Tours",
    geometry: "point",
    name_of_heresy_id: null,
    name_of_heresy_label: "#VALUE!",
    name_of_heretics_id: null,
    name_of_heretics_label: "#VALUE!",
    connotations_heresy_id: null,
    connotations_heresy_label: "#VALUE!",
    heretic_id: null,
    heretic_label: "#VALUE!",
    heretics_amount_id: null,
    heretics_amount_label: "#VALUE!",
    heretics_social_characterization_id: null,
    heretics_social_characterization_label: "#VALUE!",
    instigator_to_heresy_id: null,
    instigator_to_heresy_label: "#VALUE!",
    repressor_id: null,
    repressor_label: "#VALUE!",
    person_or_groups_other_id: null,
    person_or_groups_other_label: "#VALUE!",
    dealing_with_them_id: null,
    dealing_with_them_label: "#VALUE!",
    outcome_id: null,
    outcome_label: "#VALUE!",
    "Unnamed: 40": null,
    execution_location_type_id: null,
    beliefs_id: null,
    beliefs_label: "#VALUE!",
    practice_id: null,
    practice_label: "#VALUE!",
    note: null,
  },
  E0090: {
    id: "E0090",
    label: "Berengarian heresy (synod at Angers, 1062)",
    detail_case_summary:
      "Among others, Eusebius Bruno, Hugo, Archbishop of Besançon, and Bulgrin, Bishop of Le Mans were present at the meeting. Berengar had once again made an orthodox profession of faith (text of the creed unknown).",
    label_and_source_concatenated: "Berengarian heresy (synod at Angers, 1062)",
    case_id: "E1030",
    case_label: "Berengarian heresy",
    text_id: null,
    text_label: null,
    year_start_post_quem: "1049",
    year_start_ante_quem: "1049",
    year_end_post_quem: "1080",
    year_end_ante_quem: "1080",
    year_approximate: "n",
    location_id: "L0076",
    location_label: "Andecavis",
    location_primary_id: "L0110",
    location_primary_label: "Tours",
    geometry: "point",
    name_of_heresy_id: null,
    name_of_heresy_label: "#VALUE!",
    name_of_heretics_id: null,
    name_of_heretics_label: "#VALUE!",
    connotations_heresy_id: null,
    connotations_heresy_label: "#VALUE!",
    heretic_id: null,
    heretic_label: "#VALUE!",
    heretics_amount_id: null,
    heretics_amount_label: "#VALUE!",
    heretics_social_characterization_id: null,
    heretics_social_characterization_label: "#VALUE!",
    instigator_to_heresy_id: null,
    instigator_to_heresy_label: "#VALUE!",
    repressor_id: null,
    repressor_label: "#VALUE!",
    person_or_groups_other_id: null,
    person_or_groups_other_label: "#VALUE!",
    dealing_with_them_id: null,
    dealing_with_them_label: "#VALUE!",
    outcome_id: null,
    outcome_label: "#VALUE!",
    "Unnamed: 40": null,
    execution_location_type_id: null,
    beliefs_id: null,
    beliefs_label: "#VALUE!",
    practice_id: null,
    practice_label: "#VALUE!",
    note: null,
  },
  E0091: {
    id: "E0091",
    label: "Berengarian heresy (synod at Poitiers, 1075)",
    detail_case_summary:
      "The synod of Poitiers was chaired by papal legate Gerald. Berengar made an orthodox profession of faith.",
    label_and_source_concatenated:
      "Berengarian heresy (synod at Poitiers, 1075)",
    case_id: "E1030",
    case_label: "Berengarian heresy",
    text_id: null,
    text_label: null,
    year_start_post_quem: "1049",
    year_start_ante_quem: "1049",
    year_end_post_quem: "1080",
    year_end_ante_quem: "1080",
    year_approximate: "n",
    location_id: "L0044",
    location_label: "Pictavis",
    location_primary_id: "L0110",
    location_primary_label: "Tours",
    geometry: "point",
    name_of_heresy_id: null,
    name_of_heresy_label: "#VALUE!",
    name_of_heretics_id: null,
    name_of_heretics_label: "#VALUE!",
    connotations_heresy_id: null,
    connotations_heresy_label: "#VALUE!",
    heretic_id: null,
    heretic_label: "#VALUE!",
    heretics_amount_id: null,
    heretics_amount_label: "#VALUE!",
    heretics_social_characterization_id: null,
    heretics_social_characterization_label: "#VALUE!",
    instigator_to_heresy_id: null,
    instigator_to_heresy_label: "#VALUE!",
    repressor_id: null,
    repressor_label: "#VALUE!",
    person_or_groups_other_id: null,
    person_or_groups_other_label: "#VALUE!",
    dealing_with_them_id: null,
    dealing_with_them_label: "#VALUE!",
    outcome_id: null,
    outcome_label: "#VALUE!",
    "Unnamed: 40": null,
    execution_location_type_id: null,
    beliefs_id: null,
    beliefs_label: "#VALUE!",
    practice_id: null,
    practice_label: "#VALUE!",
    note: null,
  },
  E0092: {
    id: "E0092",
    label: "Berengarian heresy (synod at Rome, 1078)",
    detail_case_summary:
      "One of Gregory VII's two annual synods. During the synod, Berengar made an orthodox profession of faith, which, however, was not accepted by all the assembled people as they feared Berengar's insincerity. Berengar was to be subjected to the hot-iron test, which was in the end canceled, and his case was postponed until the Lenten Synod. In the meantime, Alberic of Monte Cassino wrote his treatise on the Eucharist.",
    label_and_source_concatenated: "Berengarian heresy (synod at Rome, 1078)",
    case_id: "E1030",
    case_label: "Berengarian heresy",
    text_id: null,
    text_label: null,
    year_start_post_quem: "1049",
    year_start_ante_quem: "1049",
    year_end_post_quem: "1080",
    year_end_ante_quem: "1080",
    year_approximate: "n",
    location_id: "L0042",
    location_label: "Roma",
    location_primary_id: "L0110",
    location_primary_label: "Tours",
    geometry: "point",
    name_of_heresy_id: null,
    name_of_heresy_label: "#VALUE!",
    name_of_heretics_id: null,
    name_of_heretics_label: "#VALUE!",
    connotations_heresy_id: null,
    connotations_heresy_label: "#VALUE!",
    heretic_id: null,
    heretic_label: "#VALUE!",
    heretics_amount_id: null,
    heretics_amount_label: "#VALUE!",
    heretics_social_characterization_id: null,
    heretics_social_characterization_label: "#VALUE!",
    instigator_to_heresy_id: null,
    instigator_to_heresy_label: "#VALUE!",
    repressor_id: null,
    repressor_label: "#VALUE!",
    person_or_groups_other_id: null,
    person_or_groups_other_label: "#VALUE!",
    dealing_with_them_id: null,
    dealing_with_them_label: "#VALUE!",
    outcome_id: null,
    outcome_label: "#VALUE!",
    "Unnamed: 40": null,
    execution_location_type_id: null,
    beliefs_id: null,
    beliefs_label: "#VALUE!",
    practice_id: null,
    practice_label: "#VALUE!",
    note: null,
  },
  E0093: {
    id: "E0093",
    label: "Berengarian heresy (synod at Rome, 1079)",
    detail_case_summary:
      "Lenten Synod convened by Gregory VII. Berengar signed an orthodox profession of faith. The profession contained a clause stating that Berengar understood the content of the creed in the same way as the rest of the people present at the synod. After the Synod, Berengar was instructed by the Pope to retreat to some quiet place that he would never leave.",
    label_and_source_concatenated: "Berengarian heresy (synod at Rome, 1079)",
    case_id: "E1030",
    case_label: "Berengarian heresy",
    text_id: null,
    text_label: null,
    year_start_post_quem: "1049",
    year_start_ante_quem: "1049",
    year_end_post_quem: "1080",
    year_end_ante_quem: "1080",
    year_approximate: "n",
    location_id: "L0042",
    location_label: "Roma",
    location_primary_id: "L0110",
    location_primary_label: "Tours",
    geometry: "point",
    name_of_heresy_id: null,
    name_of_heresy_label: "#VALUE!",
    name_of_heretics_id: null,
    name_of_heretics_label: "#VALUE!",
    connotations_heresy_id: null,
    connotations_heresy_label: "#VALUE!",
    heretic_id: null,
    heretic_label: "#VALUE!",
    heretics_amount_id: null,
    heretics_amount_label: "#VALUE!",
    heretics_social_characterization_id: null,
    heretics_social_characterization_label: "#VALUE!",
    instigator_to_heresy_id: null,
    instigator_to_heresy_label: "#VALUE!",
    repressor_id: null,
    repressor_label: "#VALUE!",
    person_or_groups_other_id: null,
    person_or_groups_other_label: "#VALUE!",
    dealing_with_them_id: null,
    dealing_with_them_label: "#VALUE!",
    outcome_id: null,
    outcome_label: "#VALUE!",
    "Unnamed: 40": null,
    execution_location_type_id: null,
    beliefs_id: null,
    beliefs_label: "#VALUE!",
    practice_id: null,
    practice_label: "#VALUE!",
    note: null,
  },
  E0094: {
    id: "E0094",
    label: "Berengarian heresy (synod at Bordeaux, 1080)",
    detail_case_summary:
      "The last synod to raise the issue of Berengar of Tours. Berengar was present, and at the end had to make an orthodox profession of faith.",
    label_and_source_concatenated:
      "Berengarian heresy (synod at Bordeaux, 1080)",
    case_id: "E1030",
    case_label: "Berengarian heresy",
    text_id: null,
    text_label: null,
    year_start_post_quem: "1049",
    year_start_ante_quem: "1049",
    year_end_post_quem: "1080",
    year_end_ante_quem: "1080",
    year_approximate: "n",
    location_id: "L0080",
    location_label: "Burdigala",
    location_primary_id: "L0110",
    location_primary_label: "Tours",
    geometry: "point",
    name_of_heresy_id: null,
    name_of_heresy_label: "#VALUE!",
    name_of_heretics_id: null,
    name_of_heretics_label: "#VALUE!",
    connotations_heresy_id: null,
    connotations_heresy_label: "#VALUE!",
    heretic_id: null,
    heretic_label: "#VALUE!",
    heretics_amount_id: null,
    heretics_amount_label: "#VALUE!",
    heretics_social_characterization_id: null,
    heretics_social_characterization_label: "#VALUE!",
    instigator_to_heresy_id: null,
    instigator_to_heresy_label: "#VALUE!",
    repressor_id: null,
    repressor_label: "#VALUE!",
    person_or_groups_other_id: null,
    person_or_groups_other_label: "#VALUE!",
    dealing_with_them_id: null,
    dealing_with_them_label: "#VALUE!",
    outcome_id: null,
    outcome_label: "#VALUE!",
    "Unnamed: 40": null,
    execution_location_type_id: null,
    beliefs_id: null,
    beliefs_label: "#VALUE!",
    practice_id: null,
    practice_label: "#VALUE!",
    note: null,
  },
  E0023: {
    id: "E0023",
    label: "heretics of Goslar",
    detail_case_summary:
      'A very brief mention in the "Annales Melicenses" on the heretics discovered at Goslar, who were sentenced to death with the approval of the imperial assembly.',
    label_and_source_concatenated: "heretics of Goslar (Annales Mellicenses)",
    case_id: "E1010",
    case_label: "heretics of Goslar",
    text_id: "T95",
    text_label: "Annales Mellicenses",
    year_start_post_quem: "1051",
    year_start_ante_quem: "1053",
    year_end_post_quem: "1051",
    year_end_ante_quem: "1053",
    year_approximate: "y",
    location_id: "L0037",
    location_label: "Goslaria",
    location_primary_id: "L0037",
    location_primary_label: "Goslar",
    geometry: "point",
    name_of_heresy_id: "C3242",
    name_of_heresy_label: "manicheorum secta",
    name_of_heretics_id: "[C1059]",
    name_of_heretics_label: "manichei",
    connotations_heresy_id: "C1277",
    connotations_heresy_label: "heretica contagio",
    heretic_id: "[G0039]",
    heretic_label: "[heretici Goslarienses]",
    heretics_amount_id: "[C1174]",
    heretics_amount_label: "aliqui/e/a",
    heretics_social_characterization_id: "C1067",
    heretics_social_characterization_label: "not stated by the source",
    instigator_to_heresy_id: "C1067",
    instigator_to_heresy_label: "not stated by the source",
    repressor_id: "P0039 #G0040",
    repressor_label:
      "Henricus imperator Sacri Romani Imperii #[alii homines congregati Goslarie]",
    person_or_groups_other_id: null,
    person_or_groups_other_label: "#VALUE!",
    dealing_with_them_id: null,
    dealing_with_them_label: "#VALUE!",
    outcome_id: "C1282",
    outcome_label: "hanging",
    "Unnamed: 40": null,
    execution_location_type_id: null,
    beliefs_id: "C1067",
    beliefs_label: "not stated by the source",
    practice_id: "[C1066]",
    practice_label: "avoidance of meat",
    note: 'The source dates the event as 25/12/1052 but according to modern standards it should be redated to 1051 because of the use of the "stilus a Nativitate".',
  },
  E0025: {
    id: "E0025",
    label: "heretics of Goslar",
    detail_case_summary:
      'A very brief mention in the "Chronicon" of Bernold on the heretics discovered at Goslar, who were sentenced to death with the approval of the imperial assembly.',
    label_and_source_concatenated:
      "heretics of Goslar (Bernoldus Constantiensis, Chronicon Bernoldi)",
    case_id: "E1010",
    case_label: "heretics of Goslar",
    text_id: "T97",
    text_label: "Chronicon Bernoldi",
    year_start_post_quem: "1051",
    year_start_ante_quem: "1053",
    year_end_post_quem: "1051",
    year_end_ante_quem: "1053",
    year_approximate: "y",
    location_id: "L0037",
    location_label: "Goslaria",
    location_primary_id: "L0037",
    location_primary_label: "Goslar",
    geometry: "point",
    name_of_heresy_id: "[C0001]",
    name_of_heresy_label: "heresis",
    name_of_heretics_id: "[C1059]",
    name_of_heretics_label: "manichei",
    connotations_heresy_id: "C1280",
    connotations_heresy_label: "heretica scabies",
    heretic_id: "[G0039]",
    heretic_label: "[heretici Goslarienses]",
    heretics_amount_id: "[C1174]",
    heretics_amount_label: "aliqui/e/a",
    heretics_social_characterization_id: "C1067",
    heretics_social_characterization_label: "not stated by the source",
    instigator_to_heresy_id: "C1067",
    instigator_to_heresy_label: "not stated by the source",
    repressor_id: "P0039 #G0040",
    repressor_label:
      "Henricus imperator Sacri Romani Imperii #[alii homines congregati Goslarie]",
    person_or_groups_other_id: null,
    person_or_groups_other_label: "#VALUE!",
    dealing_with_them_id: null,
    dealing_with_them_label: "#VALUE!",
    outcome_id: "C1282",
    outcome_label: "hanging",
    "Unnamed: 40": null,
    execution_location_type_id: null,
    beliefs_id: "C1067",
    beliefs_label: "not stated by the source",
    practice_id: "[C1066]",
    practice_label: "avoidance of meat",
    note: 'The source dates the event as 25/12/1052 but according to modern standards it should be redated to 1051 because of the use of the "stilus a Nativitate".',
  },
  E0026: {
    id: "E0026",
    label: "heretics of Goslar",
    detail_case_summary:
      'A very brief mention in the "Chronicon" of Hermann der Lahme on the heretics discovered at Goslar, who were sentenced to death with the approval of the imperial assembly.',
    label_and_source_concatenated:
      "heretics of Goslar (Herimannus Augiensis, Herimanni Augiensis Chronicon)",
    case_id: "E1010",
    case_label: "heretics of Goslar",
    text_id: "T98",
    text_label: "Herimanni Augiensis Chronicon",
    year_start_post_quem: "1051",
    year_start_ante_quem: "1053",
    year_end_post_quem: "1051",
    year_end_ante_quem: "1053",
    year_approximate: "y",
    location_id: "L0037",
    location_label: "Goslaria",
    location_primary_id: "L0037",
    location_primary_label: "Goslar",
    geometry: "point",
    name_of_heresy_id: "C3243",
    name_of_heresy_label: "manichea secta",
    name_of_heretics_id: "[C1059]",
    name_of_heretics_label: "manichei",
    connotations_heresy_id: "C1280",
    connotations_heresy_label: "heretica scabies",
    heretic_id: "[G0039]",
    heretic_label: "[heretici Goslarienses]",
    heretics_amount_id: "[C1174]",
    heretics_amount_label: "aliqui/e/a",
    heretics_social_characterization_id: "C1067",
    heretics_social_characterization_label: "not stated by the source",
    instigator_to_heresy_id: "C1067",
    instigator_to_heresy_label: "not stated by the source",
    repressor_id: "P0039 #G0040",
    repressor_label:
      "Henricus imperator Sacri Romani Imperii #[alii homines congregati Goslarie]",
    person_or_groups_other_id: null,
    person_or_groups_other_label: "#VALUE!",
    dealing_with_them_id: null,
    dealing_with_them_label: "#VALUE!",
    outcome_id: "C1282",
    outcome_label: "hanging",
    "Unnamed: 40": null,
    execution_location_type_id: null,
    beliefs_id: "[C0052]",
    beliefs_label: "errores",
    practice_id: "[C1066]",
    practice_label: "avoidance of meat",
    note: 'The source dates the event as 25/12/1052 but according to modern standards it should be redated to 1051 because of the use of the "stilus a Nativitate".',
  },
  E0024: {
    id: "E0024",
    label: "heretics of Goslar",
    detail_case_summary:
      'A very brief mention in the "Annalista Saxo" on heretics discovered at Goslar, who were sentenced to death with the approval of the imperial assembly.',
    label_and_source_concatenated: "heretics of Goslar (Annalista Saxo)",
    case_id: "E1010",
    case_label: "heretics of Goslar",
    text_id: "T96",
    text_label: "Annalista Saxo",
    year_start_post_quem: "1051",
    year_start_ante_quem: "1053",
    year_end_post_quem: "1051",
    year_end_ante_quem: "1053",
    year_approximate: "y",
    location_id: "L0037",
    location_label: "Goslaria",
    location_primary_id: "L0037",
    location_primary_label: "Goslar",
    geometry: "point",
    name_of_heresy_id: "[C0001]",
    name_of_heresy_label: "heresis",
    name_of_heretics_id: null,
    name_of_heretics_label: "#VALUE!",
    connotations_heresy_id: null,
    connotations_heresy_label: "#VALUE!",
    heretic_id: "[G0039]",
    heretic_label: "[heretici Goslarienses]",
    heretics_amount_id: "[C1174]",
    heretics_amount_label: "aliqui/e/a",
    heretics_social_characterization_id: "C1067",
    heretics_social_characterization_label: "not stated by the source",
    instigator_to_heresy_id: "C1067",
    instigator_to_heresy_label: "not stated by the source",
    repressor_id: "P0040",
    repressor_label: "Godefridus dux Lotharingiae",
    person_or_groups_other_id: null,
    person_or_groups_other_label: "#VALUE!",
    dealing_with_them_id: "C1266",
    dealing_with_them_label: "apprehension",
    outcome_id: "C1282",
    outcome_label: "hanging",
    "Unnamed: 40": null,
    execution_location_type_id: null,
    beliefs_id: "C1067",
    beliefs_label: "not stated by the source",
    practice_id: "C1067",
    practice_label: "not stated by the source",
    note: "The source dates the event as 1053.",
  },
  E0027: {
    id: "E0027",
    label: "heretics of Goslar",
    detail_case_summary:
      'A very brief mention in the "Annales" of Lampert of Hersfeld on the heretics discovered at Goslar, who were sentenced to death with the approval of the imperial assembly.',
    label_and_source_concatenated:
      "heretics of Goslar (Lambertus Hersfeldensis, Lamberti Hersfeldensis Annales)",
    case_id: "E1010",
    case_label: "heretics of Goslar",
    text_id: "T99",
    text_label: "Lamberti Hersfeldensis Annales",
    year_start_post_quem: "1051",
    year_start_ante_quem: "1053",
    year_end_post_quem: "1051",
    year_end_ante_quem: "1053",
    year_approximate: "y",
    location_id: "L0037",
    location_label: "Goslaria",
    location_primary_id: "L0037",
    location_primary_label: "Goslar",
    geometry: "point",
    name_of_heresy_id: "[C0001]",
    name_of_heresy_label: "heresis",
    name_of_heretics_id: null,
    name_of_heretics_label: "#VALUE!",
    connotations_heresy_id: null,
    connotations_heresy_label: "#VALUE!",
    heretic_id: "[G0039]",
    heretic_label: "[heretici Goslarienses]",
    heretics_amount_id: "[C1174]",
    heretics_amount_label: "aliqui/e/a",
    heretics_social_characterization_id: "C1067",
    heretics_social_characterization_label: "not stated by the source",
    instigator_to_heresy_id: "C1067",
    instigator_to_heresy_label: "not stated by the source",
    repressor_id: "P0040",
    repressor_label: "Godefridus dux Lotharingiae",
    person_or_groups_other_id: "P0039 #P0041 #P0042",
    person_or_groups_other_label:
      "Henricus imperator Sacri Romani Imperii #Liutpoldus archiepiscopus Moguntiacensis #Immed episcopus Podelbrunnensis",
    dealing_with_them_id: "C1266",
    dealing_with_them_label: "apprehension",
    outcome_id: "C1282",
    outcome_label: "hanging",
    "Unnamed: 40": null,
    execution_location_type_id: null,
    beliefs_id: "C1067",
    beliefs_label: "not stated by the source",
    practice_id: "C1067",
    practice_label: "not stated by the source",
    note: 'The source dates the event as 1053 but according to modern standards it should be redated to 1052 because of the use of the "stilus a Nativitate".',
  },
  E0028: {
    id: "E0028",
    label: "heretics of Goslar",
    detail_case_summary:
      'Anselm of Liège describes in his "Gesta episcoporum Tungrensium, Traiectensium, et Leodiensium" how heretics were condemned in Goslar around the year 1052. He expresses his indignation at the sentencing to death of heretics for a trivial reason.',
    label_and_source_concatenated:
      "heretics of Goslar (Anselmus Leodiensis, Herigerus Lobiensis, Gesta episcoporum Tungrensium, Traiectensium, et Leodiensium)",
    case_id: "E1010",
    case_label: "heretics of Goslar",
    text_id: "T100",
    text_label: "Gesta episcoporum Tungrensium, Traiectensium, et Leodiensium",
    year_start_post_quem: "1051",
    year_start_ante_quem: "1053",
    year_end_post_quem: "1051",
    year_end_ante_quem: "1053",
    year_approximate: "y",
    location_id: "L0037",
    location_label: "Goslaria",
    location_primary_id: "L0037",
    location_primary_label: "Goslar",
    geometry: "point",
    name_of_heresy_id: "C0122",
    name_of_heresy_label: "error",
    name_of_heretics_id: null,
    name_of_heretics_label: "#VALUE!",
    connotations_heresy_id: "C1353",
    connotations_heresy_label: "pertinacia erroris",
    heretic_id: "[G0039]",
    heretic_label: "[heretici Goslarienses]",
    heretics_amount_id: "[C1174]",
    heretics_amount_label: "aliqui/e/a",
    heretics_social_characterization_id: "C1067",
    heretics_social_characterization_label: "not stated by the source",
    instigator_to_heresy_id: "C1067",
    instigator_to_heresy_label: "not stated by the source",
    repressor_id: "P0117",
    repressor_label: "quidam episcopus",
    person_or_groups_other_id: null,
    person_or_groups_other_label: "#VALUE!",
    dealing_with_them_id: "C1266",
    dealing_with_them_label: "apprehension",
    outcome_id: "C1106 #C1282",
    outcome_label: "excommunication #hanging",
    "Unnamed: 40": null,
    execution_location_type_id: null,
    beliefs_id: "C1067",
    beliefs_label: "not stated by the source",
    practice_id: "[C1284]",
    practice_label: "rejection of killing animals",
    note: "Anselm holds that the heretics should not have been killed.\n#Anselm compares Goslar's heretics to the heretics discovered at a similar time in the diocese of Châlons.",
  },
  E0037: {
    id: "E0037",
    label: "anti-eucharistic heretics at Ivois",
    detail_case_summary:
      '"Gesta Treverorum" describes four heretics discovered in Ivois (present-day Carignan) who rejected the sacrament of the Eucharist and infant baptism. Shortly after their capture, one of the heretics managed to escape, while another renounced his error. The others had to listen to a sermon from Archbishop Bruno, after which yet another heretic managed to escape, the remaining one was put to the trial of the Eucharist, after which he seemingly converted to orthodoxy, but later was caught in adultery.',
    label_and_source_concatenated:
      "anti-eucharistic heretics at Ivois (Gesta Treverorum)",
    case_id: "E1018",
    case_label: "anti-eucharistic heretics at Ivois",
    text_id: "T106",
    text_label: "Gesta Treverorum",
    year_start_post_quem: "1112",
    year_start_ante_quem: "1122",
    year_end_post_quem: "1112",
    year_end_ante_quem: "1122",
    year_approximate: "y",
    location_id: "L0049",
    location_label: "Ivodium",
    location_primary_id: "L0049",
    location_primary_label: "Carignan",
    geometry: "point",
    name_of_heresy_id: "C0001",
    name_of_heresy_label: "heresis",
    name_of_heretics_id: null,
    name_of_heretics_label: "#VALUE!",
    connotations_heresy_id: "C1582 #C3356 #C3357 #C1568 #C3358 #C2053",
    connotations_heresy_label:
      "scelus #ethnicus #publicanus #nequitie infamia #vicium #sordidus/a/um",
    heretic_id: "P0048 #P0049 #P0050 #P0051",
    heretic_label:
      "Fredericus presbyter #Dominicus Guillelmus presbyter #Durandus #Hamelricus",
    heretics_amount_id: "~V~4",
    heretics_amount_label: "~V~4",
    heretics_social_characterization_id: "C1271 #C1075",
    heretics_social_characterization_label: "presbyteri #laici",
    instigator_to_heresy_id: null,
    instigator_to_heresy_label: "#VALUE!",
    repressor_id: "P0052 #G0117",
    repressor_label:
      "Bruno archiepiscopus Treverorum #[delatores hereticorum Ivodiensium]",
    person_or_groups_other_id: "G0118",
    person_or_groups_other_label:
      "[fideles presentes in audientia hereticorum]",
    dealing_with_them_id: "C1266 #C1265 #C2296",
    dealing_with_them_label: "apprehension #hearing #trial by Eucharist",
    outcome_id: "C2272 #C1323 #C1097 #C1106 #C1569",
    outcome_label:
      "flight #abjuration of heretical errors #degradation #excommunication #relapse into heresy",
    "Unnamed: 40": null,
    execution_location_type_id: null,
    beliefs_id: "[C1064]\n#[C1815]\n#C0052",
    beliefs_label:
      "rejection of Eucharist as sacrament #rejection of infant baptism #errores",
    practice_id: "C3362 #[C1177]",
    practice_label: "conventicula hereticorum #luxuria",
    note: 'The practice of "luxuria" refers to an act of adultery committed by Dominicus Guillelmus after his apparent reconversion to Catholicism.',
  },
  E0038: {
    id: "E0038",
    label: "anti-eucharistic heretics at Ivois",
    detail_case_summary:
      '"Annales Trevirenses" describe heretics discovered in Ivois (present-day Carignan) who rejected the sacrament of the Eucharist. After being captured they were interrogated and one managed to escape; another was put to the trial of the Eucharist, after which he seemingly converted to orthodoxy. The heretics were portrayed as heirs to the errors of Berengar of Tours.',
    label_and_source_concatenated:
      "anti-eucharistic heretics at Ivois (Annales Trevirenses)",
    case_id: "E1018",
    case_label: "anti-eucharistic heretics at Ivois",
    text_id: "T108",
    text_label: "Annales Trevirenses",
    year_start_post_quem: "1112",
    year_start_ante_quem: "1122",
    year_end_post_quem: "1112",
    year_end_ante_quem: "1122",
    year_approximate: "y",
    location_id: "L0049\n#L0051",
    location_label: "Ivodium #ager Lutzeburgensium",
    location_primary_id: "L0049",
    location_primary_label: "Carignan",
    geometry: "point",
    name_of_heresy_id: "C0122 #C0001",
    name_of_heresy_label: "error #heresis",
    name_of_heretics_id: null,
    name_of_heretics_label: "#VALUE!",
    connotations_heresy_id:
      "C1574 #C1575 #C1576 #C1577 #C1578 #C1579 #C1278 #C1580 #C3526 #C1581 #C1582 #C3527 #C3363 #C2189 #C3356 #C3357 #C3364 #C1086 #C1583",
    connotations_heresy_label:
      "perfidie virus #Berengarii venenum #nefandis et absurdis Berengarii opinionibus imbuti/e #inanem Berengarii speciem amplexi/e #aliis pravis dogmatibus infecti/e #perfidie semen #contagio #labes contempta #veteratores #perverse doctrine zizania #scelus #pestilentia #pervicax #pertinacia #ethnicus #publicanus #scelestus/a/um #nequitia #abolenda infamia",
    heretic_id: "P0048 #P0049 #P0050 #P0051 #G0051",
    heretic_label:
      "Fredericus presbyter #Dominicus Guillelmus presbyter #Durandus #Hamelricus #[heretici Ivodienses]",
    heretics_amount_id: "C1069",
    heretics_amount_label: "plures/a",
    heretics_social_characterization_id: "C1271 #C1071",
    heretics_social_characterization_label: "presbyteri #plebs",
    instigator_to_heresy_id: null,
    instigator_to_heresy_label: "#VALUE!",
    repressor_id: "P0052 #G0117",
    repressor_label:
      "Bruno archiepiscopus Treverorum #[delatores hereticorum Ivodiensium]",
    person_or_groups_other_id: null,
    person_or_groups_other_label: "#VALUE!",
    dealing_with_them_id: "C1266 #C1265 #C2296",
    dealing_with_them_label: "apprehension #hearing #trial by Eucharist",
    outcome_id: "C2272 #C1323 #C1097 #C1106 #C1569",
    outcome_label:
      "flight #abjuration of heretical errors #degradation #excommunication #relapse into heresy",
    "Unnamed: 40": null,
    execution_location_type_id: null,
    beliefs_id: "[C1064] #C0052",
    beliefs_label: "rejection of Eucharist as sacrament #errores",
    practice_id: "[C1177]",
    practice_label: "luxuria",
    note: 'The actual spelling of Dominicus Guillelmus in the source is Dominicus Wilhelmus.\n#The practice of "luxuria" refers to an act of adultery committed by Dominicus Wilhelmus after his apparent reconversion to Catholicism. Because of the act, he was sentenced to death by the secular authorities.',
  },
  E0039: {
    id: "E0039",
    label: "anticlerical heresy of Tanchelm",
    detail_case_summary:
      "After the imprisonment of the wandering preacher Tanchelm by the Archbishop of Cologne, Frederick, the canons of Utrecht addressed him in a letter with a commandment not to release the heretic and to punish him accordingly. In the letter, we can learn about the errors of Tanchelm and his followers, which amount to extreme anti-clericalism and a sense of the exclusivity of salvation. Tanchelm is depicted as a prideful man who surrounded himself with royal splendor and proclaimed himself as God. He was treated like a saint by the faithful, who even drank his water after washing. The canons also give the names of his two disciples: Manasses, Everwacher, who were also imprisoned.",
    label_and_source_concatenated:
      "anticlerical heresy of Tanchelm (epistola ecclesie Traiectensis ad Fridericum archiepiscopum Coloniensem)",
    case_id: "E1019",
    case_label: "anticlerical heresy of Tanchelm",
    text_id: "T109",
    text_label:
      "epistola ecclesie Traiectensis ad Fridericum archiepiscopum Coloniensem",
    year_start_post_quem: "~1112",
    year_start_ante_quem: "~1112",
    year_end_post_quem: "1124",
    year_end_ante_quem: "1124",
    year_approximate: "y",
    location_id: "L0052 #[L0054] #[L0055]",
    location_label:
      "Traiectum ad Rhenum #ora Maris Germanicum #diocesis Colonensis",
    location_primary_id: "L0052 #L0053",
    location_primary_label: "Utrecht #Köln",
    geometry: "polyline",
    name_of_heresy_id: "C0001",
    name_of_heresy_label: "heresis",
    name_of_heretics_id: "C1598",
    name_of_heretics_label: "Tanchelmiste",
    connotations_heresy_id:
      "C1599 #C1600 #C1601 #C1602 #C2886 #C1604 #C1606 #C1607 #C1610 #C1612 #C3528 #C1845 #C1613 #C3418 #C1615 #C1616 #C1276 #C1624",
    connotations_heresy_label:
      "Antichristus #perturbator #blasphemator #spiritus superbie #heresis donatistarum #precursor Antichristi #venenum perfidie #perfidie laquei #angelus Satane #sacrilegus/a/um #nequitie #miser/a/um #sceleris audacia #immanissimum sacrilegium #sceleratus/a/um #nequissimus magister #nefandus/a/um #cancer",
    heretic_id: "P0054 #G0050 #P0056",
    heretic_label: "Tanchelmus #Tanchelmiste #Everwacherus",
    heretics_amount_id: "C0671",
    heretics_amount_label: "multi/e/a",
    heretics_social_characterization_id: "[C1170] #C1108",
    heretics_social_characterization_label: "illitterati/e #presbyter",
    instigator_to_heresy_id: null,
    instigator_to_heresy_label: "#VALUE!",
    repressor_id: "P0053",
    repressor_label: "Fridericus archiepiscopus Coloniensis",
    person_or_groups_other_id: null,
    person_or_groups_other_label: "#VALUE!",
    dealing_with_them_id: "C1266",
    dealing_with_them_label: "apprehension",
    outcome_id: "C1067",
    outcome_label: "not stated by the source",
    "Unnamed: 40": null,
    execution_location_type_id: null,
    beliefs_id: "[C1113] #[C2880] #[C1064] #[C2489] #[C1623]",
    beliefs_label:
      "rejection of sacraments #exclusivistic ecclesiology #rejection of Eucharist as sacrament #Donatist attitude to the efficacy of sacraments #heresiarch's self-deification",
    practice_id:
      "[C1360] #[C1992] #[C1152] #[C1618] #[C3244] #[C1996] #[C1994]",
    practice_label:
      "rejection of clergy #wandering preaching #rejection of material churches #rejection of tithing #cult of heresiarch #extortion of money #attacks on clergy",
    note: 'The author of the letter perceives the sin of pride as the root of all heresies and apostasies, including the heresy of Tanchelm.\n#Tanchelm is presented as a great demagogue or even a populist, but in the beginning, his heresy is said to be spread clandestinely and with the help of women of ill repute.\n#The source gives a long description of Tanchelm\'s betrothal to a statue of the Virgin Mary. The betrothal is used by Tanchelm to financially exploit his followers.\n#There are multiple citations of St. Augustine in the letter, especially in the passages comparing Tanchelmists to Donatists and, at the end, where St. Augustine is quoted as an exhortation to resort to the help of the secular authorities in fighting heretics.\n#One of the followers of Tanchelm, Manasses the smith, was treated independently in this study under the “offshoot of the Tanchelm’s heresy”, as, in the letter, he is presented as the founder of a new heretical fraternity.\n#There are some similarities between the letter of the canons of Utrecht and the description of a Bourges heretic made by Gregory of Tours in his "Decem Libri Historiarum" (Book X, 25). Both heretics were called the Antichrist and considered themselves to be Christ. Each of them pretended to have contact with Mary: the heretic described by Gregory had in his company a woman whom he called Mary, while Tanchelm betrothed himself to a statue of Mary. Moreover, the letter contains information about Tanchelm\'s disciple, Manasses, who founded his fraternity of twelve men and one woman, who was called Mary and with whom Manasses\' disciples had sexual intercourse. Tanchelm and the heretic of Bourges were also accused of receiving large amounts of valuables from their faithful. The letter, however, does not contain information about three thousand presumed followers of Tanchelm, which appears in Gregory of Tours, as well as in three other sources regarding Tanchelm ("Vita Norberti" A and B, and "Sigeberti Gemblacensis Continuatio Premonstratensis").',
  },
  E0040: {
    id: "E0040",
    label: "anticlerical heresy of Tanchelm",
    detail_case_summary:
      '"Vita Norberti archiepiscopi Magdeburgensis" (Vita A) describes the heresy of Tanchelm, which gained numerous adherents in Antwerp. The heresy was characterized primarily by anti-clericalism. Tanchelm was depicted as a prideful man who surrounded himself with royal splendor and was treated like a saint by the faithful, who even drank his bath water. The heresy ceased to exist after the foundation of the Premonstratensian monastery in Antwerp and its missions. ',
    label_and_source_concatenated:
      "anticlerical heresy of Tanchelm (Vita Norberti archiepiscopi Magdeburgensis (Vita A))",
    case_id: "E1019",
    case_label: "anticlerical heresy of Tanchelm",
    text_id: "T110",
    text_label: "Vita Norberti archiepiscopi Magdeburgensis (Vita A)",
    year_start_post_quem: "~1112",
    year_start_ante_quem: "~1112",
    year_end_post_quem: "1124",
    year_end_ante_quem: "1124",
    year_approximate: "y",
    location_id: "L0056",
    location_label: "Antwerpia",
    location_primary_id: "L0056",
    location_primary_label: "Antwerpen",
    geometry: "polyline",
    name_of_heresy_id: "C0001 #C0122",
    name_of_heresy_label: "heresis #error",
    name_of_heretics_id: null,
    name_of_heretics_label: "#VALUE!",
    connotations_heresy_id:
      "C1625 #C1730 #C1627 #C3429 #C1628 #C1629 #C2029 #C1630 #C1632 #C1635 #C3428",
    connotations_heresy_label:
      "perniciosa heresis #mire subtilitatis et versutie seductor #seductio #sceleratissimus/a/um #christiane fidei inimicus/a #totius religionis inimicus/a #verba persuasibilia #pestiferum malum #multifere pestis sevitia #tenebre ignorantie #pessimus/a/um",
    heretic_id: "P0054 #[G0050] #G0119",
    heretic_label:
      "Tanchelmus #Tanchelmiste #tria milia pugnatorum qui Tanchelmum sequebantur",
    heretics_amount_id: "C0671",
    heretics_amount_label: "multi/e/a",
    heretics_social_characterization_id: "C1067",
    heretics_social_characterization_label: "not stated by the source",
    instigator_to_heresy_id: "C1067",
    instigator_to_heresy_label: "not stated by the source",
    repressor_id: "P0057 #G0053",
    repressor_label:
      "Norbertus Xantensis [archiepiscopus Magdeburgensis] #canonici Ordinis Praemonstratensis [apud Antverpiam]",
    person_or_groups_other_id: "G0052\n#P0058",
    person_or_groups_other_label:
      "congregatio duodecim clericorum Antverpenses qui ecclesiam suam Norberto et fratribus eius dederunt #Burchardus episcopus Camaracensis",
    dealing_with_them_id: "C1638",
    dealing_with_them_label: "preaching mission",
    outcome_id: "C1051",
    outcome_label: "reconversion to Catholicism",
    "Unnamed: 40": null,
    execution_location_type_id: null,
    beliefs_id: "[C1064]",
    beliefs_label: "rejection of Eucharist as sacrament",
    practice_id: "[C1360] #[C3244] #[C3246]",
    practice_label: "rejection of clergy #cult of heresiarch #odious practices",
    note: 'The actual spelling of the heretic\'s name in the source is Tanchelinus.\n#The foundation of the Premonstratensian monastery in Antwerp took place in 1124.\n#Vita A uses the connotation "multifere pestis sevitia"; in Vita B this connotation has its correct form: "mortifere pestis sevitia".',
  },
  E0041: {
    id: "E0041",
    label: "anticlerical heresy of Tanchelm",
    detail_case_summary:
      '"Vita Norberti ab auctore posteriore" (Vita B) describes the heresy of Tanchelm, which gained numerous adherents in Antwerp. The author explains the rapid growth of heresy due to the neglect of the faithful by a local priest. The heresy is characterized primarily by anti-clericalism. Tanchelm was depicted as a prideful man who surrounded himself with royal splendor and was treated like a saint by the faithful, who even drank his bath water. The heresy ceased to exist after the Premonstratensians were brought to Antwerp.',
    label_and_source_concatenated:
      "anticlerical heresy of Tanchelm (Vita Norberti ab auctore posteriore (Vita B))",
    case_id: "E1019",
    case_label: "anticlerical heresy of Tanchelm",
    text_id: "T111",
    text_label: "Vita Norberti ab auctore posteriore (Vita B)",
    year_start_post_quem: "~1112",
    year_start_ante_quem: "~1112",
    year_end_post_quem: "1124",
    year_end_ante_quem: "1124",
    year_approximate: "y",
    location_id: "L0056",
    location_label: "Antwerpia",
    location_primary_id: "L0056",
    location_primary_label: "Antwerpen",
    geometry: "polyline",
    name_of_heresy_id: "C0001 #C0122 #C1262",
    name_of_heresy_label: "heresis #error #secta",
    name_of_heretics_id: null,
    name_of_heretics_label: "#VALUE!",
    connotations_heresy_id:
      "C1730 #C3430 #C1718 #C1719 #C1720 #C1721 #C2029 #C1724 #C1725 #C1729 #C1635",
    connotations_heresy_label:
      "mire subtilitatis et versutie seductor #omnium hominum sceleratissimus/a/um #Dei inimicus #omnium sacramentorum Dei inimicus/a #totius religionis contrarius/a #christiane fidei contrarius/a #verba persuasibilia #turpissima seductionis exsecratio #detestanda seductionis exsecratio #mortifere pestis sevitia #tenebre ignorantie",
    heretic_id: "P0054 #[G0050] #G0119",
    heretic_label:
      "Tanchelmus #Tanchelmiste #tria milia pugnatorum qui Tanchelmum sequebantur",
    heretics_amount_id: "[C0671]",
    heretics_amount_label: "multi/e/a",
    heretics_social_characterization_id: "[C1075]",
    heretics_social_characterization_label: "laici",
    instigator_to_heresy_id: "C1067",
    instigator_to_heresy_label: "not stated by the source",
    repressor_id: "P0057 #G0053",
    repressor_label:
      "Norbertus Xantensis [archiepiscopus Magdeburgensis] #canonici Ordinis Praemonstratensis [apud Antverpiam]",
    person_or_groups_other_id: "P0059 #G0052 #P0058",
    person_or_groups_other_label:
      "sacerdos Antverpensis neglegens #congregatio duodecim clericorum Antverpenses qui ecclesiam suam Norberto et fratribus eius dederunt #Burchardus episcopus Camaracensis",
    dealing_with_them_id: "C1638",
    dealing_with_them_label: "preaching mission",
    outcome_id: "C1051",
    outcome_label: "reconversion to Catholicism",
    "Unnamed: 40": null,
    execution_location_type_id: null,
    beliefs_id: "[C1064]",
    beliefs_label: "rejection of Eucharist as sacrament",
    practice_id: "[C1360] #[C3244]",
    practice_label: "rejection of clergy #cult of heresiarch",
    note: 'The actual spelling of the heretic\'s name in the source is Tanchelinus.\n#The foundation of the Premonstratensian monastery in Antwerp took place in 1124.\n#Vita B uses the connotation "mortifere pestis sevitia"; in Vita A this connotation is in its incorrect form: "multifere pestis sevitia".',
  },
  E0042: {
    id: "E0042",
    label: "anticlerical heresy of Tanchelm",
    detail_case_summary:
      "A document of Hidolf, prebendary of St. Michael in Antwerp, from 1124, concerning a donation to the Premonstratensians, whose task was to eradicate the remnants of the Tanchelmists in the area.",
    label_and_source_concatenated:
      "anticlerical heresy of Tanchelm (Hidolphus prepositus s. Michelis in Antverpia, carta Hidolphi prepositi s. Michelis in Antverpia)",
    case_id: "E1019",
    case_label: "anticlerical heresy of Tanchelm",
    text_id: "T112",
    text_label: "carta Hidolphi prepositi s. Michelis in Antverpia",
    year_start_post_quem: "~1112",
    year_start_ante_quem: "~1112",
    year_end_post_quem: "1124",
    year_end_ante_quem: "1124",
    year_approximate: "y",
    location_id: "L0056",
    location_label: "Antwerpia",
    location_primary_id: "L0056",
    location_primary_label: "Antwerpen",
    geometry: "polyline",
    name_of_heresy_id: "C0001",
    name_of_heresy_label: "heresis",
    name_of_heretics_id: null,
    name_of_heretics_label: "#VALUE!",
    connotations_heresy_id: "C1735",
    connotations_heresy_label: "venenosus sermo",
    heretic_id: "P0054",
    heretic_label: "Tanchelmus",
    heretics_amount_id: "C1069",
    heretics_amount_label: "plures/a",
    heretics_social_characterization_id: "C1067",
    heretics_social_characterization_label: "not stated by the source",
    instigator_to_heresy_id: "C1067",
    instigator_to_heresy_label: "not stated by the source",
    repressor_id: "P0060 #P0058 #G0054 #P0057 #G0053",
    repressor_label:
      "Hidolphus prepositus s. Michelis in Antverpia #Burchardus episcopus Camaracensis #canonici s. Michelis in Antverpia #Norbertus Xantensis [archiepiscopus Magdeburgensis] #canonici Ordinis Praemonstratensis [apud Antverpiam]",
    person_or_groups_other_id: null,
    person_or_groups_other_label: "#VALUE!",
    dealing_with_them_id: "[C1638]",
    dealing_with_them_label: "preaching mission",
    outcome_id: "C1067",
    outcome_label: "not stated by the source",
    "Unnamed: 40": null,
    execution_location_type_id: null,
    beliefs_id: "[C1113] #[C0052]",
    beliefs_label: "rejection of sacraments #errores",
    practice_id: "C1067",
    practice_label: "not stated by the source",
    note: 'The actual spelling of the heretic\'s name in the source is Tanchelinus.\n#The source communicates about a foundation of the Premonstratensian monastery in Antwerp; for this reason, "preaching mission" was put under the label "dealing with heresy".',
  },
  E0043: {
    id: "E0043",
    label: "anticlerical heresy of Tanchelm",
    detail_case_summary:
      "A document of Burchard, Bishop of Cambrai, from 1124, concerning a donation to the Premonstratensians, whose task was to eradicate the remnants of the Tanchelmists in the area.",
    label_and_source_concatenated:
      "anticlerical heresy of Tanchelm (Burchardus episcopus Cameracensis, carta Burchardi episcopi Cameracensium)",
    case_id: "E1019",
    case_label: "anticlerical heresy of Tanchelm",
    text_id: "T113",
    text_label: "carta Burchardi episcopi Cameracensium",
    year_start_post_quem: "~1112",
    year_start_ante_quem: "~1112",
    year_end_post_quem: "1124",
    year_end_ante_quem: "1124",
    year_approximate: "y",
    location_id: "L0056",
    location_label: "Antwerpia",
    location_primary_id: "L0056",
    location_primary_label: "Antwerpen",
    geometry: "polyline",
    name_of_heresy_id: null,
    name_of_heresy_label: "#VALUE!",
    name_of_heretics_id: null,
    name_of_heretics_label: "#VALUE!",
    connotations_heresy_id: "C1735",
    connotations_heresy_label: "venenosus sermo",
    heretic_id: "P0054",
    heretic_label: "Tanchelmus",
    heretics_amount_id: "C1067",
    heretics_amount_label: "not stated by the source",
    heretics_social_characterization_id: "C1067",
    heretics_social_characterization_label: "not stated by the source",
    instigator_to_heresy_id: "C1067",
    instigator_to_heresy_label: "not stated by the source",
    repressor_id: "P0058 #G0054 #P0057",
    repressor_label:
      "Burchardus episcopus Camaracensis #canonici s. Michelis in Antverpia #Norbertus Xantensis [archiepiscopus Magdeburgensis]",
    person_or_groups_other_id: null,
    person_or_groups_other_label: "#VALUE!",
    dealing_with_them_id: "[C1638]",
    dealing_with_them_label: "preaching mission",
    outcome_id: "C1067",
    outcome_label: "not stated by the source",
    "Unnamed: 40": null,
    execution_location_type_id: null,
    beliefs_id: "C1067",
    beliefs_label: "not stated by the source",
    practice_id: "C1067",
    practice_label: "not stated by the source",
    note: 'The actual spelling of the heretic\'s name in the source is Tanszelinus.\n#The source communicates about the foundation of a Premonstratensian monastery in Antwerp; for this reason, "preaching mission" was put under the label "dealing with heresy".',
  },
  E0044: {
    id: "E0044",
    label: "anticlerical heresy of Tanchelm",
    detail_case_summary:
      '"Sigeberti Gemblacensis Continuatio Praemonstratensis” describes the heresy of Tanchelm, who gained many adherents in Antwerp. The heresy is characterized primarily by anti-clericalism. Tanchelm is depicted as a prideful man who surrounded himself with royal splendor and was treated like a saint by the faithful, who even drank his bath water. Tanchelm committed many atrocities like rapes. Tanchelm is said to have been killed during a water crossing by an unknown priest. The heresy ceased to exist after some Premonstratensians were brought to Antwerp.',
    label_and_source_concatenated:
      "anticlerical heresy of Tanchelm (Sigeberti Gemblacensis Continuatio Premonstratensis)",
    case_id: "E1019",
    case_label: "anticlerical heresy of Tanchelm",
    text_id: "T114",
    text_label: "Sigeberti Gemblacensis Continuatio Premonstratensis",
    year_start_post_quem: "~1112",
    year_start_ante_quem: "~1112",
    year_end_post_quem: "1124",
    year_end_ante_quem: "1124",
    year_approximate: "y",
    location_id: "L0056",
    location_label: "Antwerpia",
    location_primary_id: "L0056",
    location_primary_label: "Antwerpen",
    geometry: "polyline",
    name_of_heresy_id: "C0122 #C0001",
    name_of_heresy_label: "error #heresis",
    name_of_heretics_id: null,
    name_of_heretics_label: "#VALUE!",
    connotations_heresy_id: "C2029 #C1738 #C1739",
    connotations_heresy_label: "verba persuasibilia #incontinentia #impuritas",
    heretic_id: "P0054 #[G0050] #G0120",
    heretic_label:
      "Tanchelmus #Tanchelmiste #tria milia armati qui Tanchelmum sequebantur",
    heretics_amount_id: "[C0671]",
    heretics_amount_label: "multi/e/a",
    heretics_social_characterization_id: "C3426",
    heretics_social_characterization_label: "includes laic(s)",
    instigator_to_heresy_id: "C1067",
    instigator_to_heresy_label: "not stated by the source",
    repressor_id: "P0061 #G0055 #P0058 #P0057",
    repressor_label:
      "quidam presbyter qui Tanchelmum occidit #clerici Antverpenses [qui ecclesiam suam Norberto et fratribus eius dederunt] #Burchardus episcopus Camaracensis #Norbertus Xantensis [archiepiscopus Magdeburgensis]",
    person_or_groups_other_id: null,
    person_or_groups_other_label: "#VALUE!",
    dealing_with_them_id: "C1638",
    dealing_with_them_label: "preaching mission",
    outcome_id: "C1737 #C1051",
    outcome_label: "killing of a heretic #reconversion to Catholicism",
    "Unnamed: 40": null,
    execution_location_type_id: null,
    beliefs_id: "[C1153] #[C1064] #[C1623] #C0052",
    beliefs_label:
      "rejection of ordination #rejection of Eucharist as sacrament #heresiarch's self-deification #errores",
    practice_id: "[C1360] #[C3244] #[C3246]",
    practice_label: "rejection of clergy #cult of heresiarch #odious practices",
    note: "The source provides two different spellings of the name of the heretic: Tanchelmus and Tandemus.\n#Tanchelm is presented as a great demagogue.\n#The social characterization of heretics is unknown, except in the case of Tanchelm, who is openly described as a layperson.\n#The foundation of the Premonstratensian monastery in Antwerp took place in 1124.",
  },
  E0045: {
    id: "E0045",
    label: "anticlerical heresy of Tanchelm",
    detail_case_summary:
      "A very short mention in “Sigeberti Gemblacensis Continuatio Valcellensis” reports on the heretic Tanchelm, active in the area of Antwerp and Walcheren, and killed in 1115.",
    label_and_source_concatenated:
      "anticlerical heresy of Tanchelm (Sigeberti Gemblacensis Continuatio Valcellensis)",
    case_id: "E1019",
    case_label: "anticlerical heresy of Tanchelm",
    text_id: "T115",
    text_label: "Sigeberti Gemblacensis Continuatio Valcellensis",
    year_start_post_quem: "~1112",
    year_start_ante_quem: "~1112",
    year_end_post_quem: "1124",
    year_end_ante_quem: "1124",
    year_approximate: "y",
    location_id: "L0056 #L0058 #[L0054]",
    location_label: "Antwerpia #Walacra #ora Maris Germanicum",
    location_primary_id: "L0056 #[L0109]",
    location_primary_label: "Antwerpen #Middelburg",
    geometry: "polyline",
    name_of_heresy_id: "C0001",
    name_of_heresy_label: "heresis",
    name_of_heretics_id: null,
    name_of_heretics_label: "#VALUE!",
    connotations_heresy_id: null,
    connotations_heresy_label: "#VALUE!",
    heretic_id: "P0054",
    heretic_label: "Tanchelmus",
    heretics_amount_id: "[C1069]",
    heretics_amount_label: "plures/a",
    heretics_social_characterization_id: "C1067",
    heretics_social_characterization_label: "not stated by the source",
    instigator_to_heresy_id: "C1067",
    instigator_to_heresy_label: "not stated by the source",
    repressor_id: "C1067",
    repressor_label: "not stated by the source",
    person_or_groups_other_id: null,
    person_or_groups_other_label: "#VALUE!",
    dealing_with_them_id: "C1067",
    dealing_with_them_label: "not stated by the source",
    outcome_id: "C1740",
    outcome_label: "death of a heretic",
    "Unnamed: 40": null,
    execution_location_type_id: null,
    beliefs_id: "C1067",
    beliefs_label: "not stated by the source",
    practice_id: "C1067",
    practice_label: "not stated by the source",
    note: "The actual spelling of the heretic's name in the source is Tanchelinus.",
  },
  E0046: {
    id: "E0046",
    label: "anticlerical heresy of Tanchelm",
    detail_case_summary:
      "A very brief mention in Peter Abelard's \"Introductio ad theologiam,\" which reports on the heretic Tanchelm operating in Flanders who proclaimed himself as God's son.",
    label_and_source_concatenated:
      "anticlerical heresy of Tanchelm (Petrus Abelardus, Introductio ad theologiam)",
    case_id: "E1019",
    case_label: "anticlerical heresy of Tanchelm",
    text_id: "T116",
    text_label: "Introductio ad theologiam",
    year_start_post_quem: "~1112",
    year_start_ante_quem: "~1112",
    year_end_post_quem: "1124",
    year_end_ante_quem: "1124",
    year_approximate: "y",
    location_id: "L0059",
    location_label: "Flandria",
    location_primary_id: "L0056",
    location_primary_label: "Antwerpen",
    geometry: "polyline",
    name_of_heresy_id: "[C0001]",
    name_of_heresy_label: "heresis",
    name_of_heretics_id: null,
    name_of_heretics_label: "#VALUE!",
    connotations_heresy_id: "C1050 #C1094",
    connotations_heresy_label: "insania #dementia",
    heretic_id: "P0054 #[G0050]",
    heretic_label: "Tanchelmus #Tanchelmiste",
    heretics_amount_id: "[C1069]",
    heretics_amount_label: "plures/a",
    heretics_social_characterization_id: "C3426",
    heretics_social_characterization_label: "includes laic(s)",
    instigator_to_heresy_id: "C1067",
    instigator_to_heresy_label: "not stated by the source",
    repressor_id: "C1067",
    repressor_label: "not stated by the source",
    person_or_groups_other_id: null,
    person_or_groups_other_label: "#VALUE!",
    dealing_with_them_id: "C1067",
    dealing_with_them_label: "not stated by the source",
    outcome_id: "[C1740]",
    outcome_label: "death of a heretic",
    "Unnamed: 40": null,
    execution_location_type_id: null,
    beliefs_id: "[C1623]",
    beliefs_label: "heresiarch's self-deification",
    practice_id: "C1067",
    practice_label: "not stated by the source",
    note: "The actual spelling of the heretic's name in the source is Tanquelmus.\n#The social characterization of heretics is unknown, except in the case of Tanchelm, who is openly described as a layperson.\n#Abelard also mentions the heresy of Peter of Bruys in the same paragraph but doesn't describe it.",
  },
  E0047: {
    id: "E0047",
    label: "offshoot of the Tanchelm's heresy",
    detail_case_summary:
      "In a letter from the canons of Utrecht to the archbishop of Cologne, Frederick, in which the heretic Tanchelm was described, there is also a description of the practices of his disciple Manasses. Manasses was said to have founded a brotherhood of twelve men representing twelve apostles and a woman representing the Virgin Mary, who indulged together in debauchery.",
    label_and_source_concatenated:
      "offshoot of the Tanchelm's heresy (epistola ecclesie Traiectensis ad Fridericum archiepiscopum Coloniensem)",
    case_id: "E1020",
    case_label: "offshoot of Tanchelm's heresy",
    text_id: "T109",
    text_label:
      "epistola ecclesie Traiectensis ad Fridericum archiepiscopum Coloniensem",
    year_start_post_quem: "~1112",
    year_start_ante_quem: "~1112",
    year_end_post_quem: "1114",
    year_end_ante_quem: "1114",
    year_approximate: "y",
    location_id: "[L0055]",
    location_label: "diocesis Colonensis",
    location_primary_id: "L0053",
    location_primary_label: "Köln",
    geometry: "point",
    name_of_heresy_id: "[C0001]",
    name_of_heresy_label: "heresis",
    name_of_heretics_id: "[C1598]",
    name_of_heretics_label: "Tanchelmiste",
    connotations_heresy_id: null,
    connotations_heresy_label: "#VALUE!",
    heretic_id: "P0055",
    heretic_label: "Manasses",
    heretics_amount_id: "~V~14",
    heretics_amount_label: "~V~14",
    heretics_social_characterization_id: "C0375",
    heretics_social_characterization_label: "faber",
    instigator_to_heresy_id: "P0054",
    instigator_to_heresy_label: "Tanchelmus",
    repressor_id: "P0053",
    repressor_label: "Fridericus archiepiscopus Coloniensis",
    person_or_groups_other_id: null,
    person_or_groups_other_label: "#VALUE!",
    dealing_with_them_id: "C1266",
    dealing_with_them_label: "apprehension",
    outcome_id: "C1067",
    outcome_label: "not stated by the source",
    "Unnamed: 40": null,
    execution_location_type_id: null,
    beliefs_id: null,
    beliefs_label: "#VALUE!",
    practice_id: "[C1177]",
    practice_label: "luxuria",
    note: "The area of Manasses' activity is unknown, but since he was imprisoned by the Archbishop of Cologne, this city was chosen as the main location of his activity.",
  },
  E0048: {
    id: "E0048",
    label: "manicheans near Soissons",
    detail_case_summary:
      'In the chapter XVII (Book III) of "De vita sua", Guibert of Nogent relays the story of the heretics of Bucy-le-Long near Soissons, whom he calls Manichaeans because of the similarity of their doctrine to that described by St. Augustine of Hippo. In addition to docetism and rejection of the sacraments, Guibert also attributes abominable sexual practices to them. The heretics are subjected to the ordeal by water and then put in prison from where they are dragged out by an angry mob and killed.',
    label_and_source_concatenated:
      "manicheans near Soissons (Guibertus abbas Novigenti, De vita sua sive Monodie)",
    case_id: "E1021",
    case_label: "manicheans near Soissons",
    text_id: "T117",
    text_label: "De vita sua sive Monodie",
    year_start_post_quem: "~1114",
    year_start_ante_quem: "~1114",
    year_end_post_quem: "~1114",
    year_end_ante_quem: "~1114",
    year_approximate: "y",
    location_id: "L0060 #L0063",
    location_label: "Buciacum #Durmantiis villa",
    location_primary_id: "L0060",
    location_primary_label: "Bucy-le-Long",
    geometry: "point",
    name_of_heresy_id: "C0001 #C0122",
    name_of_heresy_label: "heresis #error",
    name_of_heretics_id: "C1059",
    name_of_heretics_label: "manichei",
    connotations_heresy_id: "C1165 #C1086 #C1812",
    connotations_heresy_label: "clandestinus/a/um #nequitia #carcinus",
    heretic_id: "P0063 #P0064 #G0056",
    heretic_label:
      "Clementius rusticus #Ebrardus [frater Clementii] #duo heretici e Durmantiis villa",
    heretics_amount_id: "[C1174]",
    heretics_amount_label: "aliqui/e/a",
    heretics_social_characterization_id: "C1169 #C1170",
    heretics_social_characterization_label: "rustici #illitterati/e",
    instigator_to_heresy_id: "C1067",
    instigator_to_heresy_label: "not stated by the source",
    repressor_id: "P0062 #P0066 #P0067 #P0068 #G0121",
    repressor_label:
      "Lisiardus episcopus Suessorum #Guibertus [abbas Novigenti] #matrona quedam quam Clementius dementaverat #diaconus quidam qui ex Clementii ore capitula maligna audierat #populus qui hereticos Suessonenses concremavit",
    person_or_groups_other_id: "P0065 #P0069",
    person_or_groups_other_label:
      "Johannes comes Suessorum #Petrus archidiaconus Suessorum",
    dealing_with_them_id: "C1266 #C1265 #C1813",
    dealing_with_them_label: "apprehension #hearing #trial by water",
    outcome_id: "C2297 #C1063",
    outcome_label: "death by mob lynching #burning",
    "Unnamed: 40": null,
    execution_location_type_id: "C1162",
    beliefs_id: "[C1080] #[C1815] #[C2880] #[C1064]",
    beliefs_label:
      "docetism #rejection of infant baptism #exclusivistic ecclesiology #rejection of Eucharist as sacrament",
    practice_id:
      "[C1151] #[C3427] #[C1082] #[C1816] #[C1818] #[C3362] #[C1817]",
    practice_label:
      "feigned orthodoxy #rejection of cemeteries #rejection of marriage as sacrament #rejection of procreation #sodomy #conventicula hereticorum #avoidance of food originating from coition",
    note: 'In chapter XVI, Guibert describes atrocities committed by John, the count of Soissons, and relays that the Count listened to the teachings of heretics, which the author describes in chapter XVII.\n#Heretics claimed that infant baptism was invalid since children cannot receive it consciously.\n#Guibert gives general information about the existence of other similar heretics who pride themselves on leading an apparent "vita apostolica".\n#Guibert scoffs at the ignorance of Latin on the part of heretics who understood "eritis" as "heretici" in the Gospel passage "Beati eritis" (John 13:17). They also confused the word "heretici" with "hereditarii".\n#The author gives a detailed description of a heretic orgy and of the consecutive murder of a child born from sexual intercourse which allegedly happened at this orgy. The ashes of the murdered child were then used by heretics as a sort of anti-Eucharist. A similar description can be found in the case of learned heretics in Orléans, described in the Cartulary of Saint-Père of Chartres.\n#Guibert took part personally in the interrogation of heretics.',
  },
  E0063: {
    id: "E0063",
    label: "wandering preacher Henry the Monk",
    detail_case_summary:
      '"Actus pontificum Cenomannis" describes in two passages the heresy of the wandering preacher Henry. The first passage deals with Henry\'s arrival in Le Mans around 1116. Through his anticlerical activities, Henry led a revolt in the city, which was eventually crushed after the heretic was banished by Bishop Hildebert. The second passage deals with the synod of Pisa in 1135, at which Henry was condemned to confinement, but it did not put an end to his activities.',
    label_and_source_concatenated:
      "wandering preacher Henry the Monk (Actus pontificum Cenomannis in urbe degentium: Gesta Domni Hildeberti episcopi)",
    case_id: "E1023",
    case_label: "wandering preacher Henry the Monk",
    text_id: "T131",
    text_label:
      "Actus pontificum Cenomannis in urbe degentium: Gesta Domni Hildeberti episcopi",
    year_start_post_quem: "~1115",
    year_start_ante_quem: "~1115",
    year_end_post_quem: "1148",
    year_end_ante_quem: "1148",
    year_approximate: "y",
    location_id: "L0071 #L0072 #L0073 #L0074 #L0075 #L0078",
    location_label:
      "Cenomannum #diocesis Cenomannensis #Sanctus Germanus #Sanctus Vincentius #castrum sancti Karileffi #Pise",
    location_primary_id: "L0071 #L0075 #L0078",
    location_primary_label: "Le Mans #Saint-Calais #Pisa",
    geometry: "polyline",
    name_of_heresy_id: "C0001 #C1592 #C0122",
    name_of_heresy_label: "heresis #schisma #error",
    name_of_heretics_id: null,
    name_of_heretics_label: "#VALUE!",
    connotations_heresy_id:
      "C1927 #C1928 #C1929 #C1933 #C1934 #C2073 #C1943 #C1944 #C0448 #C1946 #C1949 #C1950 #C1951 #C1086 #C1958 #C3438 #C3439 #C1379 #C1378 #C1953 #C3437 #C1954 #C1955 #C1956 #C1959 #C1963 #C1591 #C1966 #C1967 #C1968 #C1970 #C3428 #C1971 #C1972 #C1973 #C1974 #C1734 #C1976 #C1977 #C1979 #C1980 #C1981 #C1983 #C1984 #C1985 #C1090 #C1987",
    connotations_heresy_label:
      "hypocrita #mores perversi #dogma detestabile #scorpionibus et parricidalibus dignus suppliciis #ovium spoliis lupi rapacis rabies occulta #falsitas #lascivia #viperinus afflatus #malum #insidia Argolici equi #pseudo eremita #novitas #recens venenum #nequitia #belua #ira #opprobrium #odium #maledictio #fallacia #discordia #osculum Jude #malus error #damnosus error #perversorum dogmatum ineptie #nefande fauces #virus #sacrilegi conventus #impostor #nequam consilium #exactor #pessimus/a/um #petulantia #facinus #inscientia #malum propositum #seductor #impietas #totus deditus petulantie #fictus/a/um #levitas #viperinus hiatus #furor #virus heresis #nequitie atramentum #dogma perversum #iter delinquendi",
    heretic_id: "P0082 #G0072 #G0071 #G0074 #P0092",
    heretic_label:
      "Henricus #discipuli Henrici #vulgus [sequatores Henrici] #clerici [sequatores Henrici] #quidam adolescens clericus [socius Henrici]",
    heretics_amount_id: "C0671",
    heretics_amount_label: "multi/e/a",
    heretics_social_characterization_id: "C1354 #C0455 #C1071",
    heretics_social_characterization_label: "vulgus #clerici #plebs",
    instigator_to_heresy_id: null,
    instigator_to_heresy_label: "#VALUE!",
    repressor_id:
      "P0083 #P0084 #G0075 #P0085 #P0086 #P0087 #G0076 #P0088 #P0090 #P0091 #G0077",
    repressor_label:
      "Hildebertus episcopus Cenomannensis #Fulco comes Andegavensis #optimates Fulconis #Hugo de Osello #Willelmus Qui-non-bibit-aquam #Paganus Aldricus #clerici Cenomannenses #Willelmus Muscha #Guillelmus archiepiscopus Arelatensis #Innocentius papa #concilium [Pisis congregatum]",
    person_or_groups_other_id: "G0073 #P0089 #G0078 #G0079 #P0093",
    person_or_groups_other_label:
      "archidiaconi Cenomannenses #dapifex Fulconi #mulieres inceste et venales #multi juvenes qui muelieres venales ducebant #quedam matrona cum qua Henricus in thalamo accubuit",
    dealing_with_them_id: "C1990 #C1265 #C1266 #C1048",
    dealing_with_them_label:
      "military action #hearing #apprehension #public debate",
    outcome_id: "C1106 #C1862 #C1852",
    outcome_label: "excommunication #banishment #incarceration",
    "Unnamed: 40": null,
    execution_location_type_id: null,
    beliefs_id: "[C0052]",
    beliefs_label: "errores",
    practice_id:
      "[C1991] #[C1992] #[C1176] #[C1993] #[C1360] #[C1994] #[C1995] #[C1996] #[C1177]",
    practice_label:
      "pandering #wandering preaching #feigned celibacy #feigned piety #rejection of clergy #attacks on clergy #attacks on church buildings #extortion of money #luxuria",
    note: "The source describes the heretic's hermit-like appearance and ascetic way of life.\n#The author highlights Henry's oratory skills.\n#The Gesta include a letter written by the clerics of Le Mans against Henry. In the letter, the clerics forbid Henry from preaching in the diocese of Le Mans and excommunicate him, but the letter had no effect on the heretic.\n#The Gesta relay an incident about prostitutes who were converted by Henry and then married to certain young men. After some time, however, the women were abandoned and Henry indulged in debauchery with them.\n#The author relays that Henry played dice.",
  },
  E0064: {
    id: "E0064",
    label: "wandering preacher Henry the Monk",
    detail_case_summary:
      "In an 1145 letter to the Count of Toulouse, Alphonse Jordan, Bernard of Clairvaux announces his arrival on a mission to his county. Bernard plans to combat the heresy of Henry, who is spreading anti-clerical and anti-sacramental errors among the people. Along with Bernard arrives the Bishop of Ostia, Alberic. In the letter, Bernard gives information about Henry's earlier areas of activity: Lausanne, Le Mans, Poitiers and Bordeaux.",
    label_and_source_concatenated:
      "wandering preacher Henry the Monk (Bernardus Clarevallensis, epistola sancti Bernardi Clarevallensis ad Alfonsum comitem Tolose)",
    case_id: "E1023",
    case_label: "wandering preacher Henry the Monk",
    text_id: "T132",
    text_label:
      "epistola sancti Bernardi Clarevallensis ad Alfonsum comitem Tolose",
    year_start_post_quem: "~1115",
    year_start_ante_quem: "~1115",
    year_end_post_quem: "1148",
    year_end_ante_quem: "1148",
    year_approximate: "y",
    location_id: "[L0023] #[L0027] #L0079 #L0071 #L0044 #L0080",
    location_label:
      "Tolosa #Regnum Francie #Lausana #Cenomannum #Pictavis #Burdigala",
    location_primary_id: "[L0023] #L0079 #L0071 #L0044 #L0080",
    location_primary_label: "Toulouse #Lausanne #Le Mans #Poitiers #Bordeaux",
    geometry: "polyline",
    name_of_heresy_id: "[C0001]",
    name_of_heresy_label: "heresis",
    name_of_heretics_id: null,
    name_of_heretics_label: "#VALUE!",
    connotations_heresy_id:
      "C1997 #C1999 #C2000 #C2002 #C2003 #C2004 #C2005 #C2010 #C2008 #C2012 #C2009 #C2013 #C2016 #C2018 #C2019",
    connotations_heresy_label:
      "sub vestimentis ovium lupus rapax #invidia diabolica #stupenda Judaica cecitas #ars diabolica #ferus/a #malitia #serpens callidus #invidia #apostata #confusio #gyrovagus #feda vestigia #arbor mala #spina #prava germina",
    heretic_id: "P0082 #G0080",
    heretic_label: "Henricus #populus [sequatores Henrici]",
    heretics_amount_id: "C1069",
    heretics_amount_label: "plures/a",
    heretics_social_characterization_id: "C3449 #C2023 #[C1170]",
    heretics_social_characterization_label:
      "quondam monachus #litteratus #illitterati/e",
    instigator_to_heresy_id: null,
    instigator_to_heresy_label: "#VALUE!",
    repressor_id: "P0094 #G0081 #P0095",
    repressor_label:
      "Bernardus Clarevallensis #episcopi [cum Bernardo Tolosam venientes] #Albericus cardinalis episcopus Ostiensis",
    person_or_groups_other_id: "[P0096] #G0124",
    person_or_groups_other_label:
      "Alphonsus Iordanus comes Tolose #meretrices et coniugate cum quis Henricus inventus est",
    dealing_with_them_id: "C1638",
    dealing_with_them_label: "preaching mission",
    outcome_id: "C1067",
    outcome_label: "not stated by the source",
    "Unnamed: 40": null,
    execution_location_type_id: null,
    beliefs_id: "[C1113] #[C1061]",
    beliefs_label: "rejection of sacraments #rejection of baptism as sacrament",
    practice_id: "[C1152] #[C2025] #[C1993] #[C1996] #[C1992] #[C1177]",
    practice_label:
      "rejection of material churches #disrespect for holy days #feigned piety #extortion of money #wandering preaching #luxuria",
    note: 'Bernard accuses heretics of rejecting baptism but then explains why small children should receive the sacrament. Thus, we can speculate that Henry rejected infant baptism, not baptism in general. However, since the rejection of infant baptism is not explicitly mentioned in the source, the "rejection of baptism" was put in the "beliefs" column.\n#Bernard relays that Henry lost the faithful\'s money by playing dice.',
  },
  E0065: {
    id: "E0065",
    label: "wandering preacher Henry the Monk",
    detail_case_summary:
      'In the "Vita Bernardi" (Books III and VII), Geoffroy of Auxerre describes the mission of Bernard of Clairvaux and Alberic, Bishop of Ostia, which they undertook near Toulouse to combat the heresy of Henry. The missionaries succeeded in combating the heresy of Henry, who was spreading anti-clerical and anti-sacramental errors among the people. Henry was eventually caught, but his further history is unknown. The two passages concerning Henry are quite far apart in the text and convey information that is not entirely consistent. The differences present in the text are described in the notes.',
    label_and_source_concatenated:
      "wandering preacher Henry the Monk (Gaufridus monachus Clarevallis, Vita prima sancti Bernardi Clarevallis abbatis)",
    case_id: "E1023",
    case_label: "wandering preacher Henry the Monk",
    text_id: "T133",
    text_label: "Vita prima sancti Bernardi Clarevallis abbatis",
    year_start_post_quem: "~1115",
    year_start_ante_quem: "~1115",
    year_end_post_quem: "1148",
    year_end_ante_quem: "1148",
    year_approximate: "y",
    location_id: "L0083 #L0023",
    location_label: "vicinia Tolose #Tolosa",
    location_primary_id: "L0023",
    location_primary_label: "Toulouse",
    geometry: "polyline",
    name_of_heresy_id: "C0001 #C3472",
    name_of_heresy_label: "heresis #heresis manicheorum",
    name_of_heretics_id: "C1059",
    name_of_heretics_label: "manichei",
    connotations_heresy_id:
      "C2021 #C2026 #C2028 #C2029 #C3448 #C2031 #C2032 #C2035 #C2036 #C3445 #C3446 #C3447 #C3444 #C3473 #C3475 #C3477",
    connotations_heresy_label:
      "apostata vilis #pessima vita #perniciosa doctrina #verba persuasibilia #in hypocrisi loquens mendacium #ficta verba #hostis Ecclesie manifestus #malignitas #nutantes #errantes #subversi/e #subversores #obstinati/e #hereticorum princeps #immunda hereticorum societas #coluber tortuosus",
    heretic_id: "P0082 #G0080 #P0119",
    heretic_label: "Henricus #populus [sequatores Henrici] #quidam hereticus",
    heretics_amount_id: "C0671",
    heretics_amount_label: "multi/e/a",
    heretics_social_characterization_id: "C3449 #C1160 #C3210",
    heretics_social_characterization_label:
      "quondam monachus #simplices #quondam monachus niger",
    instigator_to_heresy_id: null,
    instigator_to_heresy_label: "#VALUE!",
    repressor_id: "P0094 #P0095",
    repressor_label:
      "Bernardus Clarevallensis #Albericus cardinalis episcopus Ostiensis",
    person_or_groups_other_id: null,
    person_or_groups_other_label: "#VALUE!",
    dealing_with_them_id: "C1638",
    dealing_with_them_label: "preaching mission",
    outcome_id: "C2272 #C1266",
    outcome_label: "flight #apprehension",
    "Unnamed: 40": null,
    execution_location_type_id: null,
    beliefs_id: "[C1113] #[C2042] #[C1358] #[C1061]",
    beliefs_label:
      "rejection of sacraments #rejection of prayers for the salvation of the dead #rejection of almsgiving for the salvation of the dead #rejection of baptism as sacrament",
    practice_id: "[C1360] #[C1100] #[C2043] #[C1152] #[C2025] #[C2046]",
    practice_label:
      "rejection of clergy #rejection of cult of saints #rejection of pilgrimages #rejection of material churches #disrespect for holy days #rejection of anointing with the chrism",
    note: 'In Book III, Geoffroy provides information that Henry was once a monk. In Book VII, he is more precise and conveys that Henry was a "black monk" ("monachus niger").\n#A passage in Book III ends the story of Henry with information about the capture of the heretic and his handing over to the bishop. A passage in Book VII, on the other hand, reports Henry\'s escape, and his further fate is unknown.\n#In the part describing the beliefs and practices of heretics (Book III) Geoffroy quotes partially the letter of Bernard of Clairvaux to the count of Toulouse.\n#Geoffroy accuses heretics of rejecting baptism but then explains why small children should receive the sacrament. Thus, we can speculate that Henry rejected infant baptism, not baptism in general. However, since the rejection of infant baptism is not explicitly mentioned in the source, the "rejection of baptism" was put in the "beliefs" column.\n#In Book III, Geoffroy says that Henry "spoke lies in hypocrisy" ("in hypocrisi loquens mendacium") which is a passage from The First Letter of Paul to Timothy in which the apostle writes about the heretics of the end of times. \n#In Book VII, Geoffroy tells a story about a certain follower of Henry ("quidam hereticus") who accused Bernard of Clairvaux of having a much more beautiful horse than his master. Bernard replied to him that the condition of the horse should not preoccupy him as much as the rider\'s stature and that Bernard was of much more modest stature than Henry.',
  },
  E0096: {
    id: "E0096",
    label: "wandering preacher Henry the Monk",
    detail_case_summary:
      'Geoffroy of Auxerre, in a letter to Archenfroy and the Clairvaux brothers, describes the deeds that Bernard of Clairvaux accomplished during his mission to Aquitaine and Languedoc. In Toulouse, Bernard encountered the followers of Henry the Monk. Some of them were also participants of another heretical group of "weavers called Arians". As soon as Henry learned about the mission of Bernard, he escaped the city. Geoffroy then proceeds to describe how Bernard managed to reconvert the remaining heretics in the city.',
    label_and_source_concatenated:
      "wandering preacher Henry the Monk (Gaufridus monachus Clarevallis, epistola Gaufridi ad Archenfredum)",
    case_id: "E1023",
    case_label: "wandering preacher Henry the Monk",
    text_id: "T147",
    text_label: "epistola Gaufridi ad Archenfredum",
    year_start_post_quem: "~1115",
    year_start_ante_quem: "~1115",
    year_end_post_quem: "1148",
    year_end_ante_quem: "1148",
    year_approximate: "y",
    location_id: "L0023 #L0078",
    location_label: "Tolosa #Pise",
    location_primary_id: "L0023 #L0078",
    location_primary_label: "Toulouse #Pisa",
    geometry: "polyline",
    name_of_heresy_id: "C0001",
    name_of_heresy_label: "heresis",
    name_of_heretics_id: "C3468 #C3467",
    name_of_heretics_label: "textores #arriani",
    connotations_heresy_id: "C3464 #C2004 #C2026 #C3470",
    connotations_heresy_label:
      "heretice contagium pravitatis #malitia #pessima vita #multiplices errorum doctrine",
    heretic_id: "P0082 #G0137 #G0125",
    heretic_label:
      "Henricus #textores vocati Arriani [sequatores Henrici] #milites obstinati [sequatores Henrici]",
    heretics_amount_id: "C1174",
    heretics_amount_label: "aliqui/e/a",
    heretics_social_characterization_id: "C3468 #C3469",
    heretics_social_characterization_label: "textores #maximi civitatis",
    instigator_to_heresy_id: null,
    instigator_to_heresy_label: "#VALUE!",
    repressor_id: "P0094 #G0077",
    repressor_label: "Bernardus Clarevallensis #concilium [Pisis congregatum]",
    person_or_groups_other_id: null,
    person_or_groups_other_label: "#VALUE!",
    dealing_with_them_id: "C1852 #C1638 #C1106",
    dealing_with_them_label:
      "incarceration #preaching mission #excommunication",
    outcome_id: "C2272 #C1051",
    outcome_label: "flight #reconversion to Catholicism",
    "Unnamed: 40": null,
    execution_location_type_id: null,
    beliefs_id: "C1067",
    beliefs_label: "not stated by the source",
    practice_id: "[C1360]",
    practice_label: "rejection of clergy",
    note: '"Incarceration" refers to Henry\'s placement in confinement after the synod of Pisa (1135). Geoffroy reports that it was at Clairvaux that Henry was held for some time.',
  },
  E0066: {
    id: "E0066",
    label: "wandering preacher Henry the Monk",
    detail_case_summary:
      'The "Contra Henricum Schismaticum et Hereticum" is a polemical treatise written by Guillelmus Monachi. In six chapters he undertakes a refutation of the successive errors of Henry the heretic. The first three chapters deal with Henry\'s heretical statements directed toward the authority of the clergy; the next chapters deal with lay people: marriage, prayers for the dead, and the baptism of children.',
    label_and_source_concatenated:
      "wandering preacher Henry the Monk (Guillelmus Monachi, Contra Henricum Scismaticum et hereticum)",
    case_id: "E1023",
    case_label: "wandering preacher Henry the Monk",
    text_id: "T134",
    text_label: "Contra Henricum Scismaticum et hereticum",
    year_start_post_quem: "~1115",
    year_start_ante_quem: "~1115",
    year_end_post_quem: "1148",
    year_end_ante_quem: "1148",
    year_approximate: "y",
    location_id: null,
    location_label: "#VALUE!",
    location_primary_id: "#VALUE!",
    location_primary_label: "#VALUE!",
    geometry: "polyline",
    name_of_heresy_id: "C0001 #C2047 #C1715 #[C1592]",
    name_of_heresy_label: "heresis #apostasia #peccatum #schisma",
    name_of_heretics_id: null,
    name_of_heretics_label: "#VALUE!",
    connotations_heresy_id:
      "C1976 #C2048 #C2049 #C2052 #C2053 #C0902 #C1302 #C2054 #C2055 #C2056 #C2058 #C2059 #C2061",
    connotations_heresy_label:
      "impietas #nefanda doctrina #lepra heresi maculatus #contaminatus/a/um #sordidus/a/um #leprosus #immundus/a/um #hereticum venenum #Pelagiana heresis #Vincentii Victoris error #complex Pelagii #patens heresis #manifesta heresis",
    heretic_id: "P0082",
    heretic_label: "Henricus",
    heretics_amount_id: null,
    heretics_amount_label: "#VALUE!",
    heretics_social_characterization_id: "C2023 #C3449",
    heretics_social_characterization_label: "litteratus #quondam monachus",
    instigator_to_heresy_id: null,
    instigator_to_heresy_label: "#VALUE!",
    repressor_id: null,
    repressor_label: "#VALUE!",
    person_or_groups_other_id: null,
    person_or_groups_other_label: "#VALUE!",
    dealing_with_them_id: "C1067",
    dealing_with_them_label: "not stated by the source",
    outcome_id: "C1106",
    outcome_label: "excommunication",
    "Unnamed: 40": null,
    execution_location_type_id: null,
    beliefs_id: "[C2088] #[C2090] #[C1815]",
    beliefs_label:
      "priests do not have the power to bind or loose #children attain salvation if they die unbaptized before the age of understanding #rejection of infant baptism",
    practice_id: "[C2086] #C2087 #[C2089]",
    practice_label:
      "clergy ought not to have any possessions #non est preceptum Evangelii ire ad sacerdotem pro penitentia #marriage can be annulled only in the case of adultery",
    note: null,
  },
  E0067: {
    id: "E0067",
    label: "wandering preacher Henry the Monk",
    detail_case_summary:
      'The anonymous polemical treatise "Contra Hereticos et Schismaticos" is not directed against one particular heretic. The treatise consists of a prologue, twelve chapters, and a conclusion. The chapters deal with the apostolic mission, infant baptism, the eucharist, marriage, and the authority of the clergy.',
    label_and_source_concatenated:
      "wandering preacher Henry the Monk (Contra hereticos et schismaticos)",
    case_id: "E1023",
    case_label: "wandering preacher Henry the Monk",
    text_id: "T135",
    text_label: "Contra hereticos et schismaticos",
    year_start_post_quem: "~1115",
    year_start_ante_quem: "~1115",
    year_end_post_quem: "1148",
    year_end_ante_quem: "1148",
    year_approximate: "y",
    location_id: null,
    location_label: "#VALUE!",
    location_primary_id: null,
    location_primary_label: "#VALUE!",
    geometry: "polyline",
    name_of_heresy_id: "C0001 #[C1592]",
    name_of_heresy_label: "heresis #schisma",
    name_of_heretics_id: null,
    name_of_heretics_label: "#VALUE!",
    connotations_heresy_id:
      "C2062 #C3450 #C2063 #C2064 #C1068 #C2066 #C3524 #C2067 #C2068 #C2072 #C2073 #C2055 #C2057 #C2075 #C1050 #C2076 #C1976 #C1983 #C2049 #C2048 #C1624 #C2077 #C2078 #C2081 #C2082 #C2074 #C2085 #C2084",
    connotations_heresy_label:
      "bestia #cervix presumptuosa #nefaria capitula #nostre fidei contraria capitula #superbia #ridiculosus/a/um #schismaticus #obscuratum cor #insipiens cor #injustitia #falsitas #Pelagiana heresis #Pelagianus/a/um #iniquitates #insania #iniquus/a/um #impietas #furor #lepra heresi maculatus #nefanda doctrina #cancer #furtivus/a/um #labia meretricis #scorpio nequam #minister Antichristi #iniquitas #impius/a/um #pessima doctrina",
    heretic_id: null,
    heretic_label: "#VALUE!",
    heretics_amount_id: null,
    heretics_amount_label: "#VALUE!",
    heretics_social_characterization_id: null,
    heretics_social_characterization_label: "#VALUE!",
    instigator_to_heresy_id: null,
    instigator_to_heresy_label: "#VALUE!",
    repressor_id: null,
    repressor_label: "#VALUE!",
    person_or_groups_other_id: null,
    person_or_groups_other_label: "#VALUE!",
    dealing_with_them_id: "C1067",
    dealing_with_them_label: "not stated by the source",
    outcome_id: "C1067",
    outcome_label: "not stated by the source",
    "Unnamed: 40": null,
    execution_location_type_id: null,
    beliefs_id: "[C2091] #[C2090] #[C1815] #[C2096] #[C2088]",
    beliefs_label:
      "only God ought to be obeyed and not other men #children attain salvation if they die unbaptized before the age of understanding #rejection of infant baptism #Eucharist cannot be consecrated by an unworthy priest #priests do not have the power to bind or loose",
    practice_id:
      "[C2092] #[C2093] #[C1992] #[C2094] #[C2095] #[C2097] #[C1082] #C2087 #[C2086] #[C2098] #[C1152]",
    practice_label:
      "acceptance of the New Testament #rejection of writings of the doctors of the Church #wandering preaching #self-proclamation as preacher #rejection of baptism with chrism and oil #Eucharist can be celebrated at any place #rejection of marriage as sacrament #non est preceptum Evangelii ire ad sacerdotem pro penitentia #clergy ought not to have any possessions #rejection of symbols of episcopal power #rejection of material churches",
    note: "Five chapters (4., 7-10) are taken from Guillelmus Monachi's treatise \"Contra Henricum Schismaticum et Hereticum\", but the absence of the heretic's name and the use of the words heretic and schismatic in the title in plural do not indicate that the treatise was directed against Henry.",
  },
  E0068: {
    id: "E0068",
    label: "wandering preacher Henry the Monk",
    detail_case_summary:
      "In his letter, Hildebert, Bishop of Le Mans, writes about two clerics Cyprian and Peter, who were successfully reconverted from the error of Henry's heresy. The letter is most likely contemporary to the events at Le Mans in 1116.",
    label_and_source_concatenated:
      "wandering preacher Henry the Monk (Hildebertus episcopus Cenomannensis, epistola Hildeberti episcopi Cenomannensis)",
    case_id: "E1023",
    case_label: "wandering preacher Henry the Monk",
    text_id: "T136",
    text_label: "epistola Hildeberti episcopi Cenomannensis",
    year_start_post_quem: "~1115",
    year_start_ante_quem: "~1115",
    year_end_post_quem: "1148",
    year_end_ante_quem: "1148",
    year_approximate: "y",
    location_id: "L0071",
    location_label: "Cenomannum",
    location_primary_id: "L0071",
    location_primary_label: "Le Mans",
    geometry: "polyline",
    name_of_heresy_id: "C0122",
    name_of_heresy_label: "error",
    name_of_heretics_id: null,
    name_of_heretics_label: "#VALUE!",
    connotations_heresy_id:
      "C2099 #C1879 #C2100 #C2102 #C2104 #C1089 #C2112 #C2006 #C2105 #C2107 #C2108 #C2110 #C1584",
    connotations_heresy_label:
      "lacus mortis #pseudopropheta #magnus diaboli laqueus #armiger Antichristi #turpitudo #pestis #tribulationes #serpens #ignominia vite #venenum doctrine #vestimentum seductionis #angelus tenebrarum #infamia",
    heretic_id: "P0082 #P0097 #P0098",
    heretic_label: "Henricus #Cyprianus clericus #Petrus clericus",
    heretics_amount_id: "~V~3",
    heretics_amount_label: "~V~3",
    heretics_social_characterization_id: "C0455",
    heretics_social_characterization_label: "clerici",
    instigator_to_heresy_id: null,
    instigator_to_heresy_label: "#VALUE!",
    repressor_id: null,
    repressor_label: "#VALUE!",
    person_or_groups_other_id: null,
    person_or_groups_other_label: "#VALUE!",
    dealing_with_them_id: "C1067",
    dealing_with_them_label: "not stated by the source",
    outcome_id: "C1051",
    outcome_label: "reconversion to Catholicism",
    "Unnamed: 40": null,
    execution_location_type_id: null,
    beliefs_id: "C1067",
    beliefs_label: "not stated by the source",
    practice_id: "C1067",
    practice_label: "not stated by the source",
    note: null,
  },
  E0069: {
    id: "E0069",
    label: "wandering preacher Henry the Monk",
    detail_case_summary:
      'In the treatise "Contra Petrobrusianos" addressed to the Archbishop of Arles and the Bishops of Die and Gap, Peter the Venerable presents the heretic Henry as a disciple of Peter of Bruis. Peter the Venerable directly attributes only one error to Henry: the rejection of infant baptism.',
    label_and_source_concatenated:
      "wandering preacher Henry the Monk (Petrus Venerabilis, Contra Petrobrusianos)",
    case_id: "E1023",
    case_label: "wandering preacher Henry the Monk",
    text_id: "T137",
    text_label: "Contra Petrobrusianos",
    year_start_post_quem: "~1115",
    year_start_ante_quem: "~1115",
    year_end_post_quem: "1148",
    year_end_ante_quem: "1148",
    year_approximate: "y",
    location_id: null,
    location_label: "#VALUE!",
    location_primary_id: null,
    location_primary_label: "#VALUE!",
    geometry: "polyline",
    name_of_heresy_id: "[C0001] #C0122",
    name_of_heresy_label: "heresis #error",
    name_of_heretics_id: null,
    name_of_heretics_label: "#VALUE!",
    connotations_heresy_id:
      "C1599 #C2145 #C2146 #C2147 #C2148 #C2152 #C2154 #C1734",
    connotations_heresy_label:
      "Antichristus #homuncio #pseudoapostolus #magister errorum #cecus dux cecorum #feces heresium #reliquie schismaticorum #seductor",
    heretic_id: "P0082",
    heretic_label: "Henricus",
    heretics_amount_id: "[C0671]",
    heretics_amount_label: "multi/e/a",
    heretics_social_characterization_id: null,
    heretics_social_characterization_label: "#VALUE!",
    instigator_to_heresy_id: "[P0099]",
    instigator_to_heresy_label: "Petrus de Bruis",
    repressor_id: null,
    repressor_label: "#VALUE!",
    person_or_groups_other_id: null,
    person_or_groups_other_label: "#VALUE!",
    dealing_with_them_id: "C1067",
    dealing_with_them_label: "not stated by the source",
    outcome_id: "C1067",
    outcome_label: "not stated by the source",
    "Unnamed: 40": null,
    execution_location_type_id: null,
    beliefs_id: "[C1815]",
    beliefs_label: "rejection of infant baptism",
    practice_id: "C1067",
    practice_label: "not stated by the source",
    note: null,
  },
  E0072: {
    id: "E0072",
    label: "wandering preacher Henry the Monk",
    detail_case_summary:
      "The letter of Peter the Venerable to the archbishops of Arles and Embrun, and the bishops of Die and Gap, preceding Peter's treatise \"Contra Petrobrusianos\". The letter summarizes in points the errors confessed by Peter of Bruis. The letter introduces the heretic Henry as Peter's heir.",
    label_and_source_concatenated:
      "wandering preacher Henry the Monk (Petrus Venerabilis, epistola Petri Venerabilis (in: Contra Petrobrusianos))",
    case_id: "E1023",
    case_label: "wandering preacher Henry the Monk",
    text_id: "T145",
    text_label: "epistola Petri Venerabilis (in: Contra Petrobrusianos)",
    year_start_post_quem: "~1115",
    year_start_ante_quem: "~1115",
    year_end_post_quem: "1148",
    year_end_ante_quem: "1148",
    year_approximate: "y",
    location_id: null,
    location_label: "#VALUE!",
    location_primary_id: null,
    location_primary_label: "#VALUE!",
    geometry: "polyline",
    name_of_heresy_id: "[C0001]",
    name_of_heresy_label: "heresis",
    name_of_heretics_id: null,
    name_of_heretics_label: "#VALUE!",
    connotations_heresy_id: "C2233\n#C2236\n#C2237\n#C2239\n#C1845",
    connotations_heresy_label:
      "heres nequitie #doctrina diabolica #verba demonica #mortis calix #miser/a/um",
    heretic_id: "P0082",
    heretic_label: "Henricus",
    heretics_amount_id: "[C0671]",
    heretics_amount_label: "multi/e/a",
    heretics_social_characterization_id: "C1067",
    heretics_social_characterization_label: "not stated by the source",
    instigator_to_heresy_id: "[P0099]",
    instigator_to_heresy_label: "Petrus de Bruis",
    repressor_id: null,
    repressor_label: "#VALUE!",
    person_or_groups_other_id: null,
    person_or_groups_other_label: "#VALUE!",
    dealing_with_them_id: "C1067",
    dealing_with_them_label: "not stated by the source",
    outcome_id: "C1067",
    outcome_label: "not stated by the source",
    "Unnamed: 40": null,
    execution_location_type_id: null,
    beliefs_id: "[C0052]",
    beliefs_label: "errores",
    practice_id: "C1067",
    practice_label: "not stated by the source",
    note: "Peter recalls that he had seen some text containing the very teachings of Henry. It is speculated that he had seen the treatise written by Guillelmus Monachi.\n#Peter announces his desire to write a treaty against Henry, but he never wrote one.",
  },
  E0095: {
    id: "E0095",
    label: "wandering preacher Henry the Monk",
    detail_case_summary:
      'Alberic of Trois-Fontaines dedicates a section of his "Chronica" to the heretic Henry, active in Brittany and around Albi. The source conflates two heretics: the wandering preacher Henry and Eudo of Stella. The following work presents selected passages relating to Henry.',
    label_and_source_concatenated:
      "wandering preacher Henry the Monk (Albericus monachus Trium Fontium, Chronica Albrici monachi Trium Fontium, a monacho Novi Monasterii Hoiensis interpolata)",
    case_id: "E1023",
    case_label: "wandering preacher Henry the Monk",
    text_id: "T129",
    text_label:
      "Chronica Albrici monachi Trium Fontium, a monacho Novi Monasterii Hoiensis interpolata",
    year_start_post_quem: "~1115",
    year_start_ante_quem: "~1115",
    year_end_post_quem: "1148",
    year_end_ante_quem: "1148",
    year_approximate: "y",
    location_id: "L0114",
    location_label: "terra Albigensium",
    location_primary_id: "L0113",
    location_primary_label: "Albi",
    geometry: "polyline",
    name_of_heresy_id: "C3208 #C0122",
    name_of_heresy_label: "heresis Popelitanorum #error",
    name_of_heretics_id: null,
    name_of_heretics_label: "#VALUE!",
    connotations_heresy_id: "C3209 #C3206",
    connotations_heresy_label: "apostata pessimus #pestifera heresis",
    heretic_id: "P0082",
    heretic_label: "Henricus",
    heretics_amount_id: "[C1069]",
    heretics_amount_label: "plures/a",
    heretics_social_characterization_id: "C3210",
    heretics_social_characterization_label: "quondam monachus niger",
    instigator_to_heresy_id: "C1067",
    instigator_to_heresy_label: "not stated by the source",
    repressor_id: "P0095 #P0116 #P0094",
    repressor_label:
      "Albericus cardinalis episcopus Ostiensis #Gaufridus episcopus Carnotensis #Bernardus Clarevallensis",
    person_or_groups_other_id: null,
    person_or_groups_other_label: "#VALUE!",
    dealing_with_them_id: "C1638",
    dealing_with_them_label: "preaching mission",
    outcome_id: "C1067",
    outcome_label: "not stated by the source",
    "Unnamed: 40": null,
    execution_location_type_id: null,
    beliefs_id: "C1067",
    beliefs_label: "not stated by the source",
    practice_id: "C1067",
    practice_label: "not stated by the source",
    note: 'The source is a patchwork of other sources ("Verbum abbreviatum", "Balduini Ninoviensis Chronicon", "Sigeberti Continuatio Gemblacensis").\n#Only the passages relating to Henry the Monk are covered in this section; the others relating to Eudo of Stella are in the section devoted to him.',
  },
  E0099: {
    id: "E0099",
    label: "heretics in Aquitaine",
    detail_case_summary:
      "At a synod in Toulouse in 1119, Pope Calixtus II called heretics all people who reject the sacrament of the Eucharist, the baptism of children, and the sacraments of priesthood and marriage. Calixtus excommunicated heretics who professed these errors and all who helped heretics. The region in which the heretics occurred was not given, but most likely it was in the vicinity of Toulouse.",
    label_and_source_concatenated:
      "heretics in Aquitaine (Acta Concilii Tolosani)",
    case_id: "E1032",
    case_label: "heretics in Aquitaine",
    text_id: "T153",
    text_label: "Acta Concilii Tolosani",
    year_start_post_quem: "1119",
    year_start_ante_quem: "1119",
    year_end_post_quem: "1119",
    year_end_ante_quem: "1119",
    year_approximate: "n",
    location_id: "L0023",
    location_label: "Tolosa",
    location_primary_id: "L0023H",
    location_primary_label: "Toulouse",
    geometry: "point with halo",
    name_of_heresy_id: "[C0001]",
    name_of_heresy_label: "heresis",
    name_of_heretics_id: null,
    name_of_heretics_label: "#VALUE!",
    connotations_heresy_id: "C3236",
    connotations_heresy_label: "simulata religio",
    heretic_id: "G0134",
    heretic_label: "heretici [in Aquitania]",
    heretics_amount_id: null,
    heretics_amount_label: "#VALUE!",
    heretics_social_characterization_id: "C1067",
    heretics_social_characterization_label: "not stated by the source",
    instigator_to_heresy_id: "C1067",
    instigator_to_heresy_label: "not stated by the source",
    repressor_id: "P0124",
    repressor_label: "Callistus papa",
    person_or_groups_other_id: null,
    person_or_groups_other_label: "#VALUE!",
    dealing_with_them_id: "C1106",
    dealing_with_them_label: "excommunication",
    outcome_id: "C1067",
    outcome_label: "not stated by the source",
    "Unnamed: 40": null,
    execution_location_type_id: null,
    beliefs_id: "[C1064] #[C1815] #[C1153]",
    beliefs_label:
      "rejection of Eucharist as sacrament #rejection of infant baptism #rejection of ordination",
    practice_id: "[C1082]",
    practice_label: "rejection of marriage as sacrament",
    note: null,
  },
  E0070: {
    id: "E0070",
    label: "Petrobrusians",
    detail_case_summary:
      'In his treatise "Contra Petrobrusianos" addressed to the Archbishop of Arles and the Bishops of Die and Gap, Peter the Venerable undertakes a polemic against the numerous errors of Peter of Bruis: the rejection of infant baptism, of temples, of the cult of the cross, of the eucharist, of prayers for the dead. The Abbot of Cluny accuses the heretic and his followers of extreme anti-clericalism and attacks on churches.',
    label_and_source_concatenated:
      "Petrobrusians (Petrus Venerabilis, Contra Petrobrusianos)",
    case_id: "E1024",
    case_label: "Petrobrusians",
    text_id: "T137",
    text_label: "Contra Petrobrusianos",
    year_start_post_quem: "~1119",
    year_start_ante_quem: "~1119",
    year_end_post_quem: "1139",
    year_end_ante_quem: "1139",
    year_approximate: "y",
    location_id: "L0084 #L0085 #L0092 #L0093 #L0094 #L0086 #L0087",
    location_label:
      "Septimania (provincia Narbonensis) #Alpes Maritime #diocesis Ebreduensis #diocesis Diensis #diocesis Vapicensis #Rodani littora #Tolosensis provincia",
    location_primary_id: "[L0106] #[L0091] #[L0090] #[L0089] #[L0107] #[L0023]",
    location_primary_label: "Narbonne #Embrun #Die #Gap #Lyon #Toulouse",
    geometry: "polyline",
    name_of_heresy_id: "C0001 #C2047 #C0122",
    name_of_heresy_label: "heresis #apostasia #error",
    name_of_heretics_id: null,
    name_of_heretics_label: "#VALUE!",
    connotations_heresy_id:
      "C2113 #C2115 #C2118 #C2119 #C2120 #C1087 #C2122 #C2123 #C2124 #C2125 #C2127 #C2129 #C2131 #C1976 #C0448 #C2134 #C2135 #C1089 #C2062 #C1343 #C1275 #C2138 #C2139 #C2142 #C2143 #C1941 #C1845 #C2144 #C1980 #C1599 #C2145 #C2146 #C2147 #C2148 #C2152 #C2154 #C1734 #C2156 #C1270 #C1239 #C2157 #C2158 #C2159 #C2160 #C2162 #C2165 #C2166 #C2168 #C2169 #C2170 #C2171 #C2172 #C2173 #C2174 #C2175 #C2176 #C1083 #C0543 #C1104 #C2180 #C2181 #C2004 #C1976 #C2182 #C2183 #C2186 #C2189 #C2190 #C2192 #C2194 #C2197 #C2006 #C2200 #C2201 #C2204 #C2205 #C2207 #C2209 #C2211 #C1086 #C2212 #C2074 #C2213 #C1068 #C2214 #C0275 #C2215 #C1635 #C2216 #C2217 #C1874 #C2218 #C2219",
    connotations_heresy_label:
      "inimici fidei Christiane #hostes salutis humane #erroneum dogma #coluber #nefandum guttur #venenum #zizania Diaboli #hostis pertinax #febris #multiformes luporum insidie #devia errorum #baratrum perditionis #peccator #impietas #malum #scelus inauditus #scelus novus #pestis #bestia #erroneus/a/um #nefanda heresis #pertinax error #anguis lubricus #barbaria #falsum dogma #lupus #miser/a/um #vanitas #levitas #Antichristus #homuncio #pseudoapostolus #magister errorum #cecus dux cecorum #feces heresium #reliquie schismaticorum #seductor #spiritus erroris #falsus/a/um #infideles #bruta heresis #impia heresis #stultus/a/um #veritas fallax #negatores scripturarum #heretica perfidia #obstinata perfidia #mendacia #temeritas #hostes Christi #hostes Ecclesie #pernicies #ethnici #publicani #impudens temeritas #imprudens temeritas #nefas #blasphemia #nova heresis #caninum guttur #insidie #malitia #impietas #pertinax malitia #templi Dominis destructores #antiqui erroris novi reparatores #pertinacia #insani dogmatis machina #bestialis heresis #profunda in religionem odia #inaudita divinitatis contumelia #serpens #absurditas #asinina stoliditas #magistri perditionis #inimici crucis #portentuosus sermo #malignus spiritus #stulta pertinacia #nequitia #hostes Dei #iniquitas #nova doctrina #superbia #stultitia #infirmitas #infidelitas #tenebre ignorantie #incredulitas #erroris tenebre #brutus/a/um #erroris machina #luporum rabies",
    heretic_id: "P0099",
    heretic_label: "Petrus de Bruis",
    heretics_amount_id: "C0671",
    heretics_amount_label: "multi/e/a",
    heretics_social_characterization_id: "C2220 #C2221",
    heretics_social_characterization_label: "agrestes #indocti",
    instigator_to_heresy_id: "C1067",
    instigator_to_heresy_label: "not stated by the source",
    repressor_id: "P0100 #P0101 #P0102",
    repressor_label:
      "Willelmus archiepiscopus Ebreduensis #Uldricus episcopus Diensis #Willelmus episcopus Vapicensis",
    person_or_groups_other_id: null,
    person_or_groups_other_label: "#VALUE!",
    dealing_with_them_id: "C1862",
    dealing_with_them_label: "banishment",
    outcome_id: "C1067",
    outcome_label: "not stated by the source",
    "Unnamed: 40": null,
    execution_location_type_id: null,
    beliefs_id: "[C1815] #[C1064] #[C2042] #[C2224]",
    beliefs_label:
      "rejection of infant baptism #rejection of Eucharist as sacrament #rejection of prayers for the salvation of the dead #good deeds are superfluous for salvation of the dead",
    practice_id:
      "[C1995] #[C1054] #[C1167] #[C1994] #[C2093] #[C2222] #[C2223] #[C1152] #[C1309]",
    practice_label:
      "attacks on church buildings #disrespect for cross #rejection of fasting #attacks on clergy #rejection of writings of the doctors of the Church #rejection of the Old Testament #partial acceptance of the Scriptures of the New Testament #rejection of material churches #rejection of ecclesiastical canticles",
    note: null,
  },
  E0071: {
    id: "E0071",
    label: "Petrobrusians",
    detail_case_summary:
      'The letter of Peter the Venerable to the Archbishops of Arles and Embrun, and the Bishops of Die and Gap precedes Peter\'s treatise "Contra Petrobrusianos" and explains the purpose of the treatise. The letter summarizes in points the errors confessed by Peter of Bruis: the rejection of infant baptism, temples, worship of the cross, the eucharist, and prayers for the dead. The letter also describes the death of the heretic at Saint-Gilles.',
    label_and_source_concatenated:
      "Petrobrusians (Petrus Venerabilis, epistola Petri Venerabilis (in: Contra Petrobrusianos))",
    case_id: "E1024",
    case_label: "Petrobrusians",
    text_id: "T145",
    text_label: "epistola Petri Venerabilis (in: Contra Petrobrusianos)",
    year_start_post_quem: "~1119",
    year_start_ante_quem: "~1119",
    year_end_post_quem: "1139",
    year_end_ante_quem: "1139",
    year_approximate: "y",
    location_id: "L0095 #L0092 #L0093 #L0094 #L0084 #L0069 #L0096",
    location_label:
      "diocesis Arelatensis #diocesis Ebreduensis #diocesis Diensis #diocesis Vapicensis #Septimania (provincia Narbonensis) #Gasconia #Villa Sancti Egidii",
    location_primary_id:
      "[L0077] #[L0091] #[L0090] #[L0089] #[L0106] #[L0108] #L0096",
    location_primary_label:
      "Arles #Embrun #Die #Gap #Narbonne #Auch #Saint-Gilles-du-Gard",
    geometry: "polyline",
    name_of_heresy_id: "C0001 #C0122",
    name_of_heresy_label: "heresis #error",
    name_of_heretics_id: null,
    name_of_heretics_label: "#VALUE!",
    connotations_heresy_id:
      "C1155 #C2158 #C1089 #C2225 #C2227 #C0544 #C2228 #C2229 #C2230 #C3490 #C2085 #C1086",
    connotations_heresy_label:
      "stulta heresis #impia heresis #pestis #letale venenum #erroris stultitia #blasphemie #nefandum dogma #erronei dogmatis semina #venenata virgulta #perfidorum impietas #impius/a/um #nequitia",
    heretic_id: "P0099",
    heretic_label: "Petrus de Bruis",
    heretics_amount_id: "C0671",
    heretics_amount_label: "multi/e/a",
    heretics_social_characterization_id: "C1067",
    heretics_social_characterization_label: "not stated by the source",
    instigator_to_heresy_id: "C1067",
    instigator_to_heresy_label: "not stated by the source",
    repressor_id: "P0090 #P0100 #P0101 #P0102 #G0130",
    repressor_label:
      "Guillelmus archiepiscopus Arelatensis #Willelmus archiepiscopus Ebreduensis #Uldricus episcopus Diensis #Willelmus episcopus Vapicensis #fideles qui cremaverunt Petrum",
    person_or_groups_other_id: null,
    person_or_groups_other_label: "#VALUE!",
    dealing_with_them_id: "C1862",
    dealing_with_them_label: "banishment",
    outcome_id: "C2297 #C1063",
    outcome_label: "death by mob lynching #burning",
    "Unnamed: 40": null,
    execution_location_type_id: null,
    beliefs_id: "[C1815] #[C1064] #[C2042] #[C1358] #[C2224]",
    beliefs_label:
      "rejection of infant baptism #rejection of Eucharist as sacrament #rejection of prayers for the salvation of the dead #rejection of almsgiving for the salvation of the dead #good deeds are superfluous for salvation of the dead",
    practice_id: "[C1152] #[C1054]",
    practice_label: "rejection of material churches #disrespect for cross",
    note: null,
  },
  E0077: {
    id: "E0077",
    label: "heretics at Liège",
    detail_case_summary:
      "A letter from the Church of Liège to Pope Lucius II in 1145 describes the heretics discovered in Liège, who also managed to spread throughout France. The heretics had their own church structure, as well as an internal division into auditores, credentes, christiani, sacerdotes, and prelates. Among their errors were such things as rejecting the sacrament of baptism and the Eucharist, not taking oaths, and believing that the Holy Spirit could only be received by good deeds. Some heretics were burned by the mob, but others were saved by canons of Liège and placed in various religious houses awaiting the counsel of Lucius II, who died in the meantime.",
    label_and_source_concatenated:
      "heretics at Liège (epistola ecclesie Leodiensis ad Lucum papam II)",
    case_id: "E1028",
    case_label: "heretics at Liège",
    text_id: "T140",
    text_label: "epistola ecclesie Leodiensis ad Lucum papam II",
    year_start_post_quem: "1135",
    year_start_ante_quem: "1145",
    year_end_post_quem: "1135",
    year_end_ante_quem: "1145",
    year_approximate: "y",
    location_id: "L0036 #L0101 #L0009",
    location_label: "Leodium #Mons Guimari #Galia",
    location_primary_id: "L0036",
    location_primary_label: "Liège",
    geometry: "point",
    name_of_heresy_id: "C0001 #C0122",
    name_of_heresy_label: "heresis #error",
    name_of_heretics_id: null,
    name_of_heretics_label: "#VALUE!",
    connotations_heresy_id:
      "C2267 #C3498 #C3499 #C3520 #C1582 #C1086 #C1333 #C1591",
    connotations_heresy_label:
      "insidie veterum hostium #varia heresis #multiplex heresis #nefande blasphemie #scelus #nequitia #venenum erroris #virus",
    heretic_id: "G0094 #G0095 #G0096 #G0097 #G0098 #P0114",
    heretic_label:
      "auditores [heretici Leodienses] #credentes [heretici Leodienses] #christiani [heretici Leodienses] #sacerdoces [heretici Leodienses] #prelates [heretici Leodienses] #Americus [auditor]",
    heretics_amount_id: "[C1069]",
    heretics_amount_label: "plures/a",
    heretics_social_characterization_id: "C1160 #C1117",
    heretics_social_characterization_label: "simplices #canonici cathedrales",
    instigator_to_heresy_id: "C1067",
    instigator_to_heresy_label: "not stated by the source",
    repressor_id: "G0099 #G0133",
    repressor_label: "populus [cives Leodienses] #canonici Leodienses",
    person_or_groups_other_id: null,
    person_or_groups_other_label: "#VALUE!",
    dealing_with_them_id: "C1266 #C1265",
    dealing_with_them_label: "apprehension #hearing",
    outcome_id: "C2297 #C1063 #C1852",
    outcome_label: "death by mob lynching #burning #incarceration",
    "Unnamed: 40": null,
    execution_location_type_id: null,
    beliefs_id: "[C1061] #[C1064] #[C2269] #[C2880]",
    beliefs_label:
      "rejection of baptism as sacrament #rejection of Eucharist as sacrament #good deeds are enough to receive the Holy Spirit #exclusivistic ecclesiology",
    practice_id: "[C2257] #[C1081] #[C1082] #[C2270] #[C1151]",
    practice_label:
      "internal group structure #rejection of imposition of hands #rejection of marriage as sacrament #rejection of oath #feigned orthodoxy",
    note: 'Only a small proportion of the heretics were burned by the mob. Most were saved by the canons of Liège and distributed to nearby monasteries. The further fate of the heretics is unknown.\n#It has been stated that the "Annales Aquenses" and the "Annales Rodenses" mentioning the existence of some heretics in Liège under the year 1135 may refer to the same event as described in the 1145 letter of the Church of Liège. The common treatment of the three sources as referring to a single event is due to their coincidence of place and time.',
  },
  E0078: {
    id: "E0078",
    label: "heretics at Liège",
    detail_case_summary:
      'The "Annales Aquenses" mention in one sentence under 1135 certain heretics, one of whom was condemned to the stake at the synod of Liège.',
    label_and_source_concatenated: "heretics at Liège (Annales Aquenses)",
    case_id: "E1028",
    case_label: "heretics at Liège",
    text_id: "T141",
    text_label: "Annales Aquenses",
    year_start_post_quem: "1135",
    year_start_ante_quem: "1145",
    year_end_post_quem: "1135",
    year_end_ante_quem: "1145",
    year_approximate: "y",
    location_id: "L0036",
    location_label: "Leodium",
    location_primary_id: "L0036",
    location_primary_label: "Liège",
    geometry: "point",
    name_of_heresy_id: "[C0001]",
    name_of_heresy_label: "heresis",
    name_of_heretics_id: null,
    name_of_heretics_label: "#VALUE!",
    connotations_heresy_id: null,
    connotations_heresy_label: "#VALUE!",
    heretic_id: "G0100",
    heretic_label: "[heretici Leodienses]",
    heretics_amount_id: "[C1174]",
    heretics_amount_label: "aliqui/e/a",
    heretics_social_characterization_id: "C1067",
    heretics_social_characterization_label: "not stated by the source",
    instigator_to_heresy_id: "C1067",
    instigator_to_heresy_label: "not stated by the source",
    repressor_id: "G0101",
    repressor_label: "concilium [Leodii congregatum]",
    person_or_groups_other_id: null,
    person_or_groups_other_label: "#VALUE!",
    dealing_with_them_id: "C1266",
    dealing_with_them_label: "apprehension",
    outcome_id: "C1063",
    outcome_label: "burning",
    "Unnamed: 40": null,
    execution_location_type_id: null,
    beliefs_id: "C1067",
    beliefs_label: "not stated by the source",
    practice_id: "C1067",
    practice_label: "not stated by the source",
    note: 'It has been stated that the "Annales Aquenses" and the "Annales Rodenses" mentioning the existence of some heretics in Liège under the year 1135 may refer to the same event as described in the 1145 letter of the Church of Liège. The common treatment of the three sources as referring to a single event is due to their coincidence of place and time.',
  },
  E0079: {
    id: "E0079",
    label: "heretics at Liège",
    detail_case_summary:
      'The "Annales Rodenses" mention under 1135 the capture of heretics in Liège. The heretics did not recognize the sacrament of marriage and were opposed to infant baptism and prayers for the dead. The people of Liege wanted to lapidate them, but some of the heretics escaped, others were converted to the Catholic faith, and only one heretic was burned.',
    label_and_source_concatenated: "heretics at Liège (Annales Rodenses)",
    case_id: "E1028",
    case_label: "heretics at Liège",
    text_id: "T142",
    text_label: "Annales Rodenses",
    year_start_post_quem: "1135",
    year_start_ante_quem: "1145",
    year_end_post_quem: "1135",
    year_end_ante_quem: "1145",
    year_approximate: "y",
    location_id: "L0036",
    location_label: "Leodium",
    location_primary_id: "L0036",
    location_primary_label: "Liège",
    geometry: "point",
    name_of_heresy_id: "[C0001] #C0122",
    name_of_heresy_label: "heresis #error",
    name_of_heretics_id: null,
    name_of_heretics_label: "#VALUE!",
    connotations_heresy_id: null,
    connotations_heresy_label: "#VALUE!",
    heretic_id: "G0100",
    heretic_label: "[heretici Leodienses]",
    heretics_amount_id: "[C1174]",
    heretics_amount_label: "aliqui/e/a",
    heretics_social_characterization_id: "C1067",
    heretics_social_characterization_label: "not stated by the source",
    instigator_to_heresy_id: "C1067",
    instigator_to_heresy_label: "not stated by the source",
    repressor_id: "G0099",
    repressor_label: "populus [cives Leodienses]",
    person_or_groups_other_id: null,
    person_or_groups_other_label: "#VALUE!",
    dealing_with_them_id: "C1266 #C2298",
    dealing_with_them_label: "apprehension #attempted mob lynching",
    outcome_id: "C2272 #C1063 #C1051",
    outcome_label: "flight #burning #reconversion to Catholicism",
    "Unnamed: 40": null,
    execution_location_type_id: null,
    beliefs_id: "[C1815] #[C2042]",
    beliefs_label:
      "rejection of infant baptism #rejection of prayers for the salvation of the dead",
    practice_id: "[C1151] #[C1993] #[C1082] #[C2273]",
    practice_label:
      "feigned orthodoxy #feigned piety #rejection of marriage as sacrament #communia feminarum",
    note: 'The source mentions enigmatically the heretics\' recognition of "communia feminarum", most likely referring to the sharing of women by men, as heretics were also credited with the rejection of the sacrament of marriage.\n#It has been stated that the "Annales Aquenses" and the "Annales Rodenses" mentioning the existence of some heretics in Liège under the year 1135 may refer to the same event as described in the 1145 letter of the Church of Liège. The common treatment of the three sources as referring to a single event is due to their coincidence of place and time.',
  },
  E0073: {
    id: "E0073",
    label: "Arnoldists",
    detail_case_summary:
      'In the "Historia Pontificalis", under the year 1149, John of Salisbury describes the heretic Arnold of Brescia as one of the perpetrators of the riots in Rome. Arnold of Brescia was once a clergyman but had left the Church and begun preaching anti-clerical sermons. John of Salisbury reports Arnold\'s stay in Paris, during which he was a disciple of Peter Abelard and preached his doctrines to the students gathered at Sainte-Geneviève.',
    label_and_source_concatenated:
      "Arnoldists (Joannes Saresberiensis, Historia Pontificalis)",
    case_id: "E1025",
    case_label: "Arnoldists",
    text_id: "T138",
    text_label: "Historia Pontificalis",
    year_start_post_quem: "1137",
    year_start_ante_quem: "1139",
    year_end_post_quem: "1155",
    year_end_ante_quem: "1155",
    year_approximate: "y",
    location_id: "L0097 #L0098 #L0120 #L0122 #L0121 #L0042 #L0123",
    location_label:
      "Brixia #Parisis #mons sancte Genovefe #ecclesia Sancti Hylarii Parisis #Viterbium #Roma #Capitolium",
    location_primary_id: "L0042",
    location_primary_label: "Roma",
    geometry: "point",
    name_of_heresy_id: "C1592 #C1262 #C3492",
    name_of_heresy_label: "schisma #secta #heresis Lumbardorum",
    name_of_heretics_id: null,
    name_of_heretics_label: "#VALUE!",
    connotations_heresy_id: "C3493",
    connotations_heresy_label: "seditiosus/a/um",
    heretic_id: "P0103 #G0131 #G0085 #[G0084] #G0132",
    heretic_label:
      "Arnaldus Brixensis #cives Brixenses #auditores pauperes [scholares Parisenses] #sectatores Arnaldi [populus Romanus] #religiose femine [sectatores Arnaldi]",
    heretics_amount_id: "[C0671]",
    heretics_amount_label: "multi/e/a",
    heretics_social_characterization_id: "C2254 #C1248 #C3495 #[C1075]",
    heretics_social_characterization_label:
      "canonicus regularis #abbas #scolares #laici",
    instigator_to_heresy_id: "C1067",
    instigator_to_heresy_label: "not stated by the source",
    repressor_id: "P0091 #P0094 #P0112 #P0071",
    repressor_label:
      "Innocentius papa #Bernardus Clarevallensis #Ludovicus rex Francorum #Eugenius papa",
    person_or_groups_other_id: "P0107 #P0106 #P0111",
    person_or_groups_other_label:
      "Manfredus episcopus Brixensis #Petrus Abelardus #dominus Hyacinthus",
    dealing_with_them_id: "C1106 #C1097 #C1862",
    dealing_with_them_label: "excommunication #degradation #banishment",
    outcome_id: "C1051 #C1569",
    outcome_label: "reconversion to Catholicism #relapse into heresy",
    "Unnamed: 40": null,
    execution_location_type_id: null,
    beliefs_id: "C1067",
    beliefs_label: "not stated by the source",
    practice_id: "[C1992] #[C1993] #[C1251]",
    practice_label:
      "wandering preaching #feigned piety #rejection of the Roman Church",
    note: "Viterbo is not the actual place of Arnold’s activity. It is the location of the synod at which Arnold seemingly returned to the orthodoxy, after being banished from the Kingdom of France.\n#John of Salisbury relates that Arnold was banished two times, firstly from Brescia and then from the Kingdom of France.",
  },
  E0074: {
    id: "E0074",
    label: "Arnoldists",
    detail_case_summary:
      'Otto of Freising in his "Gesta Friderici" mentions Arnold of Brescia twice: in a brief mention under 1147 and a longer passage under 1155. Arnold was a former priest. He preached anticlerical sermons and spread republican ideas in Rome. He was excommunicated at the Lateran Council II, then was a disciple of Peter Abelard in Paris and taught in Zurich. Upon his return to Italy, he was eventually burned at the stake and his body thrown into the Tiber River.',
    label_and_source_concatenated:
      "Arnoldists (Otto Frisigensis, Gesta Friderici seu rectius Cronica)",
    case_id: "E1025",
    case_label: "Arnoldists",
    text_id: "T126",
    text_label: "Gesta Friderici seu rectius Cronica",
    year_start_post_quem: "1137",
    year_start_ante_quem: "1139",
    year_end_post_quem: "1155",
    year_end_ante_quem: "1155",
    year_approximate: "y",
    location_id: "L0042 #L0097 #L0100 #L0099",
    location_label: "Roma #Brixia #Turegum #Tuscia",
    location_primary_id: "L0042",
    location_primary_label: "Roma",
    geometry: "point",
    name_of_heresy_id: null,
    name_of_heresy_label: "#VALUE!",
    name_of_heretics_id: null,
    name_of_heretics_label: "#VALUE!",
    connotations_heresy_id:
      "C2169 #C2241 #C3496 #C2243 #C2244 #C2248 #C2249 #C2252 #C2253 #C0448",
    connotations_heresy_label:
      "temeritas #sub ovina pelle lupus #premolle dogma #singularitatis amator #novitatis cupidus #clericorum et episcoporum derogator #monachorum persecutor #perniciosum dogma #venenosum dogma #malum",
    heretic_id: "P0103 #[G0083]",
    heretic_label: "Arnaldus Brixensis #[sequatores Arnaldi]",
    heretics_amount_id: "C0671",
    heretics_amount_label: "multi/e/a",
    heretics_social_characterization_id: "[C1354] #C0454 #C3420",
    heretics_social_characterization_label: "vulgus #clericus #lector",
    instigator_to_heresy_id: "C1067",
    instigator_to_heresy_label: "not stated by the source",
    repressor_id: "P0107 #P0091 #G0082 #P0108 #P0109 #P0110",
    repressor_label:
      "Manfredus episcopus Brixensis #Innocentius papa #concilium [Rome congregatum] #quidam vir [qui Arnaldum cepit] #Gwelfo princeps, marchio Tuscie #Petrus prefectus Rome",
    person_or_groups_other_id: "P0104 #P0105 #P0106 #P0071",
    person_or_groups_other_label:
      "Fridericus rex Romanorum #Hadrianus papa #Petrus Abelardus #Eugenius papa",
    dealing_with_them_id: "C1048 #C1862 #C1266",
    dealing_with_them_label: "public debate #banishment #apprehension",
    outcome_id: "C1063",
    outcome_label: "burning",
    "Unnamed: 40": null,
    execution_location_type_id: null,
    beliefs_id: "[C1064] #[C1815]",
    beliefs_label:
      "rejection of Eucharist as sacrament #rejection of infant baptism",
    practice_id: "[C2086] #[C1994]",
    practice_label:
      "clergy ought not to have any possessions #attacks on clergy",
    note: "Even if Otto mentions that Arnold was for some time a student of Peter Abelard, he doesn't provide any further specific information about this moment of Arnold's career.\n#The metaphor of the false prophet being like a wolf in sheep's clothing was taken from the Gospel of Matthew (Matt. 7:15).\n#The Roman Synod under Innocent II, during which Arnold was first convicted, was Lateran II.",
  },
  E0075: {
    id: "E0075",
    label: "ascetic heretics at Cologne",
    detail_case_summary:
      "Evervin of Steinfeld, in his letter to Bernard of Clairvaux, written in 1143 or 1144, describes two groups of heretics recently discovered near Cologne. The first group of heretics characterized itself by asceticism. Some of the heretics reconverted, but those who did not were burned by mob lynching and happily accepted martyrdom. The heretics practiced their own eucharist and rejected the sacrament of marriage and baptism by water. They had an internal division between electi, credentes, and auditores, and had their own pope. The heretics admitted that many of them were scattered in different lands. They believed that they were the ones who represented the true apostolic Church living in secrecy for years.",
    label_and_source_concatenated:
      "ascetic heretics at Cologne (Evervinus Steinfeldensis, epistola Evervini Steinfeldensis ad S. Bernardum Clarevallem)",
    case_id: "E1026",
    case_label: "ascetic heretics at Cologne",
    text_id: "T139",
    text_label: "epistola Evervini Steinfeldensis ad S. Bernardum Clarevallem",
    year_start_post_quem: "1143",
    year_start_ante_quem: "1144",
    year_end_post_quem: "1143",
    year_end_ante_quem: "1144",
    year_approximate: "y",
    location_id: "L0053 #L0047",
    location_label: "Colonia #Gretia",
    location_primary_id: "L0053",
    location_primary_label: "Köln",
    geometry: "point",
    name_of_heresy_id: "C0001",
    name_of_heresy_label: "heresis",
    name_of_heretics_id: null,
    name_of_heretics_label: "#VALUE!",
    connotations_heresy_id: "[C1104] #C3521 #C0448 #C2261 #C2262 #C2263",
    connotations_heresy_label:
      "nova heresis #diaboli membra #malum #feri/e/a #monstra #apostolici Satane",
    heretic_id: "P0120 #P0121 #G0089 #G0090 #G0091 #P0122 #G0093",
    heretic_label:
      "episcopus hereticorum #socio episcopi #electi [ascetici heretici Colonienses] #auditores [ascetici heretici Colonienses] #credentes [ascetici heretici Colonienses] #papa hereticorum #femine continentes",
    heretics_amount_id: "C0671",
    heretics_amount_label: "multi/e/a",
    heretics_social_characterization_id: "C0455 #C1078 #[C1075]",
    heretics_social_characterization_label: "clerici #monachi #laici",
    instigator_to_heresy_id: "C1067",
    instigator_to_heresy_label: "not stated by the source",
    repressor_id: "P0113 #G0087 #G0088",
    repressor_label:
      "Arnoldus archiepiscopus Colonensis #conventus clericorum et laicorum [congregatus Colonie] #populus [qui hereticos Colonienses interfecit]",
    person_or_groups_other_id: "C1067",
    person_or_groups_other_label: "not stated by the source",
    dealing_with_them_id: "C1048",
    dealing_with_them_label: "public debate",
    outcome_id: "C1051 #C2297 #C1063",
    outcome_label:
      "reconversion to Catholicism #death by mob lynching #burning",
    "Unnamed: 40": null,
    execution_location_type_id: null,
    beliefs_id: "[C2880] #[C1061]",
    beliefs_label:
      "exclusivistic ecclesiology #rejection of baptism as sacrament",
    practice_id:
      "[C2325] #[C2324] #[C2092] #[C2330] #C0800 #[C2255] #[C1062] #[C1255] #[C2284] #[C1817] #[C3517] #[C1242] #[C2257] #[C1082] #[C2322] #[C1251]",
    practice_label:
      "heretical bishops #alternative Church ministers #acceptance of the New Testament #undergoing martyrdom #vita apostolica #voluntary poverty #fasting #constant prayers #importance of manual labor #avoidance of food originating from coition #heretical Eucharist consecration #imposition of hands #internal group structure #rejection of marriage as sacrament #heretical pope #rejection of the Roman Church",
    note: 'The source states that heretics consecrated the Eucharist by reciting the Lord\'s Prayer.\n#Heretics considered water baptism insufficient and recognized the validity only of baptism performed by the imposition of hands. They supported their arguments with the New Testament.\n#Everwin points out that heretics did not give a reason for rejecting the sacrament of marriage.\n#Apart from the internal division into "electi", "credentes" and "auditores", heretics also had their bishops. The heretical bishop of Cologne also had his assistant. At the top of the hierarchy was a person whom Evervin calls "papa".\n#Greece was one of the places where heretics were to survive in hiding, carrying out their activities in this way for many years.\n#The source says that women had active roles in the group of heretics, also belonging to "electi" and "credentes".\n#The heretics called themselves apostles.',
  },
  E0098: {
    id: "E0098",
    label: "ascetic heretics at Cologne",
    detail_case_summary:
      'The "Annales Brunwilarenses" mention in brief certain heretics discovered in Cologne. Some of them were subjected to the ordeal of water and others took flight but were soon caught in Bonn and put to death by burning.',
    label_and_source_concatenated:
      "ascetic heretics at Cologne (Annales Brunwilarenses)",
    case_id: "E1026",
    case_label: "ascetic heretics at Cologne",
    text_id: "T149",
    text_label: "Annales Brunwilarenses",
    year_start_post_quem: "1143",
    year_start_ante_quem: "1144",
    year_end_post_quem: "1143",
    year_end_ante_quem: "1144",
    year_approximate: "y",
    location_id: "L0053 #L0124",
    location_label: "Colonia #Verona",
    location_primary_id: "L0053",
    location_primary_label: "Köln",
    geometry: "point",
    name_of_heresy_id: "C0001",
    name_of_heresy_label: "heresis",
    name_of_heretics_id: null,
    name_of_heretics_label: "#VALUE!",
    connotations_heresy_id: null,
    connotations_heresy_label: "#VALUE!",
    heretic_id: null,
    heretic_label: "#VALUE!",
    heretics_amount_id: "C1069",
    heretics_amount_label: "plures/a",
    heretics_social_characterization_id: "C1067",
    heretics_social_characterization_label: "not stated by the source",
    instigator_to_heresy_id: "C1067",
    instigator_to_heresy_label: "not stated by the source",
    repressor_id: "P0113 #P0123",
    repressor_label: "Arnoldus archiepiscopus Colonensis #Otto comes de Rineke",
    person_or_groups_other_id: "C1067",
    person_or_groups_other_label: "not stated by the source",
    dealing_with_them_id: "C1266 #C1813",
    dealing_with_them_label: "apprehension #trial by water",
    outcome_id: "C2272 #C1063",
    outcome_label: "flight #burning",
    "Unnamed: 40": null,
    execution_location_type_id: null,
    beliefs_id: "C1067",
    beliefs_label: "not stated by the source",
    practice_id: "[C2330]",
    practice_label: "undergoing martyrdom",
    note: 'The heretics were killed at "Verona", which is the Latin name for Bonn.',
  },
  E0076: {
    id: "E0076",
    label: "evangelical heretics at Cologne",
    detail_case_summary:
      "Evervin of Steinfeld, in his letter to Bernard of Clairvaux, written in 1143 or 1144, describes two groups of heretics recently discovered near Cologne. The second group put great importance on evangelical precepts and rejected Catholic Tradition. The heretics held an unorthodox view on the sacrament of marriage and baptism, did not believe in the intercession of saints or Purgatory, and rejected the sacrament of Eucharist.",
    label_and_source_concatenated:
      "evangelical heretics at Cologne (Evervinus Steinfeldensis, epistola Evervini Steinfeldensis ad S. Bernardum Clarevallem)",
    case_id: "E1027",
    case_label: "donatist heretics at Cologne",
    text_id: "T139",
    text_label: "epistola Evervini Steinfeldensis ad S. Bernardum Clarevallem",
    year_start_post_quem: "1143",
    year_start_ante_quem: "1144",
    year_end_post_quem: "1143",
    year_end_ante_quem: "1144",
    year_approximate: "y",
    location_id: "L0053",
    location_label: "Colonia",
    location_primary_id: "L0053",
    location_primary_label: "Köln",
    geometry: "point",
    name_of_heresy_id: "C0001",
    name_of_heresy_label: "heresis",
    name_of_heretics_id: null,
    name_of_heretics_label: "#VALUE!",
    connotations_heresy_id: "[C1104] #C0448 #C2261 #C2262",
    connotations_heresy_label: "nova heresis #malum #feri/e/a #monstra",
    heretic_id: "G0086",
    heretic_label: "heretici Colonienses",
    heretics_amount_id: "[C1069]",
    heretics_amount_label: "plures/a",
    heretics_social_characterization_id: "C1067",
    heretics_social_characterization_label: "not stated by the source",
    instigator_to_heresy_id: "C1067",
    instigator_to_heresy_label: "not stated by the source",
    repressor_id: null,
    repressor_label: "#VALUE!",
    person_or_groups_other_id: null,
    person_or_groups_other_label: "#VALUE!",
    dealing_with_them_id: "C1067",
    dealing_with_them_label: "not stated by the source",
    outcome_id: "C1067",
    outcome_label: "not stated by the source",
    "Unnamed: 40": null,
    execution_location_type_id: null,
    beliefs_id: "[C1064] #[C1153] #[C1113] #[C1815] #[C2260] #[C2042] #[C2224]",
    beliefs_label:
      "rejection of Eucharist as sacrament #rejection of ordination #rejection of sacraments #rejection of infant baptism #disbelief in the existence of Purgatory #rejection of prayers for the salvation of the dead #good deeds are superfluous for salvation of the dead",
    practice_id:
      "[C1251] #[C2258] #[C1100] #[C2423] #[C2259] #[C2422] #[C2256]",
    practice_label:
      "rejection of the Roman Church #marriage can only be contracted between virgins #rejection of cult of saints #attitude limiting the salvatory effect of fasting #rejection of mortification #rejection of mainstream Christian cultic practices #acceptance of the Old and the New Testament",
    note: 'Heretics did not recognize the baptism of infants because, on the basis of the gospel words "qui crediderit et baptizatus fuerit, salvus erit" (Mark 16:16), they recognized that one can only be baptized in one\'s name, consciously and with faith.',
  },
  E0050: {
    id: "E0050",
    label: "eccentric heretic Eudo of Stella",
    detail_case_summary:
      'In the anonymous "Sigiberti Continuatio Gemblacensis" under the years 1146 and 1148, the author described the case of the Breton heretic Eudo, whose followers he calls eonites. Eudo is portrayed as an uneducated idiot who set up his own church structures and declared himself a son of God. During the synod of Rheims, he was sentenced to imprisonment, where he died shortly thereafter.',
    label_and_source_concatenated:
      "eccentric heretic Eudo of Stella (Sigeberti Continuatio Gemblacensis)",
    case_id: "E1022",
    case_label: "eccentric heretic Eudo of Stella",
    text_id: "T118",
    text_label: "Sigeberti Continuatio Gemblacensis",
    year_start_post_quem: "~1145",
    year_start_ante_quem: "~1145",
    year_end_post_quem: "1148",
    year_end_ante_quem: "1148",
    year_approximate: "y",
    location_id: "L0064 #L0065",
    location_label: "Britannia minor #Remi",
    location_primary_id: "L0065",
    location_primary_label: "Reims",
    geometry: "polyline",
    name_of_heresy_id: "C0001 #C0122",
    name_of_heresy_label: "heresis #error",
    name_of_heretics_id: "C1819",
    name_of_heretics_label: "Eunite",
    connotations_heresy_id: "C1820 #C1822 #C1324 #C1827 #C1829 #C1050 #C1832",
    connotations_heresy_label:
      "perversa mens #os pollutum #nefarius/a/um #subversio perditorum #diabolico spiritu completus/a/um #insania #perversa heresis",
    heretic_id: "P0070 #G0057",
    heretic_label: "Eudo de Stella #Eunite",
    heretics_amount_id: null,
    heretics_amount_label: "#VALUE!",
    heretics_social_characterization_id: "C3207",
    heretics_social_characterization_label: "idiota",
    instigator_to_heresy_id: "C1067",
    instigator_to_heresy_label: "not stated by the source",
    repressor_id: "P0071 #P0072",
    repressor_label: "Eugenius papa #quidam catholicus Brittanie episcopus",
    person_or_groups_other_id: "G0058",
    person_or_groups_other_label: "synodum generale [Remis congregatum]",
    dealing_with_them_id: "C1266 #C1048",
    dealing_with_them_label: "apprehension #public debate",
    outcome_id: "C1740",
    outcome_label: "death of a heretic",
    "Unnamed: 40": null,
    execution_location_type_id: null,
    beliefs_id: "[C1623] #[C0052]",
    beliefs_label: "heresiarch's self-deification #errores",
    practice_id: "[C3205] #[C2325] #[C3246]",
    practice_label:
      "heretical Mass celebration #heretical bishops #odious practices",
    note: 'The actual spelling of the heretic\'s name in the source is Eunus.\n#Eudo was portrayed as an unlettered idiot thinking that the words "per eundem Dominum nostrum" spoken by the celebrant referred to him.',
  },
  E0061: {
    id: "E0061",
    label: "eccentric heretic Eudo of Stella",
    detail_case_summary:
      'Alberic of Trois-Fontaines dedicates a section of his "Chronica" to the heretic Henry active in Brittany and around Albi. The source conflates two heretics: the wandering preacher Henry and Eudo of Stella. The following work presents selected passages relating to Eudo of Stella. The author situates the heresy in 1148.',
    label_and_source_concatenated:
      "eccentric heretic Eudo of Stella (Albericus monachus Trium Fontium, Chronica Albrici monachi Trium Fontium, a monacho Novi Monasterii Hoiensis interpolata)",
    case_id: "E1022",
    case_label: "eccentric heretic Eudo of Stella",
    text_id: "T129",
    text_label:
      "Chronica Albrici monachi Trium Fontium, a monacho Novi Monasterii Hoiensis interpolata",
    year_start_post_quem: "~1145",
    year_start_ante_quem: "~1145",
    year_end_post_quem: "1148",
    year_end_ante_quem: "1148",
    year_approximate: "y",
    location_id: "L0064 #L0065",
    location_label: "Britannia minor #Remi",
    location_primary_id: "L0065",
    location_primary_label: "Reims",
    geometry: "polyline",
    name_of_heresy_id: "C0001 #C0122",
    name_of_heresy_label: "heresis #error",
    name_of_heretics_id: "C1819",
    name_of_heretics_label: "Eunite",
    connotations_heresy_id: "C1822 #C1324 #C1827 #C1829 #C1050",
    connotations_heresy_label:
      "os pollutum #nefarius/a/um #subversio perditorum #diabolico spiritu completus/a/um #insania",
    heretic_id: "[P0082]",
    heretic_label: "Henricus",
    heretics_amount_id: "[C1069]",
    heretics_amount_label: "plures/a",
    heretics_social_characterization_id: "C3207",
    heretics_social_characterization_label: "idiota",
    instigator_to_heresy_id: "C1067",
    instigator_to_heresy_label: "not stated by the source",
    repressor_id: "P0071 #P0073",
    repressor_label: "Eugenius papa #Samson archiepiscopus Remensis",
    person_or_groups_other_id: "G0064 #G0105",
    person_or_groups_other_label:
      "synodum [Remis congregatum] #mille centum archiepiscopi, episcopi et abbates [in synodo Remensi congregati]",
    dealing_with_them_id: "C1266 #C1048",
    dealing_with_them_label: "apprehension #public debate",
    outcome_id: "C1852 #C1740",
    outcome_label: "incarceration #death of a heretic",
    "Unnamed: 40": null,
    execution_location_type_id: null,
    beliefs_id: "[C1623] #[C0052]",
    beliefs_label: "heresiarch's self-deification #errores",
    practice_id: "[C2325] #[C3246]",
    practice_label: "heretical bishops #odious practices",
    note: 'The source is a patchwork of other sources ("Verbum abbreviatum", "Balduini Ninoviensis Chronicon", "Sigeberti Continuatio Gemblacensis").\n#Only the passages relating to Eudo are covered in this section; the others relating to the wandering preacher Henry the Monk are in the section devoted to him.',
  },
  E0049: {
    id: "E0049",
    label: "eccentric heretic Eudo of Stella",
    detail_case_summary:
      'In chapter XIX (Book I) of the "Historia Rerum Anglicarum", William of Newburgh describes the case of the heretic Eudo, who was sentenced to prison at the synod of Rheims, where he died shortly thereafter. Eudo is portrayed by William as an uneducated idiot using diabolical tricks, who surrounds himself with disciples with unusual names such as Sapientia, Scientia, and Judicium.',
    label_and_source_concatenated:
      "eccentric heretic Eudo of Stella (Willelmus Neuburgensis, Historia Rerum Anglicarum)",
    case_id: "E1022",
    case_label: "eccentric heretic Eudo of Stella",
    text_id: "T119",
    text_label: "Historia Rerum Anglicarum",
    year_start_post_quem: "~1145",
    year_start_ante_quem: "~1145",
    year_end_post_quem: "1148",
    year_end_ante_quem: "1148",
    year_approximate: "y",
    location_id: "L0065 #[L0064]",
    location_label: "Remi #Britannia minor",
    location_primary_id: "L0065",
    location_primary_label: "Reims",
    geometry: "polyline",
    name_of_heresy_id: "C0122 #C1262",
    name_of_heresy_label: "error #secta",
    name_of_heretics_id: null,
    name_of_heretics_label: "#VALUE!",
    connotations_heresy_id:
      "C1631 #C1833 #C1835 #C2004 #C1836 #C1867 #C1838 #C1840 #C1842 #C1845 #C1631 #C1846 #C1847 #C1089",
    connotations_heresy_label:
      "pestifer/a/um #spiritu plenus diabolico #prestigialis astutia #malitia #dementatus/a/um #fatuus/a/um #stupenda cecitas #diabolicum prestigium #fantastica gloria #miser/a/um #pestifer/a/um #nefanda secta #stolidus/a/um #pestis",
    heretic_id: "P0070 #G0062 #G0063 #P0077 #P0078 #P0079",
    heretic_label:
      "Eudo de Stella #populus [sequatores Eudonis] #discipuli Eudonis #Sapientia [discipulus Eudonis] #Scientia [discipulus Eudonis] #Judicium [discipulus Eudonis]",
    heretics_amount_id: "C0671",
    heretics_amount_label: "multi/e/a",
    heretics_social_characterization_id: "C3431 #C3207 #C1160",
    heretics_social_characterization_label: "illiteratus/a #idiota #simplices",
    instigator_to_heresy_id: "C1067",
    instigator_to_heresy_label: "not stated by the source",
    repressor_id: "P0071 #G0059 #P0073 #G0060 #G0061",
    repressor_label:
      "Eugenius papa #concilium generale [episcopi et abbates Remis congregati] #Samson archiepiscopus Remensis #exercitus ad vestigandum et persequendum Eudonem missus #principes qui exercituum ad vestigandum et persequendum Eudonem mittebant",
    person_or_groups_other_id: "P0074 #P0075 #P0076 #P0080",
    person_or_groups_other_label:
      "quidam miles [propinquus Eudonis] #armiger militis [propinqui Eudonis] #demon in accipitrem transformatus #quidam venerabilis vir [qui interfuit dum heretici ignibus traditi fuerunt]",
    dealing_with_them_id: "C1266 #C1048 #C1852",
    dealing_with_them_label: "apprehension #public debate #incarceration",
    outcome_id: "C1852 #C1740 #C1063",
    outcome_label: "incarceration #death of a heretic #burning",
    "Unnamed: 40": null,
    execution_location_type_id: null,
    beliefs_id: "[C1623]",
    beliefs_label: "heresiarch's self-deification",
    practice_id: "[C1995]",
    practice_label: "attacks on church buildings",
    note: 'The source does not mention Brittany as the place of Eudo\'s activity but mentions that he was active in different areas ("diversa loca", "diverse provincie") and originated from Brittany. Thus, it can be assumed that one of his main areas of activity was Brittany.\n#Eudo died in prison shortly after his arrest. His disciples Sapientia, Scientia and Judicium, were sentenced to death by burning, because they refused to repudiate the heresy.\n#Eudo was portrayed as an unlettered idiot thinking that the words "per Eum qui venturus est judicare vivos et mortuos, et seculum per ignem" spoken by the celebrant referred to him. Eudo also had a special stick with one split end. Eudo explained to the synod that if the forked part is facing the sky, then God has two-thirds of the world in His possession and Eudo one-third, when Eudo turns the double end to the earth the situation is reversed and then Eudo possesses two-thirds of the world and God the remaining one-third.\n#William of Newburgh relays that Eudo had the gift of producing wonderful dishes from nothing. However, these were only devilish tricks. The author goes on to relay a story about a demon in the shape of a hawk, which Eudo once gave to a certain squire. The squire was then abducted by the devilish hawk and no one ever saw him again.',
  },
  E0051: {
    id: "E0051",
    label: "eccentric heretic Eudo of Stella",
    detail_case_summary:
      'In the "Annales Parchenses" there is a brief mention under 1149 of a synod at Rheims during which the heretic Eudo was convicted and imprisoned in the "porta Martis", where he died the same year.',
    label_and_source_concatenated:
      "eccentric heretic Eudo of Stella (Annales Parchenses)",
    case_id: "E1022",
    case_label: "eccentric heretic Eudo of Stella",
    text_id: "T120",
    text_label: "Annales Parchenses",
    year_start_post_quem: "~1145",
    year_start_ante_quem: "~1145",
    year_end_post_quem: "1148",
    year_end_ante_quem: "1148",
    year_approximate: "y",
    location_id: "L0065 #[L0064]",
    location_label: "Remi #Britannia minor",
    location_primary_id: "L0065",
    location_primary_label: "Reims",
    geometry: "polyline",
    name_of_heresy_id: "[C0001]",
    name_of_heresy_label: "heresis",
    name_of_heretics_id: null,
    name_of_heretics_label: "#VALUE!",
    connotations_heresy_id: null,
    connotations_heresy_label: "#VALUE!",
    heretic_id: "[P0070]",
    heretic_label: "Eudo de Stella",
    heretics_amount_id: "~V~1",
    heretics_amount_label: "~V~1",
    heretics_social_characterization_id: "C1067",
    heretics_social_characterization_label: "not stated by the source",
    instigator_to_heresy_id: "C1067",
    instigator_to_heresy_label: "not stated by the source",
    repressor_id: "P0071 #G0064",
    repressor_label: "Eugenius papa #synodum [Remis congregatum]",
    person_or_groups_other_id: null,
    person_or_groups_other_label: "#VALUE!",
    dealing_with_them_id: "C1067",
    dealing_with_them_label: "not stated by the source",
    outcome_id: "C1106 #C1852 #C1740",
    outcome_label: "excommunication #incarceration #death of a heretic",
    "Unnamed: 40": null,
    execution_location_type_id: null,
    beliefs_id: "C1067",
    beliefs_label: "not stated by the source",
    practice_id: "C1067",
    practice_label: "not stated by the source",
    note: "The actual spelling of the heretic's name in the source is Eys.\n#The source does not mention Brittany as the place of Eudo's activity but mentions that he originated from Brittany.\n#The source dates the synod of Rheims at 1149.",
  },
  E0052: {
    id: "E0052",
    label: "eccentric heretic Eudo of Stella",
    detail_case_summary:
      'In the "Annales Cameracenses" there is a brief reference under 1148 to a synod at Rheims at which the heretic Eudo was condemned.',
    label_and_source_concatenated:
      "eccentric heretic Eudo of Stella (Annales Cameracenses)",
    case_id: "E1022",
    case_label: "eccentric heretic Eudo of Stella",
    text_id: "T121",
    text_label: "Annales Cameracenses",
    year_start_post_quem: "~1145",
    year_start_ante_quem: "~1145",
    year_end_post_quem: "1148",
    year_end_ante_quem: "1148",
    year_approximate: "y",
    location_id: "L0065 #[L0064]",
    location_label: "Remi #Britannia minor",
    location_primary_id: "L0065",
    location_primary_label: "Reims",
    geometry: "polyline",
    name_of_heresy_id: "[C0001]",
    name_of_heresy_label: "heresis",
    name_of_heretics_id: null,
    name_of_heretics_label: "#VALUE!",
    connotations_heresy_id: null,
    connotations_heresy_label: "#VALUE!",
    heretic_id: "[P0070]",
    heretic_label: "Eudo de Stella",
    heretics_amount_id: "~V~1",
    heretics_amount_label: "~V~1",
    heretics_social_characterization_id: null,
    heretics_social_characterization_label: "#VALUE!",
    instigator_to_heresy_id: "C1067",
    instigator_to_heresy_label: "not stated by the source",
    repressor_id: "P0071 #G0059",
    repressor_label:
      "Eugenius papa #concilium generale [episcopi et abbates Remis congregati]",
    person_or_groups_other_id: null,
    person_or_groups_other_label: "#VALUE!",
    dealing_with_them_id: "C1067",
    dealing_with_them_label: "not stated by the source",
    outcome_id: "C1106",
    outcome_label: "excommunication",
    "Unnamed: 40": null,
    execution_location_type_id: null,
    beliefs_id: "C1067",
    beliefs_label: "not stated by the source",
    practice_id: "C1067",
    practice_label: "not stated by the source",
    note: "The actual spelling of the heretic's name in the source is Eons.\n#The source does not mention Brittany as the place of Eudo's activity but mentions that he originated from Brittany.",
  },
  E0053: {
    id: "E0053",
    label: "eccentric heretic Eudo of Stella",
    detail_case_summary:
      "In a brief description, the \"Chronicon Britannicum\" situates Eudo's activities in the year 1145. The source includes information about Eudo's self-deification and attacks on hermitages. Brittany is presented as the area of activity of the heretics, and Eudo himself is said to have come from Loudéac.",
    label_and_source_concatenated:
      "eccentric heretic Eudo of Stella (Chronicon Britannicum)",
    case_id: "E1022",
    case_label: "eccentric heretic Eudo of Stella",
    text_id: "T122",
    text_label: "Chronicon Britannicum",
    year_start_post_quem: "~1145",
    year_start_ante_quem: "~1145",
    year_end_post_quem: "1148",
    year_end_ante_quem: "1148",
    year_approximate: "y",
    location_id: "L0066 #L0068 #L0067",
    location_label: "Befrelien foresta #episcopatus Aletensis #Lodiacum",
    location_primary_id: "L0105 #L0067",
    location_primary_label: "Aleth #Loudéac",
    geometry: "polyline",
    name_of_heresy_id: "C0001",
    name_of_heresy_label: "heresis",
    name_of_heretics_id: null,
    name_of_heretics_label: "#VALUE!",
    connotations_heresy_id: null,
    connotations_heresy_label: "#VALUE!",
    heretic_id: "[P0070] #G0065",
    heretic_label: "Eudo de Stella #sequaces Eudonis",
    heretics_amount_id: "C0671",
    heretics_amount_label: "multi/e/a",
    heretics_social_characterization_id: null,
    heretics_social_characterization_label: "#VALUE!",
    instigator_to_heresy_id: "C1067",
    instigator_to_heresy_label: "not stated by the source",
    repressor_id: "C1067",
    repressor_label: "not stated by the source",
    person_or_groups_other_id: null,
    person_or_groups_other_label: "#VALUE!",
    dealing_with_them_id: "C1067",
    dealing_with_them_label: "not stated by the source",
    outcome_id: "C1067",
    outcome_label: "not stated by the source",
    "Unnamed: 40": null,
    execution_location_type_id: null,
    beliefs_id: "[C0052] #[C1623]",
    beliefs_label: "errores #heresiarch's self-deification",
    practice_id: "[C1995]",
    practice_label: "attacks on church buildings",
    note: "The actual spelling of the heretic's name in the source is \"Eudo de pago Lodiacense\".\n#The description of Eudo's heresy is preceded by information about the appearance of a comet in the sky.",
  },
  E0054: {
    id: "E0054",
    label: "eccentric heretic Eudo of Stella",
    detail_case_summary:
      'In the "Verbum abbreviatum", Peter Cantor gives information about the synod of Rheims in 1148, which sentenced a certain unnamed Manichaean to prison, where he died shortly thereafter.',
    label_and_source_concatenated:
      "eccentric heretic Eudo of Stella (Petrus Cantor, Verbum abbreviatum)",
    case_id: "E1022",
    case_label: "eccentric heretic Eudo of Stella",
    text_id: "T123",
    text_label: "Verbum abbreviatum",
    year_start_post_quem: "~1145",
    year_start_ante_quem: "~1145",
    year_end_post_quem: "1148",
    year_end_ante_quem: "1148",
    year_approximate: "y",
    location_id: "L0065",
    location_label: "Remi",
    location_primary_id: "L0065",
    location_primary_label: "Reims",
    geometry: "polyline",
    name_of_heresy_id: "C0001",
    name_of_heresy_label: "heresis",
    name_of_heretics_id: "C1872",
    name_of_heretics_label: "manicheus",
    connotations_heresy_id: null,
    connotations_heresy_label: "#VALUE!",
    heretic_id: "[P0070]",
    heretic_label: "Eudo de Stella",
    heretics_amount_id: "~V~1",
    heretics_amount_label: "~V~1",
    heretics_social_characterization_id: "C1067",
    heretics_social_characterization_label: "not stated by the source",
    instigator_to_heresy_id: "C1067",
    instigator_to_heresy_label: "not stated by the source",
    repressor_id: "P0071 #G0066 #P0073",
    repressor_label:
      "Eugenius papa #concilium [Remis congregatum] #Samson archiepiscopus Remensis",
    person_or_groups_other_id: null,
    person_or_groups_other_label: "#VALUE!",
    dealing_with_them_id: "[C1048]",
    dealing_with_them_label: "public debate",
    outcome_id: "C1323 #C1852 #C1740",
    outcome_label:
      "abjuration of heretical errors #incarceration #death of a heretic",
    "Unnamed: 40": null,
    execution_location_type_id: null,
    beliefs_id: "C1067",
    beliefs_label: "not stated by the source",
    practice_id: "C1067",
    practice_label: "not stated by the source",
    note: null,
  },
  E0055: {
    id: "E0055",
    label: "eccentric heretic Eudo of Stella",
    detail_case_summary:
      'In the "Verbum abbreviatum textus alter", Peter Cantor gives information about the 1148 synod of Rheims that sentenced a Breton heretic Eudo to prison, where he died shortly thereafter.',
    label_and_source_concatenated:
      "eccentric heretic Eudo of Stella (Petrus Cantor, Verbum abbreviatum textus alter)",
    case_id: "E1022",
    case_label: "eccentric heretic Eudo of Stella",
    text_id: "T124",
    text_label: "Verbum abbreviatum textus alter",
    year_start_post_quem: "~1145",
    year_start_ante_quem: "~1145",
    year_end_post_quem: "1148",
    year_end_ante_quem: "1148",
    year_approximate: "y",
    location_id: "L0065 #[L0064]",
    location_label: "Remi #Britannia minor",
    location_primary_id: "L0065",
    location_primary_label: "Reims",
    geometry: "polyline",
    name_of_heresy_id: "C0001",
    name_of_heresy_label: "heresis",
    name_of_heretics_id: null,
    name_of_heretics_label: "#VALUE!",
    connotations_heresy_id: "C1873 #C1874",
    connotations_heresy_label: "fatua heresis #brutus/a/um",
    heretic_id: "[P0070]",
    heretic_label: "Eudo de Stella",
    heretics_amount_id: "~V~1",
    heretics_amount_label: "~V~1",
    heretics_social_characterization_id: "C1067",
    heretics_social_characterization_label: "not stated by the source",
    instigator_to_heresy_id: "C1067",
    instigator_to_heresy_label: "not stated by the source",
    repressor_id: "P0071 #G0066 #P0073",
    repressor_label:
      "Eugenius papa #concilium [Remis congregatum] #Samson archiepiscopus Remensis",
    person_or_groups_other_id: "G0067\n#G0068\n#G0069\n#G0070",
    person_or_groups_other_label:
      "cardinales [Remis congregati] #archiepiscopi [Remis congregati] #episcopi [Remis congregati] #viri litterati [Remis congregati]",
    dealing_with_them_id: "[C1048]",
    dealing_with_them_label: "public debate",
    outcome_id: "C1852 #C1740",
    outcome_label: "incarceration #death of a heretic",
    "Unnamed: 40": null,
    execution_location_type_id: null,
    beliefs_id: "[C1623] #[C0052]",
    beliefs_label: "heresiarch's self-deification #errores",
    practice_id: "C1067",
    practice_label: "not stated by the source",
    note: 'The source does not mention Brittany as the place of Eudo\'s activity but mentions that he originated from Brittany.\n#The actual spelling of the heretic\'s name in the source is "Evus de Steila".\n#Cantor relays that Eudo "dicebat se illum Eum, qui vivit et regnat in secula".',
  },
  E0056: {
    id: "E0056",
    label: "eccentric heretic Eudo of Stella",
    detail_case_summary:
      'The "Annales Magdeburgenses" contain information about the activity of the heretic Eudo in Gascony (sic!). The Annales state that Eudo declared himself a God and launched attacks on churches. He was sentenced to exile at the synod of Rheims in 1148.',
    label_and_source_concatenated:
      "eccentric heretic Eudo of Stella (Annales Magdeburgenses)",
    case_id: "E1022",
    case_label: "eccentric heretic Eudo of Stella",
    text_id: "T125",
    text_label: "Annales Magdeburgenses",
    year_start_post_quem: "~1145",
    year_start_ante_quem: "~1145",
    year_end_post_quem: "1148",
    year_end_ante_quem: "1148",
    year_approximate: "y",
    location_id: "L0065 #L0069",
    location_label: "Remi #Gasconia",
    location_primary_id: "L0065",
    location_primary_label: "Reims",
    geometry: "polyline",
    name_of_heresy_id: "C0122",
    name_of_heresy_label: "error",
    name_of_heretics_id: null,
    name_of_heretics_label: "#VALUE!",
    connotations_heresy_id: "C1861",
    connotations_heresy_label: "spiritus pravi erroris",
    heretic_id: "[P0070]",
    heretic_label: "Eudo de Stella",
    heretics_amount_id: "[C1069]",
    heretics_amount_label: "plures/a",
    heretics_social_characterization_id: "[C1160]",
    heretics_social_characterization_label: "simplices",
    instigator_to_heresy_id: "C1067",
    instigator_to_heresy_label: "not stated by the source",
    repressor_id: "P0071 #G0066",
    repressor_label: "Eugenius papa #concilium [Remis congregatum]",
    person_or_groups_other_id: null,
    person_or_groups_other_label: "#VALUE!",
    dealing_with_them_id: "C1048",
    dealing_with_them_label: "public debate",
    outcome_id: "C1323 #C1852 #C1862",
    outcome_label: "abjuration of heretical errors #incarceration #banishment",
    "Unnamed: 40": null,
    execution_location_type_id: null,
    beliefs_id: "[C1623]",
    beliefs_label: "heresiarch's self-deification",
    practice_id: "[C1995]",
    practice_label: "attacks on church buildings",
    note: "The actual spelling of the heretic's name in the source is Eus.\n#The social characterization of Eudo’s followers (“simplices”) has been determined based on the passage “gens illa stultissima”.",
  },
  E0057: {
    id: "E0057",
    label: "eccentric heretic Eudo of Stella",
    detail_case_summary:
      'In the first book of the "Gesta Friderici" Otto of Freising describes a synod held in 1148 in Rheims. The synod dealt with the case of the heretic Eudo, whose activities were located in Brittany and Gascony. The source gives information about Eudo\'s self-deification. The heretic was handed over to Suger, abbot of Saint-Denis. He was subsequently imprisoned and died shortly thereafter.',
    label_and_source_concatenated:
      "eccentric heretic Eudo of Stella (Otto Frisigensis, Gesta Friderici seu rectius Cronica)",
    case_id: "E1022",
    case_label: "eccentric heretic Eudo of Stella",
    text_id: "T126",
    text_label: "Gesta Friderici seu rectius Cronica",
    year_start_post_quem: "~1145",
    year_start_ante_quem: "~1145",
    year_end_post_quem: "1148",
    year_end_ante_quem: "1148",
    year_approximate: "y",
    location_id: "L0065 #L0069 #L0064",
    location_label: "Remi #Gasconia #Britannia minor",
    location_primary_id: "L0065",
    location_primary_label: "Reims",
    geometry: "polyline",
    name_of_heresy_id: "C0122",
    name_of_heresy_label: "error",
    name_of_heretics_id: null,
    name_of_heretics_label: "#VALUE!",
    connotations_heresy_id: "C1863 #C1869 #C1866",
    connotations_heresy_label:
      "heretici nominis indignus #contumax fatuitas #fatua contumacia",
    heretic_id: "[P0070] #G0062",
    heretic_label: "Eudo de Stella #populus [sequatores Eudonis]",
    heretics_amount_id: "C0671",
    heretics_amount_label: "multi/e/a",
    heretics_social_characterization_id: "[C1160] #C1285 #C3431",
    heretics_social_characterization_label:
      "simplices #rusticus #illiteratus/a",
    instigator_to_heresy_id: "C1067",
    instigator_to_heresy_label: "not stated by the source",
    repressor_id: "P0071 #G0122 #P0081",
    repressor_label:
      "Eugenius papa #concilium generale [Remis congregatum] #Sugerius abbas S. Dionysii",
    person_or_groups_other_id: null,
    person_or_groups_other_label: "#VALUE!",
    dealing_with_them_id: "C1266 #C1048",
    dealing_with_them_label: "apprehension #public debate",
    outcome_id: "C1852 #C1740",
    outcome_label: "incarceration #death of a heretic",
    "Unnamed: 40": null,
    execution_location_type_id: null,
    beliefs_id: "[C1623]",
    beliefs_label: "heresiarch's self-deification",
    practice_id: "C1067",
    practice_label: "not stated by the source",
    note: 'The actual spelling of the heretic\'s name in the source is Eum.\n#Otto of Freising relays that Eudo identified himself with the scriptural "per Eum".',
  },
  E0058: {
    id: "E0058",
    label: "eccentric heretic Eudo of Stella",
    detail_case_summary:
      'In the "Sigeberti Gemblacensis Continuatio Premonstratensis" under 1148, the heretic Eudo is portrayed as a freak who believes he is the chosen one. At the synod of Rheims, he is sentenced to prison, where he dies shortly thereafter.',
    label_and_source_concatenated:
      "eccentric heretic Eudo of Stella (Sigeberti Gemblacensis Continuatio Premonstratensis)",
    case_id: "E1022",
    case_label: "eccentric heretic Eudo of Stella",
    text_id: "T114",
    text_label: "Sigeberti Gemblacensis Continuatio Premonstratensis",
    year_start_post_quem: "~1145",
    year_start_ante_quem: "~1145",
    year_end_post_quem: "1148",
    year_end_ante_quem: "1148",
    year_approximate: "y",
    location_id: "L0065 #L0064",
    location_label: "Remi #Britannia minor",
    location_primary_id: "L0065",
    location_primary_label: "Reims",
    geometry: "polyline",
    name_of_heresy_id: "[C0001]",
    name_of_heresy_label: "heresis",
    name_of_heretics_id: null,
    name_of_heretics_label: "#VALUE!",
    connotations_heresy_id: null,
    connotations_heresy_label: "#VALUE!",
    heretic_id: "[P0070] #G0123",
    heretic_label: "Eudo de Stella #apostoli vel angeli [sequatores Eudonis]",
    heretics_amount_id: "[C1069]",
    heretics_amount_label: "plures/a",
    heretics_social_characterization_id: "C1067",
    heretics_social_characterization_label: "not stated by the source",
    instigator_to_heresy_id: "C1067",
    instigator_to_heresy_label: "not stated by the source",
    repressor_id: "P0071 #G0066 #P0073",
    repressor_label:
      "Eugenius papa #concilium [Remis congregatum] #Samson archiepiscopus Remensis",
    person_or_groups_other_id: null,
    person_or_groups_other_label: "#VALUE!",
    dealing_with_them_id: null,
    dealing_with_them_label: "#VALUE!",
    outcome_id: "C1106 #C1852 #C1740",
    outcome_label: "excommunication #incarceration #death of a heretic",
    "Unnamed: 40": null,
    execution_location_type_id: null,
    beliefs_id: "[C1623]",
    beliefs_label: "heresiarch's self-deification",
    practice_id: "[C2325]",
    practice_label: "heretical bishops",
    note: 'The actual spelling of the heretic\'s name in the source is Eon.\n#Eudo was said to believe that the words "per Eum qui venturus est judicare vivos et mortuos, et seculum per ignem" spoken by the celebrant referred to him.',
  },
  E0059: {
    id: "E0059",
    label: "eccentric heretic Eudo of Stella",
    detail_case_summary:
      "In the \"Annales Casinenses\" there is a brief mention under 1148 of a synod in Rheims at which the heretic Eudo was sentenced to life imprisonment. The source mentions Eudo's self-deification. Spain (sic!) is given as the heretic's area of activity.",
    label_and_source_concatenated:
      "eccentric heretic Eudo of Stella (Annales Casinenses)",
    case_id: "E1022",
    case_label: "eccentric heretic Eudo of Stella",
    text_id: "T127",
    text_label: "Annales Casinenses",
    year_start_post_quem: "~1145",
    year_start_ante_quem: "~1145",
    year_end_post_quem: "1148",
    year_end_ante_quem: "1148",
    year_approximate: "y",
    location_id: "L0065 #L0030",
    location_label: "Remi #Hispania",
    location_primary_id: "L0065",
    location_primary_label: "Reims",
    geometry: "polyline",
    name_of_heresy_id: "[C0001]",
    name_of_heresy_label: "heresis",
    name_of_heretics_id: null,
    name_of_heretics_label: "#VALUE!",
    connotations_heresy_id: null,
    connotations_heresy_label: "#VALUE!",
    heretic_id: "[P0070]",
    heretic_label: "Eudo de Stella",
    heretics_amount_id: "~V~1",
    heretics_amount_label: "~V~1",
    heretics_social_characterization_id: "C1067",
    heretics_social_characterization_label: "not stated by the source",
    instigator_to_heresy_id: "C1067",
    instigator_to_heresy_label: "not stated by the source",
    repressor_id: "P0071 #G0066",
    repressor_label: "Eugenius papa #concilium [Remis congregatum]",
    person_or_groups_other_id: null,
    person_or_groups_other_label: "#VALUE!",
    dealing_with_them_id: null,
    dealing_with_them_label: "#VALUE!",
    outcome_id: "C1852",
    outcome_label: "incarceration",
    "Unnamed: 40": null,
    execution_location_type_id: null,
    beliefs_id: "[C1623]",
    beliefs_label: "heresiarch's self-deification",
    practice_id: "C1067",
    practice_label: "not stated by the source",
    note: "The actual spelling of the heretic's name in the source is Eum.",
  },
  E0060: {
    id: "E0060",
    label: "eccentric heretic Eudo of Stella",
    detail_case_summary:
      'In the "Chronicon" of Balduin of Ninove, the author mentions the heretic Eudo under the years 1146 and 1147. Eudo was portrayed as an illiterate heretic active in Brittany. Eudo was said to celebrate masses and appoint his own bishops. He was put in prison after the synod of Rheims, where he soon died.',
    label_and_source_concatenated:
      "eccentric heretic Eudo of Stella (Balduinus Ninovensis, Balduini Ninovensis Chronicon)",
    case_id: "E1022",
    case_label: "eccentric heretic Eudo of Stella",
    text_id: "T128",
    text_label: "Balduini Ninovensis Chronicon",
    year_start_post_quem: "~1145",
    year_start_ante_quem: "~1145",
    year_end_post_quem: "1148",
    year_end_ante_quem: "1148",
    year_approximate: "y",
    location_id: "L0065 #L0064",
    location_label: "Remi #Britannia minor",
    location_primary_id: "L0065",
    location_primary_label: "Reims",
    geometry: "polyline",
    name_of_heresy_id: "C0001",
    name_of_heresy_label: "heresis",
    name_of_heretics_id: null,
    name_of_heretics_label: "#VALUE!",
    connotations_heresy_id: null,
    connotations_heresy_label: "#VALUE!",
    heretic_id: "[P0070] #G0057",
    heretic_label: "Eudo de Stella #Eunite",
    heretics_amount_id: "[C1069]",
    heretics_amount_label: "plures/a",
    heretics_social_characterization_id: "C3207",
    heretics_social_characterization_label: "idiota",
    instigator_to_heresy_id: "C1067",
    instigator_to_heresy_label: "not stated by the source",
    repressor_id: "P0071 #G0066 #G0106",
    repressor_label:
      "Eugenius papa #concilium [Remis congregatum] #mille centum episcopi vel abbates [in concilio Remensi congregati]",
    person_or_groups_other_id: null,
    person_or_groups_other_label: "#VALUE!",
    dealing_with_them_id: null,
    dealing_with_them_label: "#VALUE!",
    outcome_id: "C1852 #C1740",
    outcome_label: "incarceration #death of a heretic",
    "Unnamed: 40": null,
    execution_location_type_id: null,
    beliefs_id: "C1067",
    beliefs_label: "not stated by the source",
    practice_id: "[C3205] #[C2325]",
    practice_label: "heretical Mass celebration #heretical bishops",
    note: "The actual spelling of the heretic's name in the source is Euno.",
  },
  E0062: {
    id: "E0062",
    label: "eccentric heretic Eudo of Stella",
    detail_case_summary:
      'In Robert de Monte\'s "Cronica" there is a brief mention under the year 1148 of a synod at Rheims, during which the heretic Eudo was placed in the prison of the archbishop [of Reims], where he died shortly afterwards.',
    label_and_source_concatenated:
      "eccentric heretic Eudo of Stella (Robertus de Monte, Roberti de Monte Cronica)",
    case_id: "E1022",
    case_label: "eccentric heretic Eudo of Stella",
    text_id: "T130",
    text_label: "Roberti de Monte Cronica",
    year_start_post_quem: "~1145",
    year_start_ante_quem: "~1145",
    year_end_post_quem: "1148",
    year_end_ante_quem: "1148",
    year_approximate: "y",
    location_id: "L0065",
    location_label: "Remi",
    location_primary_id: "L0065",
    location_primary_label: "Reims",
    geometry: "polyline",
    name_of_heresy_id: "[C0001]",
    name_of_heresy_label: "heresis",
    name_of_heretics_id: null,
    name_of_heretics_label: "#VALUE!",
    connotations_heresy_id: "C1879",
    connotations_heresy_label: "pseudopropheta",
    heretic_id: "[P0070]",
    heretic_label: "Eudo de Stella",
    heretics_amount_id: "~V~1",
    heretics_amount_label: "~V~1",
    heretics_social_characterization_id: "C1067",
    heretics_social_characterization_label: "not stated by the source",
    instigator_to_heresy_id: "C1067",
    instigator_to_heresy_label: "not stated by the source",
    repressor_id: "G0066 #P0073",
    repressor_label:
      "concilium [Remis congregatum] #Samson archiepiscopus Remensis",
    person_or_groups_other_id: null,
    person_or_groups_other_label: "#VALUE!",
    dealing_with_them_id: null,
    dealing_with_them_label: "#VALUE!",
    outcome_id: "C1852 #C1740",
    outcome_label: "incarceration #death of a heretic",
    "Unnamed: 40": null,
    execution_location_type_id: null,
    beliefs_id: "C1067",
    beliefs_label: "not stated by the source",
    practice_id: "C1067",
    practice_label: "not stated by the source",
    note: "The actual spelling of the heretic's name in the source is Eudo.\n#The source doesn't mention the name of the archbishop, but we can assume that it talks about the archbishop of the city where the synod took place.",
  },
  E0100: {
    id: "E0100",
    label: "weavers at Toulouse",
    detail_case_summary:
      'Geoffroy of Auxerre, in a letter to Archenfroy and the Clairvaux brothers, describes the deeds that Bernard of Clairvaux accomplished during his mission to Aquitaine and Languedoc. In Toulouse, Bernard encountered heretics of unspecified doctrine. Geoffroy writes rather puzzlingly about them, calling them "weavers called Arians". As soon as they learned about the preaching mission of Bernard, they escaped the city.',
    label_and_source_concatenated:
      "weavers at Toulouse (Gaufridus monachus Clarevallis, epistola Gaufridi ad Archenfredum)",
    case_id: "E1033",
    case_label: "weavers at Toulouse",
    text_id: "T147",
    text_label: "epistola Gaufridi ad Archenfredum",
    year_start_post_quem: "1145",
    year_start_ante_quem: "1145",
    year_end_post_quem: "1145",
    year_end_ante_quem: "1145",
    year_approximate: "y",
    location_id: "L0023",
    location_label: "Tolosa",
    location_primary_id: "L0023",
    location_primary_label: "Toulouse",
    geometry: "point",
    name_of_heresy_id: "[C0001]",
    name_of_heresy_label: "heresis",
    name_of_heretics_id: "C3468 #C3467",
    name_of_heretics_label: "textores #arriani",
    connotations_heresy_id: "C3464",
    connotations_heresy_label: "heretice contagium pravitatis",
    heretic_id: "G0136 #G0126 #P0125 #P0126",
    heretic_label:
      "textores vocati Arriani #maximi Tolosane urbis [sequatores textorum] #unus e ditioribus Tolose #uxor ditis Tolosanis",
    heretics_amount_id: "C1069",
    heretics_amount_label: "plures/a",
    heretics_social_characterization_id: "C3468 #C3469",
    heretics_social_characterization_label: "textores #maximi civitatis",
    instigator_to_heresy_id: "C1067",
    instigator_to_heresy_label: "not stated by the source",
    repressor_id: "P0094",
    repressor_label: "Bernardus Clarevallensis",
    person_or_groups_other_id: "P0127",
    person_or_groups_other_label: "filius ditis Tolosanis",
    dealing_with_them_id: "C1067",
    dealing_with_them_label: "not stated by the source",
    outcome_id: "C2272",
    outcome_label: "flight",
    "Unnamed: 40": null,
    execution_location_type_id: null,
    beliefs_id: "C1067",
    beliefs_label: "not stated by the source",
    practice_id: "C1067",
    practice_label: "not stated by the source",
    note: null,
  },
  E0097: {
    id: "E0097",
    label: "manicheans at Agen",
    detail_case_summary:
      'In the "Commentaria in epistolas Pauli" concerning a fragment of the First Epistle to Timothy about the heretics that would appear at the end of time, the monk Herveus of Bordeaux mentions the heretics of Agen who had similar practices to the heretics mentioned by Saint Paul.',
    label_and_source_concatenated:
      "manicheans at Agen (Herveus Burdigolensis monachus, Commentaria in epistolas Pauli)",
    case_id: "E1031",
    case_label: "manicheans at Agen",
    text_id: "T148",
    text_label: "Commentaria in epistolas Pauli",
    year_start_post_quem: "~1150",
    year_start_ante_quem: "~1150",
    year_end_post_quem: "~1150",
    year_end_ante_quem: "~1150",
    year_approximate: "y",
    location_id: "L0119",
    location_label: "Aginnum",
    location_primary_id: "L0119",
    location_primary_label: "Agen",
    geometry: "point",
    name_of_heresy_id: "[C0001] #C0122",
    name_of_heresy_label: "heresis #error",
    name_of_heretics_id: null,
    name_of_heretics_label: "#VALUE!",
    connotations_heresy_id:
      "C3480 #C2156 #C2209 #C3481 #C3448 #C3236 #C3482 #C3483 #C3484 #C3485",
    connotations_heresy_label:
      "prava dogmata #spiritus erroris #malignus spiritus #doctrine demoniorum #in hypocrisi loquens mendacium #simulata religio #conscientia corrupta #conscientia putrefacta #putredo #fetor",
    heretic_id: "G0127 #G0129",
    heretic_label:
      "Agimnenses heretici #heresiarchi Agimnensium hereticorum [homines demones habentes]",
    heretics_amount_id: "[C1174]",
    heretics_amount_label: "aliqui/e/a",
    heretics_social_characterization_id: "C1067",
    heretics_social_characterization_label: "not stated by the source",
    instigator_to_heresy_id: "C1067",
    instigator_to_heresy_label: "not stated by the source",
    repressor_id: "C1067",
    repressor_label: "not stated by the source",
    person_or_groups_other_id: "G0128",
    person_or_groups_other_label: "demones in equorum specie",
    dealing_with_them_id: "C1067",
    dealing_with_them_label: "not stated by the source",
    outcome_id: "C1067",
    outcome_label: "not stated by the source",
    "Unnamed: 40": null,
    execution_location_type_id: null,
    beliefs_id: "C1067",
    beliefs_label: "not stated by the source",
    practice_id: "[C1993] #[C1082] #[C1817]",
    practice_label:
      "feigned piety #rejection of marriage as sacrament #avoidance of food originating from coition",
    note: 'Herveus recalls that horse-shaped demons appeared to heretics to carry them wherever they wished.\n#Herveus does not call heretics Manichaeans but likens their practices to those of the Manichaeans.\n#When writing about heresiarchs and demonic men ("homines demonium habentes"), Herveus was probably referring to the same group of heretics.',
  },
};

export default mentions;
